import { DecimalPipe, DOCUMENT } from '@angular/common';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { isEqual, orderBy } from 'lodash';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../common/pipes/currency-format.pipe';
import { TitleCasePipe } from '../../common/pipes/title-case.pipe';
import { MemberActivityLogType } from '../../shared/common/enumerations';
import { Language } from '../../shared/components/ILanguage';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { AddressVisibility } from '../../shared/interface/address-visibility';
import { Country } from '../../shared/interface/country.interface';
import { DisplayPriceConfig } from '../../shared/interface/display-price-config.interface';
import { Member } from '../../shared/interface/member.interface';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { EnrollmentCommonService } from '../../shared/services/enrollment-common.service';
import { AddressService } from '../services/address.service';
import { MemberDisplayPriceConfigService } from '../../shared/services/member-display-price-config.service';
import { MessageService } from '../../shared/services/message.service';
import { CustomValidators } from '../../shared/Utils/custom-validator';
import { Utils } from '../../shared/Utils/utils';
import { Constants, DelivaryOptionType, IsoCodeThree, PCSponsorConstants } from '../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, PromotionActionType, PromotionOrderType } from '../common/enumerations';
import { DateConstants } from '../constants/date.constants';
import { MemberTypeId } from '../constants/member-type-id.enum';
import { PaymentMethodTypeConstants } from '../constants/payment-method-types.constants';
import { PaymentConstants } from '../constants/payment.constants';
import { PhoneCodesConstants } from '../constants/phone-codes.constant';
import { PortalDisplayPage } from '../constants/portal-display-page.enum';
import { PromotionConstants } from '../constants/promotion.constants';
import { Translations } from '../constants/translations.constants';
import { EcheckPhoneNumberValidation } from '../directive/echeck-phone-validation';
import { DiscountType } from '../enums/discount-type.enum';
import { DisplaySectionId, DocumentLibraryMemberId, Portal } from '../enums/document-library-member-id.enum';
import { AccountType } from '../enums/echeck-accounttypes.enum';
import { EcheckPortalTypes } from '../enums/echeck-portal-types.enum';
import { ImageType } from '../enums/image-type.enum';
import { MemberOrderType } from '../enums/member-order-type.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MessageTypeEnum } from '../enums/message-type.enums';
import { NotificationType } from '../enums/notification-types.enum';
import {
    OrderSourceType,AddressType,
    OrderStatus, PaymentMethodTypes, PaymentType,PurchaseFlows,
    PurchaseFlowType, ShippingOrderType, ShippingType, PromotionsTypes,Source
} from '../enums/order-source-type';
import { OrderSourceTypes } from '../enums/order-source.enum';
import { SelectEnum } from '../enums/selection.enum';
import { ProductMetatDataValue } from '../enums/product-metadata.enum';
import { ShippingMemberTitle } from '../enums/shipping-member-title.enum';
import { ShippingMemberType } from '../enums/shipping-member-type.enum';
import { ValueType } from '../enums/value-type.enum';
import { PersonalAch } from '../interface/ach-payment/payment-achrequest.interface';
import { ActivityLogKey } from '../interface/activityLogKey';
import { Address } from '../interface/address';
import { AppCountryConfig } from '../interface/app-config';
import { BankDetails } from '../interface/bank-details.interface';
import { CheckoutConfig } from '../interface/checkout-config.interface';
import { DiscountPercentageResponse } from '../interface/discount-percentage.response.interface';
import { PersonalCheck } from '../interface/eCheck/payment-echeckrequest.interface';
import { TokenResponse } from '../interface/eCheck/token-response.interface';
import { ValidateEcheckRequest } from '../interface/eCheck/validate-echeck-request.interface';
import { ValidateEcheckResponse } from '../interface/eCheck/validate-echeck-response.interface';
import {
    EnrollInfo,
    EnrollSession, MemberCommunicationPreference, PersonalInfo, PersonalInformation, SponsorInformation
} from '../interface/enrollment';
import { DocumentLibrary, DocumentLibraryRequest } from '../interface/enrollment/document-library.interface';
import { RebindSponsorData } from '../interface/enrollment/sponsor-rebind-data.interface';
import { OrderRulesRequest } from '../interface/order-rules-request.interface';
import { OrderRulesResponse } from '../interface/order-rules-response.interface';
import { OrderTrackingRequest } from '../interface/orderTracking';
import { ParticipatingCountries } from '../interface/participating-countries.interface';
import { PayvisionSavedCardResponse } from '../interface/payvision/payvision-saved-card-response.interface';
import { PayvisionSavedCard } from '../interface/payvision/payvision-saved-card.interface';
import { Product, ProductAssociation } from '../interface/product-info';
import { ProductRestrictionModel } from '../interface/product-restriction.interface';
import { Promotion } from '../interface/promotion';
import { RestrictedProduct } from '../interface/restricted-product.interface';
import { ShippingMethod } from '../interface/ship-method';
import { ShippingAddressInfoConfig } from '../interface/shipping-address-info-config.interface';
import { ShippingOptionsRequest } from '../interface/shipping-options-request';
import { ShippingOptionsResponse } from '../interface/shipping-options-response';
import { TaxRequest } from '../interface/tax-request';
import { TaxType } from '../interface/tax-type.interface';
import { VerifyAccountModel } from '../interface/verify-account-exits-model';
import { Cart } from '../models/cart.model';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { PaymentComponentSettings } from '../models/payments/payment.model';
import { StockQuantity } from '../interface/stock-quantity';
import { AchService } from '../services/ach.service';
import { AppConfigService } from '../services/app-config.service';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { CustomerService } from '../services/customer.service';
import { DocumentService } from '../services/document.service';
import { EcheckService } from '../services/echeck.service';
import { EnrollmentMessageService } from '../services/enrollment-message.service';
import { EnrollService } from '../services/enrollment.service';
import { OrderService } from '../services/order.service';
import { PayvisionService } from '../services/payvision.service';
import { ShippingAddressInfoConfigService } from '../services/shipping-config.service';
import { CustomValidator } from './customvalidation.component';
import { CollectionPoint, GeoPoint } from '../interface/pudo-location.interface';
import { BusinessHour, SplitHour } from '../interface/business-hour.interface';
import { PudoLocationRequest } from '../interface/pudo-location-request.interface';
import { PaymentMethodSourceConfiguration } from '../../shared/interface/payment-method-source-configuration.interface';
import { PaymentModeConstants } from '../constants/payment-mode.constants';
import { ImpersonateUserConstants } from '../constants/impersonate-user.constants';
import { PersonalInfoConfigService } from './../services/personal-info-config.service';
import { ProductSource } from '../common/constants';
import { BonusInfo } from '../interface/bonus-info.interface';
import { PersonalInfoConfig } from '../interface/personal-info-config.interface';
import { BeneluxCountries } from '../enums/countries.enums';
import { BonusPaymentOption } from '../enums/bonus-payment-option.enum';
import { ConfigurationService } from '../services/configuration.service';
import { PersonalMessageService } from '../services/personal-schema-form.service';
import { PaymentProcessorAlias } from '../enums/payment-processor-alias.enum';
import { Subscription } from 'rxjs';
import { BankWireTransferConstants } from '../constants/bank-wire-transfer-configuration.constants';
const Randomize = require('randomatic');
@Component({
    selector: 'app-order-promotion-fpc',
    templateUrl: '../templates/template1/views/order-promotion-fpc.component.html',
    styleUrls: [
        '../templates/template1/themes/default/less/order-promotion-fpc.component.less','../templates/template1/themes/default/less/print-preview.less'
    ],
    providers: []
})

export class OrderCreateFPCComponent implements OnInit {
    @Input() orderFromLookup: boolean;
    @Output() fpcProductsInCart = new EventEmitter<number>();
    @ViewChild('paymentModal') paymentModalPopup: Modal;
    @ViewChild('payvisionPayment') payvisionPayment: Modal;
    @ViewChild('eCheckPaymentPopup') eCheckPaymentPopup: Modal;
    @ViewChild('showWorldPayXMLPopup') showWorldPayXMLPopup: Modal;
    @ViewChild('showAdyenPaymentPopup') showAdyenPaymentPopup: Modal;
    @ViewChild('showNIPopup') showNIPopup: Modal;
    @ViewChild('showNexioPopup') showNexioPopup: Modal;
    @ViewChild('shipMethodId') shipMethodId: ElementRef;
    @ViewChild('creditCardPayment') creditCardPayment: ElementRef;
    @ViewChild('paymentFormBtn') paymentFormBtn: ElementRef;
    @ViewChild('eCheckPayment') eCheckPayment: ElementRef;
    @ViewChild('savedCardsDdl') savedCardsDdl: ElementRef;
    @ViewChild('savedEcheckDdl') savedEcheckDdl: ElementRef;
    @ViewChild('showRestrictedProducts') showRestrictedProducts: Modal;
    @ViewChild('outOfStockModal') outOfStockModal: Modal;
    @ViewChild('saveEcheckFormBtn') saveEcheckFormBtn: ElementRef;
    @ViewChild('seachItemElement') seachItemElement: ElementRef;
    @ViewChild('itemLevelSearch') itemLevelSearch: ElementRef;
    @ViewChild('participatingCountryChangeConfirmation') participatingCountryChangeConfirmation: Modal;
    @ViewChild('achPaymentPopup') achPaymentPopup: Modal;
    @ViewChild('overrideMinimumLimit') overrideMinimumLimit:Modal;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    cartMessageID: any;
    memberInfo: any;
    memberTypeId = MemberTypeEnum.FPC;
    orderTypeFPC = OrderType.NEW_FPC;
    deliveryPreference: any = DeliveryPreference;
    orderFormGroup: FormGroup;
    items: any[] = [];
    countries: any[] = [];
    states: any[] = [];
    shippingAddressInfo: any;
    address: any;
    countryTaxInclusive: boolean;
    storeInfo: StoreConfig;
    shipMethodValidation: any = '';
    verifiedShippingAddressId: number;
    shippingDeliveryOptionAvailable = false;
    pickupDeliveryOptionAvailable = false;
    agreementCheckError = true;
    defaultCurrency = CommonConstant.Default_Currency;
    totalCommissionableVolume = 0;
    selectedIsoCountryCode: any = '';
    selectedCountryCodeTwo = '';
    shipMethods: ShippingOptionsResponse;
    shippingMethods: ShippingMethod[] = [];
    isSubmitted = false;
    products: any[] = [];
    orderTaxResponse: any;
    taxableAmount = 0;
    shippingCost = 0;
    cityList: any = [];
    originalShippingCost = 0;
    shipMethod: any = {};
    showSelectedShipMethod = false;
    languageCode = 'en-US';
    disableDelivery = false;
    importFeeValue = 0;
    importFeeEnabled = false;
    selectEnum = SelectEnum;
    userInfo: UserInfo;
    storeId: number;
    credit_Card_show: boolean;
    echeck_show: boolean;
    gstTax: number;
    pstTax: number;
    storeDefaultLanguage: string;
    taxCalculationStatus: boolean;
    minMaxPriceValidation: boolean;
    isFocused: boolean;
    selectedPickup: number;
    displayPriceConfig: DisplayPriceConfig;
    billingAddressInfo: any;
    paymentComponentSettings: PaymentComponentSettings = new PaymentComponentSettings();
    countryCode: string;
    addNewPayvisionCard: boolean;
    selectedPayvisionCardInfo: any;
    orderSession: any = {};
    isOrderSessionInfo: boolean;
    addNeweCheck: boolean;
    selectedECheckInfo: PersonalCheck;
    echeckForm: FormGroup;
    accountTypes: Array<string>;
    echeckRequest: PersonalCheck;
    eCheckTokenRes: string;
    savedEChecks: string;
    isWorldpayPayment: boolean;
    isAdyenPayment:boolean;
    isNIPayment: boolean;
    showWorldpayXml: boolean;
    showAdyenPayment:boolean;
    showNIPayment: boolean;
    echeckSubmitted: boolean;
    createOrderInfo: any;
    eCheckValidationMessages: Array<String>;
    restrictedProducts: Array<String>;
    shippingAddressInfoConfig: ShippingAddressInfoConfig;
    checkoutConfig: CheckoutConfig;
    appConfig: AppCountryConfig;
    skipAddressVerification: boolean;
    participatingCountries: ParticipatingCountries[];
    hasNewFPCOrderPermissions: boolean;
    shippingSchemaUrl: string;
    billingSchemaUrl: string;
    showAddressForm: boolean;
    savedAddressId: number;
    money_Order_show: boolean;
    bank_transfer_show: boolean;
    cash_on_delivery_show: boolean;
    orange_money_show:boolean;
    orderRules: OrderRulesResponse;
    productErrorMsg: string;
    savePaymentMethod: boolean;
    isNewCard: Boolean = false;
    memberCart: Cart;
    itemCount = 0;
    isRestrictionPopupOpened: boolean;
    outOfStockItems: Product[];
    stores: Country[];
    storeLanguages: Language[];
    agreementDocuments: DocumentLibrary[];
    personalInformation: PersonalInformation;
    returningFPCUser: Member;
    sponsorInformation: SponsorInformation;
    documentsRequest: DocumentLibraryRequest;
    fieldErrors: any[];
    personalInfoFormValid = true;
    mailingSchemaUrl: string;
    displayMailingAddressForm: boolean;
    mailingAddress: Address;
    memberCommunicationPreferences: MemberCommunicationPreference = {
        email: true,
        phone: false
    };
    liveFormAddress: Address;
    rebindSponsorData: RebindSponsorData;
    liveFormPersonalInfo: PersonalInformation;
    memberDiscountPercentage: DiscountPercentageResponse;
    memberCartSessionGuid: string;
    mailAlreadyExist = false;
    showMailingAddress = true;
    showShippingAddress = true;
    addNewCardClicked: boolean;
    paymentTypeEnum = PaymentType;
    bankDetailsList = [];
    shippingTax: number;
    originalShippingTax: number;
    shippingAddressChanged = false;
    signUpEmail: string;
    hasParticipatingCountries = false;
    participatingCountry: ParticipatingCountries;
    isParticipatingCountrySameAsStore = false;
    associatedCountries: ParticipatingCountries[];
    associatedCountry: number;
    accountVerified = false;
    paymentAchForm: FormGroup;
    selectedAchInfo: PersonalAch;
    achRequest: PersonalAch;
    ach_show: boolean;
    achPaymentInfo: any;
    achToken: string;
    savedAch: string;
    bankDetailsCountryList: BankDetails[];
    addNewAchCard: boolean;
    banContact_misterCash_and_maestro_show: boolean;
    misterCash_and_maestro_show: boolean;
    taxType = TaxType;
    phoneNumberFormat: string;
    promotionrequest: Promotion;
    promotionModels = [];
    itemSubTotal: number;
    totalCC: number;
    clickTimeout = [];
    promotionIds = [];
    displayPudoAddress: boolean;
    showPudoPickupPersonAddressForm: boolean = false;
    pudoShippingAddressInfo: Address = null;
    selectedPudoCollectionPoint: CollectionPoint = null;
    pudoLocationSearchForm:FormGroup;
    paymentReferenceNumber : FormGroup;
    loadingPudoPickupLocations: boolean;
    pudoAddressSubmitted: boolean;
    pudoAddress: any;
    savedPudoAddressId: number;
    pudoShippingMethod: ShippingMethod = null;
    pudoLocationsNotFound: boolean = false;
    pudoCollectionPoints: CollectionPoint[] = null;
    isnewcardAdded:boolean;
    pay_by_link_show: boolean;
    emailForm: FormGroup;
    isPayByLinkValid = true;
    storeDefaultLanguageShortCode: string;
    languageShortCode = 'en';
    languageCulture = 'en-US';
    payByLinkLanguageShortCode= 'en';
    dropShipDeliveryOptionDisabled = false;
    isNexioPayment: boolean;
    showNexioPayment: boolean;
    operatingCountry:any=[];
    overrideMinimumOrderLimitPermissions: number[]=[
        Permission.OVERRIDE_MINIMUM_LIMIT

    ]
    hasMinimumOverrideLimit:boolean;
    isOverrideMinimumLimit:boolean=false;
    overrideMinimumLimitIsEnabled:boolean=false;
    hidePudoPickupLocationsButton: boolean = true;
    formPickupPersonAddressValid: boolean;
    displayDropAddress: boolean =false;
    showDropShipPersonAddressForm: boolean = false;
    dropShipOptionAvailable = false;
    dropShipAddress :any | {};
    dropLoactionSelected = false;
    itemTotal : number;
    itemShippingCost : number;
    totalCost : number;
    depsoitFeeProductsInfo: Product[] = [];
    productAssociationInfo: ProductAssociation[] = [];
    purchaseFlowType = null;
    setPickupAddress:Address;
    deliveryPreferenceType:any = this.deliveryPreference.DELIVERY;
    isFPCPurchaseOverrideEnabled:boolean = false;
    sessionGuid: any;
    //Added Variables For Bonus Schema Form Integration
    bonusInformation: BonusInfo;
    bonusInfoSchemaUrl: string;
    bonusInfoFormValidated: boolean;
    disableBonusInfoChecks: boolean = false;
    displayIBANAckError: boolean = false;
    preloadMemberBonusInfo: BonusInfo;
    bonusInfoBankCode:string;
    bonusInfoAgreements: DocumentLibrary[] = [];
    bonusPaymentOptionType: string;
    bonusPaymentOption = BonusPaymentOption;
    memberBonusInfo: any;
    liveBonusinformation: BonusInfo;
    //To Fetch store settings
    storeSettings: PersonalInfoConfig;
    isBeneluxCountry: boolean = false;
    //PC Sponsor variables
    pCSponsorshipParticipationType;
    pcSponsorMinCC;
    pcSponsorEligible = false;
    isTaxMetaDataAvailable: boolean;
    isWorldPayEnabledCountry: boolean;
    retailDeliveryFee: number;
    pudoSuggestedAddressSubscription: Subscription;
    wire_Transfer_show: boolean;
    displayStatementForWavePayment:boolean = false;
    translateOptions = {
        translateText: "checkout.Forever Living Products {{countryName}} GmbH",
        translateParams: { countryName: '' }
    };
    storePaymentInfo:any;
    enableNexioPaymentForPickUpCenter:boolean = environment.enableNexioPaymentForPickUpCenter;
    customBankTransferDetailsConfiguration = BankWireTransferConstants.BankTransferCountries;
    customWireTransferDetailsConfiguration = BankWireTransferConstants.WireTransferCountries;
    showCustomerBankTransferDetails = false;
    showCustomerWireTransferDetails = false;
    dropshipPudoShippingMethod: ShippingMethod = null;
    isPickUpOptionExist = false;
    isDropShipOptionExist = false;
    scandinavianCountry: boolean = false;
    showDistance:boolean = false;
    constructor(private _orderService: OrderService,
        private _echeckService: EcheckService,
        private _sanitizer: DomSanitizer,
        private _formbuilder: FormBuilder,
        private _http: Http,
        private _commonService: CommonService,
        private _translatePipe: TranslateService,
        private _documentService: DocumentService,
        private _currencyPipe: CurrencyTransformPipe,
        private _cacheService: CacheService,
        private _customerService: CustomerService,
        private messageService: MessageService,
        private _payvisionService: PayvisionService,
        private _titleCase: TitleCasePipe,
        private _maskPipe: MaskPipe,
        private _enrollmentMessageService: EnrollmentMessageService,
        private _enrollService: EnrollService,
        private _shippingAddressInfoConfigService: ShippingAddressInfoConfigService,
        private _checkoutConfigService: CheckoutConfigService,
        private _memberDisplayPriceConfigService: MemberDisplayPriceConfigService,
        private _appConfigService: AppConfigService,
        private _translateService: TranslateService,
        private _enrollmentCommonService: EnrollmentCommonService,
        private _achService: AchService,
        private _personalInfoConfigService: PersonalInfoConfigService,
        private _addressService: AddressService,
        private _configurationService: ConfigurationService,
        private _personalMessageService: PersonalMessageService,
        @Inject(DOCUMENT) private document: any
    ) {
    }
    ngOnInit(): void {
        this.dropShipOptionAvailable = false;
        this.showDropShipPersonAddressForm = false;
        this.dropShipDeliveryOptionDisabled = false;
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.orderSession = sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
        this.showDistance = environment.restrictGoogleMapNavigation;
        this.getAllPermissions();
        this.buildPayByLinkForm();
        this.buildForm();
        this.getOperatingCountries();
        this.getCountries();
        this.getStates();
        if (this.orderSession ) {
            this.pudoAddress=this.orderSession.pudoaddress?this.orderSession.pudoaddress:this.pudoAddress;
            this.languageCulture = this.orderSession.languageCulture;
        }
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.createOrderInfo = this._cacheService.get('CreateOrderInfo');
        this._cacheService.remove('CreateOrderInfo');
        if (this.createOrderInfo) {
            this.orderFromLookup = true;
        }
        if (this.orderSession) {
            this.memberCartSessionGuid = this.orderSession.memberCartSessionGuid;
            this.minMaxPriceValidation = this.orderSession.minMaxPriceValidation;
        }
        this.orderSession!=null && this.orderSession.isOverrideMinimumLimit===true?this.isOverrideMinimumLimit=true:this.isOverrideMinimumLimit=false;
        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.orderFromLookup || this.isOrderSessionInfo
            // tslint:disable-next-line: no-unused-expression
            ? (document.getElementById('country') ? document.getElementById('country').focus() : null)
            : null;
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.sessionGuid = this._cacheService.getSessionValue(CacheKey.SessionGuid) || this._enrollmentCommonService.getSessionGuid();
        this.accountTypes = [AccountType.Checking, AccountType.Savings];
        this.setPUDOSuggestedAddress();
    }

    /**
     * @description This method used to get form controls for product line items
     * getFormControls()
     * @memberof OrderCreateFPCComponent
     */
    getFormControls() {
        const items: any = this.orderFormGroup.get('items');
        return items.controls;
    }

    buildReferenceNumberForm() {
        this.paymentReferenceNumber = this._formbuilder.group({
            referenceNumber: ['']
        })
    }
    paymentReferenceNumberFormValidations() {
        
        const paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
        this.paymentReferenceNumber.get('referenceNumber').clearValidators();
        if (paymentSelectorValue === this.paymentTypeEnum.Orange_Money) {
            this.paymentReferenceNumber.get('referenceNumber').setValidators([Validators.required,Validators.maxLength(18),Validators.pattern('[O,o]{1}[M,m]{1}[ ]{0,1}[0-9]{1,}')]);
        } else if (paymentSelectorValue === this.paymentTypeEnum.Money_order) {
            this.paymentReferenceNumber.get('referenceNumber').setValidators([Validators.required,Validators.maxLength(18),Validators.pattern('[W,w]{1}[A,a]{1}[V,v]{1}[E,e]{1}[ ]{0,1}[0-9]{1,}')]);
        }
    }


    /**
     * @description This method used to get all permissions
     * getAllPermissions()
     * @memberof OrderCreateFPCComponent
     */
    getAllPermissions(): void {
        this.hasNewFPCOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.MANAGE_FPC + ']'), AccessLevel.Customer_Service);
        this.hasMinimumOverrideLimit=this._commonService.checkPermissionByAccessLevel(
            JSON.parse('['+ this.overrideMinimumOrderLimitPermissions +']'),AccessLevel.Customer_Service);
    }


    selectParticipatingCountry(){
        this.removeSessionGuid();
        this.onSelectParticipatingCountry();
    }
    
    removeSessionGuid(): void {
        this._cacheService.removeSessionValue(CacheKey.SessionGuid);
    }

    /**
     * @description This method called when there is change in order type
     * orderTypeChange()
     * @memberof OrderCreateFPCComponent
     */
    orderTypeChange(orderType: OrderType) {
        this.mailAlreadyExist = false;
        this.orderFormGroup.controls['orderType'].setValue(orderType);
        if (!this.isOrderSessionInfo) {
            this.address = null;
            this.showSelectedShipMethod = false;
            this.orderFormGroup.controls['countryId'].setValue('');
            this.paymentComponentSettings.savedCards = [];
        }
        !this.isOrderSessionInfo ? this.clearAllTheForms(true, true, true) : this.clearAllTheForms();
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    }

    /**
     * @description This method called when New FPC flow is selected
     * onSelectNewFPCCreateFlow()
     * @memberof OrderCreateFPCComponent
     */
    onSelectNewFPCCreateFlow(): void {
        this.memberTypeId = this._enrollmentCommonService.getMemberTypeId(this.orderFormGroup.controls['orderType'].value);
        this.stores.forEach((allowedCountry: Country) => {
            const countryObj = this.countries.filter((country: Country) =>
                allowedCountry.isocodeThree === country.isocodeThree)[0];
            if (countryObj) {
                allowedCountry.id = countryObj.countryId;
                allowedCountry.name = countryObj.name;
                allowedCountry.isoCodeThree = countryObj.isocodeThree;
                allowedCountry.isoCodeTwo = countryObj.isocodeTwo;
            }
        });
        const countryId = this.stores.find(store => store.isocodeThree.toUpperCase() === IsoCodeThree.USA).id || this.stores[0].id;
        this.isOrderSessionInfo ? this.orderFormGroup.controls['countryId'].setValue(this.orderSession.countryId)
            : this.orderFormGroup.controls['countryId'].setValue(countryId);
        this.selectedCountry();
        this.disableDelivery = false;
        this.pickupDeliveryOptionAvailable = false;
        this.paymentComponentSettings.billingAddress = null;
        this.orderFormGroup.patchValue({
            deliveryPreference: DeliveryPreference.DELIVERY
        });
        this.showDropShipPersonAddressForm = false;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    }

    /**
     * @description This method to build New FPC form
     * buildForm()
     * @memberof OrderCreateFPCComponent
     */
    buildForm() {
        this.orderFormGroup = this._enrollmentCommonService.buildForm(this._formbuilder, this.orderTypeFPC, this.items);
        this.buildPudoLocationSearchForm();
    }

    /**
     * @description To get Bank Details for Bank Transfer Payment method.
     * getBankDetails()
     * @memberof OrderCreateFPCComponent
     */
    getBankDetails() {
        const bankDetails = this._translateService.get(PaymentConstants.BankTransfer)['value'];
        if (bankDetails !== PaymentConstants.BankTransfer) {
            for (let key in bankDetails) {
                if (key.indexOf(PaymentConstants.BankDetails) > -1) {
                    this.bankDetailsList.push(bankDetails[key]);
                }
            }
        }

    }

    /**
     * create item number
     * createItemNumberGroup()
     * @returns FormGroup
     * @memberof OrderCreateFPCComponent
     */
    createItemNumberGroup(): FormGroup {
        return this._enrollmentCommonService.createItemNumberGroup(this._formbuilder);
    }
    buildPudoLocationSearchForm(zipCode: string = '', city: string = '', addressLine1: string = '', country: string = '' ,externalId: string = '') {
        this.pudoLocationSearchForm = this._formbuilder.group({
            zipCode: [zipCode, [Validators.required]],
            externalId: [externalId],
            city: [city, [Validators.required]],
            country: [country],
            addressLine1: [addressLine1]
        })
        const countryCode = this.selectedIsoCountryCode || '';
        this.pudoLocationSearchForm.patchValue({
            country: countryCode.toUpperCase()
        });

    }

    /**
     * get Countries
     * getCountries()
     * @memberof OrderCreateFPCComponent
     */
    getCountries() {
        this._customerService.getCountriesLookup().subscribe(response => {
            if (response) {
                this.countries = response;
                this._cacheService.set(CacheKey.COUNTRIES, this.countries);
                this.stores = this.countries.filter(country => country.titanPlatformEnabled
                    && country.enrollmentEnabled && country.shopEnabled && this.isLiveCountry(country.isocodeThree));
                if (this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['orderType'].setValue(this.orderSession.orderType);
                    this.orderTypeChange(this.orderFormGroup.controls['orderType'].value);
                }
                this.orderFromLookup = this.isOrderSessionInfo ? this.orderSession.orderFromLookup : this.orderFromLookup;
                this.onSelectNewFPCCreateFlow();
            }
        });
    }

    /**
     * @description this method will check Give country Titan Live Country Or Not
     * @author Akhil
     * @date 2021-09-16
     * @param {string} countryCode
     * @returns {boolean}
     * @memberof OrderCreateFPCComponent
     */
    isLiveCountry(countryCode: string): boolean {
        if (environment.liveCountries) {
            const liveCountries = environment.liveCountries.toLowerCase().split(',');
            if (liveCountries && liveCountries.length) {
                return liveCountries.some((liveCountryCode) => liveCountryCode.toLowerCase() === countryCode.toLowerCase());
            }
        }
        return true
    }

    /**
     * get States
     * getStates()
     */
    getStates() {
        this._customerService.getStates().subscribe(response => {
            if (response) {
                this.states = response;
            }
        });
    }

    /**
     * On Country Select
     */
    selectedCountry(fromParticipatingCountry?: boolean) {
        this.showAddressForm = false;
        this.displayMailingAddressForm = false;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
        const selectedCountryID = this.orderFormGroup && this.orderFormGroup.value ? this.orderFormGroup.value.countryId : null;
        if (selectedCountryID) {
            this.orderFormGroup.controls['countryId'].disable();
            const countryObj = this.countries.filter((x: Country) => x.countryId === +selectedCountryID)[0];
            if (countryObj) {
                this.translateOptions.translateParams.countryName = countryObj.name;
                this.selectedIsoCountryCode = countryObj.isocodeThree;
                this.isBeneluxCountry = this.getBeneluxCountry(this.selectedIsoCountryCode);
                this.checkoutConfig = this._checkoutConfigService.getSettings(countryObj.isocodeThree, this.memberInfo);
                if(this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState){
                    this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                    this._cacheService.set(CacheKey.COUNTRY_ID,countryObj.countryId);
                    this.getCitiesByStates();
                }else{
                    this._cacheService.remove(CacheKey.COUNTRY_CODE);
                    this._cacheService.remove(CacheKey.COUNTRY_ID);
                }
                // this.isWorldPayEnabledCountry = this._configurationService.checkWorldPayEnabledCountry(countryObj.isocodeThree);
                // this.isWorldpayPayment = this.checkoutConfig.isWorldpayPayment;
                // this.isAdyenPayment = this.checkoutConfig.isAdyenPayment;
                // this.isNIPayment = this.checkoutConfig.isNIPayment;
                // this.isNexioPayment = this.checkoutConfig.isNexioPayment;
                this.countryCode = countryObj.isocodeThree;
                this.documentsRequest = null;
                this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                this.selectedCountryCodeTwo = countryObj.isocodeTwo;
                this.paymentComponentSettings.isoCountryCode = countryObj.isocodeThree;
                this.paymentComponentSettings.isoTwoletterCountryCode = countryObj.isocodeTwo;
                this.paymentComponentSettings.orderTypeId = this._enrollmentCommonService.getOrderTypeId(this.orderFormGroup.controls['orderType'].value);
                this.storeInfo = null;
                this.storeId = 0;
                // this._enrollmentMessageService.setStoreInfo(this.storeInfo);
                this.getStoreInfo(countryObj.isocodeThree);
                this.skipAddressVerification = this.checkoutConfig.skipAddressVerification;
                this.clearAllTheForms(false);
                this.orderSession!=null && this.orderSession.isOverrideMinimumLimit===true?this.isOverrideMinimumLimit=true:this.isOverrideMinimumLimit=false;
                this.address = null;
                if (!fromParticipatingCountry) {
                    this.participatingCountry = null;
                }
            }
            if (+this.orderFormGroup.value.countryId === countryObj.countryId) {
                this.isParticipatingCountrySameAsStore = true;
            } else {
                this.isParticipatingCountrySameAsStore = false;
            }
        }
    }

    /**
     * To Show popup on participating Country Change
     */
    showWarningPopup(event) {
        const selectedAgreements = this.agreementDocuments.filter(agreement => agreement.isSelected);
        if (this.participatingCountry && (this.mailingAddress || this.shippingAddressInfo || this.address || this.personalInformation
            || this.sponsorInformation || (this.products && this.products.length)) || selectedAgreements.length > 0) {
            event.preventDefault ? event.preventDefault() : (event.returnValue = false);
            this.participatingCountryChangeConfirmation.open();
        } else {
            this.onSelectParticipatingCountry();
        }
    }

    /**
     * To close popup on participating Country Change
     */
    closePopUp() {
        if (this.associatedCountry) {
            this.orderFormGroup.controls['participatingCountry'].setValue(this.associatedCountry);
        } else {
            this.orderFormGroup.controls['participatingCountry'].setValue('');
        }
        this.participatingCountryChangeConfirmation.close();
    }

    /**
     * On Country Select
     */
    onSelectParticipatingCountry() {
        this.showAddressForm = false;
        this.displayMailingAddressForm = false;
        const selectedCountryID = this.orderFormGroup && this.orderFormGroup.value ? this.orderFormGroup.value.participatingCountry : null;
        this.associatedCountry = selectedCountryID;
        if (selectedCountryID) {
            this.orderFormGroup.controls['participatingCountry'].disable();
            const countryObj = this.participatingCountries.filter((x: Country) => x.countryId === +selectedCountryID)[0];
            if (countryObj) {
                this.participatingCountry = countryObj;
                this.constructSchemaFormUrl(countryObj.isocodeThree);
                this.mailingAddress = null;
                this.liveFormAddress = null;
                this._enrollmentMessageService.setParticipatingCountryInfo(countryObj.countryId);
                this.selectedCountry(true);
            }
        } else {
            this.participatingCountry = null;
        }
    }

    /**
    * @description This method used to load fpc data from order session
    * loadOrderFromSession()
    * @returns void
    */
    loadOrderFromSession(): void {
        if (this.isOrderSessionInfo) {
            this.personalInformation = this.orderSession.personalInformation;
            this.participatingCountry = this.orderSession.participatingCountry ? this.orderSession.participatingCountry : null;
            if (this.participatingCountry) {
                this.orderFormGroup.controls['participatingCountry'].setValue(this.participatingCountry.countryId);
                this.associatedCountry = this.participatingCountry.countryId;
            }
            this.mailAlreadyExist = this.orderSession.mailAlreadyExist;
            this.accountVerified = this.orderSession.accountVerified;
            this.mailingAddress = this.orderSession.mailingAddress;
            this.memberCommunicationPreferences = this.orderSession.memberCommunicationPreferences;
            this.liveFormAddress = this.orderSession.liveFormAddress;
            this.orderFormGroup.controls['isContactSponsor'].setValue(this.memberCommunicationPreferences.email);
            this.returningFPCUser = this.orderSession.returningFPCUser;
            this.agreementDocuments = this.orderSession.documents;
            this.orderFormGroup.controls['language'].setValue(this.orderSession.language);
            this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
            this.storeInfo = this.orderSession.storeInfo;
            this.bonusInfoAgreements = this.orderSession.bonusInfoDocuments;
            this.bonusPaymentOptionType = this.orderSession.bonusPaymentOptionType;
            this.bonusInformation = this.orderSession.bonusInformation ? this.orderSession.bonusInformation : null;
            this.bonusPaymentOption = this.orderSession.bonusPaymentOption ? this.orderSession.bonusPaymentOption : null;
            this.pcSponsorEligible = this.orderSession.pcSponsorEligible;
            this.fetchTermsConditionDocument(this.agreementDocuments);
            if (this.orderSession.shippingAddressId || this.orderSession.shippingAddressInfo ||this.orderSession.pudoaddress) {
                this.address = this.orderSession.shippingAddressInfo;
                if(this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP){
                    this.address=this.orderSession.pudoaddress;
                    this.pudoAddress = this.address;
                    this.pudoShippingAddressInfo = this.address;
                }
                this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId, { onlySelf: true });
                if (this.address) {
                    this.shippingAddressInfo = this.address;
                    this.pudoAddress=this.address;
                    this.savedAddressId = this.address.id;
                    if (!this.participatingCountry) {
                        this.constructSchemaFormUrl(this.countryCode);
                    } else {
                        this.constructSchemaFormUrl(this.participatingCountry.isocodeThree);
                    }
                    this.address.isSavedAddress = this.orderSession.isSavedAddress;
                    this.address.id = this.orderSession.shippingAddressId;
                    this.pudoAddress = this.address;
                    this.pudoShippingAddressInfo = this.address;
                }
            } else {
                if (!this.participatingCountry) {
                    this.constructSchemaFormUrl(this.countryCode);
                } else {
                    this.constructSchemaFormUrl(this.participatingCountry.isocodeThree);
                }
            }
            if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP || this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
                this.validationsOnDeliveryPreference();
            }
            // check for shpping address when order info is in cache
            this.loadproductsFromSession();
        }
    }

    /**
     * get products by Ids
     */
    getProductsByIds(productsIds: Array<number>, storeInfo: StoreConfig) {
        this._orderService.getProductsByIds(productsIds, this.storeDefaultLanguage, storeInfo.id,
            this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value),
            this._enrollmentCommonService.getPurchaseFlow(this.orderFormGroup.controls['orderType'].value),
            this.selectedIsoCountryCode, false, false, storeInfo.taxInclusive).subscribe(
                response => {
                    if (response && response.length > 0) {
                        this.loadproducts(response);
                    }
                });
    }

    getCitiesByStates() {
        const countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
        this._addressService.getCitiesList(countryId).subscribe((response: any) => {
          console.log(response);
          
          if (response) {
            this.cityList = response;
            this._cacheService.set(CacheKey.Cities, response)
          }
        }
        );
      }

    /**
     *load procducts from session
     */
    loadproducts(products: Product[]) {
        products.forEach((product: Product) => {
            this.addItemNumber();
            const items: any = this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                const index = (items.length - 1);
                if (product) {
                    const itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    const itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
                    const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    const isDepositFeeProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1');
                    const depositFeeEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                    if (this.isOrderSessionInfo) {
                        const productInfo = this.orderSession.products.find((item: any) => product.id === item.productId);
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    } else if (this.orderFormGroup && !this.isOrderSessionInfo) {
                        let productInfo = null;
                        if (this.memberCart && this.memberCart.items.length > 0) {
                            productInfo = this.memberCart.items.find((item: any) => product.id === item.productId);
                        }
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    }
                    if(depositFeeEnabled) {
                        this.getDepositFeeProduct(product, true);
                    }
                }
            }
        });
        this.updateTotalsAndShipMethod();
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && !this.isOrderSessionInfo) {
            this.getShipMethods();
        }
    }

    /**
    * removing not available cart items based on logged in user
    * @param  {Cart} orderCart
    * @param  {CartItem[]} unAvailableCartItems
    */
    private deleteCart(sessionGuid: string) {
        if (sessionGuid) {
            this.itemCount = 0;
            this._customerService.removeCartItem(sessionGuid,
                this.storeInfo.id).subscribe(response => {
                });
        }
    }

    /**
     * @description constructing the schema form url
     * @memberof OrderCreateFPCComponent
     */
    constructSchemaFormUrl(countryCode: string): void {

        //To form Bonus schema URL and map schema form
        this.storeSettings = this._personalInfoConfigService.getSettings(this.countryCode);
        this.bonusInfoSchemaUrl = '';
        if (this.storeSettings.showBonusInfoSection) {
            if(this.storeSettings.countryCode.toLowerCase() === IsoCodeThree.SWE.toLowerCase() || this.storeSettings.countryCode.toLowerCase() === IsoCodeThree.DEU.toLowerCase() || this.storeSettings.countryCode.toLowerCase() === IsoCodeThree.AUT.toLowerCase()){
                if(this.bonusInfoBankCode){
                    this.bonusInfoSchemaUrl = countryCode.toLowerCase() + '-' + this.bonusInfoBankCode.toLowerCase() + '-bonus-info.json?templateVersion= '
                    + environment.templateVersion;
                } else {
                    this.bonusInfoSchemaUrl = countryCode.toLowerCase() + '-bankgiro-bonus-info.json?templateVersion= '
                    + environment.templateVersion;
                }
            } else{
                this.bonusInfoSchemaUrl = countryCode.toLowerCase() + '-bonus-info.json?templateVersion= '
                + environment.templateVersion;
            }
            this._configurationService.setStoreID(this.storeId);
            this._configurationService.setEnrollCountry(countryCode);
            this._configurationService.setLanguageCulture(this.storeDefaultLanguage);
            this._configurationService.setBonusInfoSchemaUrl(this.bonusInfoSchemaUrl);
            this._personalMessageService.setRebindBonusinfoForm(true);
            if(this.isOrderSessionInfo) {
                    this.disableBonusInfoChecks = this.orderSession.disableBonusInfoChecks;
            } else {
                this.disableBonusInfoChecks = true;
            }


        }
        //--------------------END--------------

        if (this.participatingCountry && !this.checkoutConfig.isParticipatingCountryShippingEnabled) {

            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        } else {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
            } else {
                this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
            }
            this.shippingSchemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        this.billingSchemaUrl = countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
            + environment.templateVersion;
        this.mailingSchemaUrl = countryCode.toLowerCase() + '-mailing-schema-form.json?templateVersion='
            + environment.templateVersion;
        setTimeout(() => {
            this.address = this.address;
            this.mailingAddress = this.mailingAddress;
            this.displayMailingAddressForm = true;
            this.showAddressForm = true;
            this.shippingDeliveryOptionAvailable = true;
        }, 500);
        this.orderFormGroup.controls['countryId'].enable();
        if (this.hasParticipatingCountries) {
            this.orderFormGroup.controls['participatingCountry'].enable();
        }
        
    }

    //Methods for Bonus Info Section Display Starts

    /**
     * @description To check whether selected country is Benelux country or not
     * @param homeCountry 
     * @returns 
     */
    getBeneluxCountry(homeCountry: string) {
        let beneluxCountries = [];
        Object.keys(BeneluxCountries).forEach(key => {
            beneluxCountries.push(BeneluxCountries[key]);
        });
        if (beneluxCountries && beneluxCountries.length > 0) {
            if (homeCountry) {
                this.isBeneluxCountry = beneluxCountries.includes(homeCountry) ? true : false;
            }
        }
        return this.isBeneluxCountry;
    }

    /**
     * @description to get Bonus information from bonus schema form to component
     * @param bonusInformation
     */
    getBonusInfo(bonusInformation: BonusInfo): void {
        this.bonusInformation = bonusInformation;
    }

    /**
     * @description To verify whether agreements are accepeted on IBAN bonus section flow
     * @param agreement
     */
    selectedAgreements(agreement: DocumentLibrary) {
        const agreementObj = this.bonusInfoAgreements.find(agreement => agreement.documentLibraryId === agreement.documentLibraryId);
        if(agreementObj) {
            agreementObj.isSelected = !agreementObj.isSelected;
            if (agreementObj.isSelected) {
                this.displayIBANAckError = false;
            }
        }
    }

    /**
     * @description To get information from bonus schema form on Input Change
     * @param bonusInfoFormValidated
     */
    getBonusInfoOnInputChange(bonusInfoFormValidated): void {
        this.bonusInfoFormValidated = bonusInfoFormValidated;
        let IBANNumber;
        this.messageService.accountNumber.subscribe(accountNumber =>  {
            if(!accountNumber) {
                this.displayIBANAckError = false;
            }
            IBANNumber = accountNumber ? accountNumber : '';
            this.disableBonusInfoChecks = IBANNumber ? false : true;
        });
    }

    /**
     * @description To reset bonus information on decide later option
     * @param paymentOption
     */
    selectBonusPaymentType(paymentOption: any) {
        this.bonusPaymentOptionType = paymentOption;
        if (paymentOption === this.bonusPaymentOption.DECIDE_LATER) {
            this.bonusInformation = null;
        }
    }

    /**
     * @description - To set bonus information 
     */
    setBonusInformation(): void {
        this._personalMessageService.setSubmitBonusInfoForm(true);
    }

    showVerifyBonusInfoMessage(): void {
        const verifyAddressError: any = this._translatePipe.get('order.Bonus Information  must be verified. Please click on Mailing address VERIFY ADDRESS Button');
        this._commonService.createNotification('', verifyAddressError.value, NotificationType.ERROR);
    }

    /**
     * @description - To fetch bonus info Terms and condition documents
     */
    fetchBonusAgreementDocument(): void {
        const customerTypeId = DocumentLibraryMemberId.Distributor;
        const displaySetionId = DisplaySectionId.Fbo_Sign_up;
        this._documentService.getDocuments(Portal.Csp, customerTypeId, displaySetionId, this.countryCode, this.storeDefaultLanguage)
            .subscribe((response) => {
                if (response && response.length > 0 && response[0].body && response[0].body.length > 0) {
                    this.bonusInfoAgreements = response[0].body;
                    this.bonusInfoAgreements.forEach((agreement: any) =>
                        agreement.isSelected = false
                    );
                } else {
                    const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            }, (error: any) => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
              });
    }

    //End Bonus Region Methods

    /**
     * Get Store Info
     * @param countryCode
     */
    getStoreInfo(countryCode: any) {
        if (countryCode) {
            this._orderService.getStoreInfo(countryCode).subscribe(response => {
                if (response) {
                    const storeInfo = response;
                    this.getMemberDiscountPercentages(storeInfo);
                    this.fetchPCSponsorEligiblityForStore(storeInfo);
                    this.storeId = response.id;
                    this.countryCode = countryCode;
                    this.countryTaxInclusive = storeInfo.taxInclusive;
                    this.shippingAddressInfoConfig = this._shippingAddressInfoConfigService.getSettings(countryCode);
                    this.appConfig = this._appConfigService.getSettings(countryCode, null);
                    if (this.appConfig.enablePaymentReferenceNumber) {
                        this.buildReferenceNumberForm();
                    }
                    if(this.appConfig.isWireTransferLabelWithoutGmbh){
                        this.translateOptions.translateText = "checkout.Forever Living Products {{countryName}}";
                    }
                    if (response.languages && response.languages.length > 0) {
                        this.storeDefaultLanguage = response.languages.find((languageCulture: any) => languageCulture.default).cultureName;
                        this.languageCulture = this.storeDefaultLanguage;
                        this.payByLinkLanguageShortCode = response.languages.find((languageCulture: any) => languageCulture.default).languageCode;
                    } else {
                        this.storeDefaultLanguage = this.languageCode;
                        this.languageCulture = this.languageCulture;
                        this.payByLinkLanguageShortCode = this.payByLinkLanguageShortCode;
                    }

                    if(this.customBankTransferDetailsConfiguration && this.customWireTransferDetailsConfiguration && this.selectedIsoCountryCode) {
                        let language = this._cacheService.get(CacheKey.Language);
                        this.showCustomerBankTransferDetails = this.customBankTransferDetailsConfiguration.includes(this.selectedIsoCountryCode) && language.toLowerCase() == this.storeDefaultLanguage.toLowerCase();
                        this.showCustomerWireTransferDetails = this.customWireTransferDetailsConfiguration.includes(this.selectedIsoCountryCode) && language.toLowerCase() == this.storeDefaultLanguage.toLowerCase();
                    }
                    
                    // this.getStorePromotions();
                    this.getParticipatingCountries(this.storeId);
                    this.loadFPCFlowSettings(response);
                    if (!this.isOrderSessionInfo) {
                        this.getFpcDocuments();
                        if(this.isBeneluxCountry) {
                            this.fetchBonusAgreementDocument();
                        }
                    }
                    if (this.memberInfo) {
                        this.achToken = ''
                        this.getSavedAchs();
                    }
                this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);                }
            }, error => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Store Details');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
    }

    /**
     * @description Fetch PC Sponsor participation details of Store
     * @param store 
     */
    private fetchPCSponsorEligiblityForStore(store){
            if(store && store.businessEntityId){
                this._configurationService.getBusinessEntityDetails(store.businessEntityId).subscribe((businessEntityDetails) => {
                    if(businessEntityDetails){
                            this.pCSponsorshipParticipationType = businessEntityDetails.pCSponsorshipParticipationType;
                            this.pcSponsorMinCC = businessEntityDetails.minCCToQualify;
                    }
                });
            }
    }


    // Start Region Promotion

    /**
     * To Get Promotions based on store
     */
    getStorePromotions(langCultureID?: number, resetPromotion?: boolean) {
        this.promotionModels = [];
        const promotionrequest: Promotion = {
            memberType: MemberTypeId.PREFERREDCUSTOMER,
            orderType: PromotionOrderType.JOIN,
            isTaxInclusive: this.countryTaxInclusive,
            languageSetting: langCultureID ? langCultureID : null
        };
        this._commonService.getPromotionEngineConfigurations(this.storeId, promotionrequest).subscribe((response: any) => {
            if (response && response.promotionModelList && response.promotionModelList.length > 0) {
                this.promotionModels = response.promotionModelList;
                if ( resetPromotion && (<FormArray>this.orderFormGroup.get('items')).length > 0) {
                    this.reUpdateCartAndPromotion();
                }
            } else {
                this.promotionModels = [];
                this.reUpdateCartAndPromotion();
            }
        }, error => {
            this.promotionModels = [];
            this.reUpdateCartAndPromotion();
        });
    }

    /**
     * Rebind the products based promotions
     */
    reUpdateCartAndPromotion() {
            const items = this.orderFormGroup.get('items');
            const freeProductsInfo = this.validatePromotionCriteria(items);
            const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
            this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
            if (productIds && productIds.length) {
                this.addPromotionEngineProducts(productIds, freeProductsInfo);
            } else {
                this.updateTotalsAndShipMethod();
            }
    }

    /**
     * Validate Promotions based on all criteria
     * @param product
     * @returns
     */
    validatePromotionCriteria(product: any) {
        const items = this.orderFormGroup.get('items');
        let freeProductsInfo = [];
        if (this.promotionModels && this.promotionModels.length > 0) {
            this._commonService.setSubTotalAndOrderCC(this.itemSubTotal, this.totalCommissionableVolume, this.countryTaxInclusive);
            this._commonService.validateOrderCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderSubTotalCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderCCCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductAtQuantityCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateMultipleProductCriteria(this.promotionModels, freeProductsInfo, items);
        }
        return this._commonService.removeDuplicates(freeProductsInfo);
    }

    /**
     * To Get Promotion Product details and bind it to order line items
     * @param productIds
     */
    addPromotionEngineProducts(productIds: number[], freeProductsInfo: any) {
        let items: any = this.orderFormGroup.get('items');
        // const notification: any = this._translatePipe.get('order.Invalid Item Number');
        if (items && items.length >= 0) {
            this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, this.getMemberTitleId(),
                this._enrollmentCommonService.getPurchaseFlow(this.orderFormGroup.controls['orderType'].value),
                this.selectedIsoCountryCode, false, false, this.storeInfo.taxInclusive).subscribe((products: Product[]) => {
                    if (products && products.length > 0) {
                        products.forEach((product) => {
                            const freeProductIndex = items.controls.findIndex(item => item.controls['productId'].value === product.id);
                            if (items && items.length >= 0 && freeProductIndex < 0) {
                                const currentFreeProduct = freeProductsInfo.find((freeProduct) => freeProduct.productId === product.id);
                                let stockQuantity: StockQuantity = this._commonService.stockQuantityCheck(product, currentFreeProduct);
                                if (stockQuantity.currentFreeProductQuantity> 0) {
                                    this.addItemNumber();
                                    const index = (items.length - 1);
                                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                    if (currentFreeProduct.promotionId && currentFreeProduct.promotionId.length > 0) {
                                        currentFreeProduct.promotionId.forEach((promotionId) => {
                                            if (this.promotionIds.indexOf(promotionId) == -1) {
                                                this.promotionIds.push(promotionId)
                                            }
                                        });
                                    }
                                    currentFreeProduct.quantity = stockQuantity.currentFreeProductQuantity;
                                    items = this._commonService.addPromoItem(items, index, product,
                                        environment.uiTemplateBaseUrl, environment.cdnURL);
                                    const productItem = items.controls[index].controls['productItem'].value;
                                    productItem.orderPromotionTrackings = stockQuantity.orderPromotionTrackings;
                                    if (!items.controls[index].controls['quantity'].value) {
                                        items.controls[index].controls['quantity'].setValue(currentFreeProduct.quantity);
                                    }
                                    items.controls[index].controls['quantity'].updateValueAndValidity();
                                    productItem.quantity = currentFreeProduct.quantity;
                                    items.controls[index].controls['productItem'].setValue(productItem);
                                }
                            }
                        });
                    } else {
                        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                            this.itemLevelSearch.nativeElement.focus();
                        }
                        // this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                    this.itemLevelSearch.nativeElement.value = '';
                });
                this.updateTotalsAndShipMethod();
        }
    }

    // End Region Promotion


    /**
     * @description
     * @private
     * @memberof OrderCreateFPCComponent
     */
    private getMemberDiscountPercentages(storeInfo: StoreConfig): void {
        if (this.taxCalculationStatus) {
            this.updateTotalsAndShipMethod();
        }
        this._commonService.getDiscountPercentages(false, false,
            this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value), storeInfo.id).
            subscribe(response => {
                this.memberDiscountPercentage = response;
            });
    }

    /**
    * @description This method used to load default settings for fpc flow
    * loadFPCFlowSettings()
    * @returns void
    */
    loadFPCFlowSettings(response: StoreConfig): void {
        this.getOrderRules();
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this.loadPreferences(response);
        this.getPaymentMethodsByStore(this.memberTypeId);
        this.loadDeliveryOptions();
        if (this.isOrderSessionInfo) {
            this.rebindSponsorData = this.orderSession.rebindSponsorData;
            this.sponsorInformation = this.orderSession.sponsorInformation;
        }
        this.storeId = response.id;
        this.storeInfo = response;
        this._enrollmentMessageService.setStoreInfo(this.storeInfo);
        this.storeLanguages = response.languages;
        this.paymentComponentSettings.languageCode = this.languageCode;
        this.overrideMinimumLimitIsEnabled=this.getOverrideMinimumLimit();
        this.paymentComponentSettings.storeId = this.storeInfo.id;
        this.paymentComponentSettings.currencyCode = this.storeInfo.currencyCode;
        this.paymentComponentSettings.numberDecimals = this.storeInfo.numberDecimals;
        this.paymentComponentSettings.isoCountryCode = this.storeInfo.homeIsocodeThree;
        this.storeInfo.ccNumberDecimals = 3;
        this.storeInfo.ccNumberFormat = 'CR';
        this.storeInfo.ccSymbol = 'CC';
        if(this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
            this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
            this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
            this.validationsOnDeliveryPreference();
        }
        if (response.languages && response.languages.length > 0) {
            this.storeDefaultLanguage = this.storeLanguages.find((languageCulture: Language) =>
                languageCulture.default).cultureName || this.storeLanguages[0].cultureName;
        }
        this.isOrderSessionInfo ?
            this.orderFormGroup.controls['language'].setValue(this.orderSession.language)
            : this.orderFormGroup.controls['language'].setValue(this.storeLanguages.find(item => item.default).cultureName);

        const langCultureID = this.storeLanguages && this.storeLanguages.length > 0 && this.orderFormGroup.controls['language'].value ?
        this.storeLanguages.find(item => item.cultureName.toLowerCase() == this.orderFormGroup.controls['language'].value.toLowerCase()).cultureId : null;
        this.getStorePromotions(langCultureID);

        this.orderFormGroup.controls['countryId'].enable();
        if (this.isOrderSessionInfo) {
            this.updateTotalsAndShipMethod();
        }
        if (!this.participatingCountry) {
            this.constructSchemaFormUrl(this.countryCode);
        } else {
            this.constructSchemaFormUrl(this.participatingCountry.isocodeThree);
            this._enrollmentMessageService.setParticipatingCountryInfo(this.participatingCountry.countryId);
        }
        if (this.isOrderSessionInfo) {
            this.loadOrderFromSession();
        } else {
            this.documentsRequest = this._enrollmentCommonService.prepareAgreementDocumentsRequest(this.orderFormGroup.controls['orderType'].value,
                this.countryCode, this.orderFormGroup.value.language);
        }
    }

    /**
    * @description This method used to load delivery options based on member type
    * loadDeliveryOptions()
    * @returns void
    */
    loadDeliveryOptions(): void {
        const getDeliveryOptionsRequest: any = {
            memberTypeId: this._enrollmentCommonService.getMemberTypeId(this.orderFormGroup.controls['orderType'].value),
            memberType: this._enrollmentCommonService.getMemberType(this.orderFormGroup.controls['orderType'].value),
            source: Source.CSP,
            countryCode: this.countryCode,
            purchaseFlow: this._enrollmentCommonService.getPurchaseFlow(this.orderFormGroup.controls['orderType'].value),
            storeId: this.storeId
        };
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this._orderService.getDeliveryOptions(this.countryCode, getDeliveryOptionsRequest).subscribe(res => {
            if (res && res.length > 0) {
                this.dropShipDeliveryOptionDisabled = false;
                res.forEach(option => {
                    if (option.optionValue === DelivaryOptionType.Delivery) {
                        this.shippingDeliveryOptionAvailable = true;
                    }
                    if (option.optionValue === DelivaryOptionType.Pickup) {
                        this.pickupDeliveryOptionAvailable = true;
                    }if (option.optionValue === DelivaryOptionType.Dropship) {
                        if (option.optionDisabled) {
                            this.dropShipDeliveryOptionDisabled = true;
                        } else if (this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                            this.dropShipOptionAvailable = true;
                        } else {
                            this.pickupDeliveryOptionAvailable = true;
                        }
                    }
                });
                const isDropShip = res.find((x)=> x.optionValue == DelivaryOptionType.Dropship);
                const isPickUp = res.find((x)=> x.optionValue == DelivaryOptionType.Pickup);
                if (environment.scandinavianCountries && this.countryCode) {
                    let scandinavianCountries = environment.scandinavianCountries;
                    this.scandinavianCountry = scandinavianCountries.split(",").find(country => country === this.countryCode);
                }
                // For Scandian country checking for Pickup
                if (this.scandinavianCountry && isPickUp) {
                    this.isPickUpOptionExist = true;
                }
                // For Non-Scandian country checking for DropShip
                if (!this.scandinavianCountry && isDropShip && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && !this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    this.isDropShipOptionExist = true;
                }
                // For Non-Scandian country checking for PickUp
                if (!this.scandinavianCountry && isPickUp && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                    this.isPickUpOptionExist = true;
                }
                if (!this.scandinavianCountry && isPickUp && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    this.isPickUpOptionExist = true;
                }
                this.loadSavedCardsForMemberId(0, this.selectedIsoCountryCode);
            }
        });
    }

    loadSavedCardsForMemberId(memberId: number, countryCode: string): void {
        let paymentStatus = this._cacheService.get(CacheKey.PaymentStatus);
        if (paymentStatus) {
            const newCardError: any = this._translatePipe.get('order.Payment gateway not responding');
            this._commonService.createNotification('', newCardError.value, NotificationType.ERROR);
            this._cacheService.remove(CacheKey.PaymentStatus);
        }
        const paymentInstrumentId: number = this._cacheService.get(CacheKey.PaymentInstrumentId);
        this._payvisionService.getSavedPayvisonCards(memberId, countryCode,
            paymentInstrumentId).subscribe((savedCardResponse: PayvisionSavedCardResponse) => {
                if (savedCardResponse && savedCardResponse.savedCards && savedCardResponse.savedCards.length > 0) {
                    this.paymentComponentSettings.savedCards = savedCardResponse.savedCards;
                    this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                        card.notes = card.defaultCard ? PaymentConstants.default : '';
                    });
                    if (paymentInstrumentId) {
                        const selectedCard = this.paymentComponentSettings.savedCards.find(x => x.id === paymentInstrumentId);
                        if (selectedCard) {
                            const indexPostion = this.paymentComponentSettings.savedCards.findIndex(x => x.id === paymentInstrumentId);
                            this.paymentComponentSettings.savedCards.splice(indexPostion, 1);
                            this.paymentComponentSettings.savedCards.unshift(selectedCard);
                            this.selectedPayvisionCardInfo = selectedCard;
                        }
                        this.orderFormGroup.controls['paymentInstrumentId'].setValue(paymentInstrumentId);
                        this._cacheService.remove(CacheKey.PaymentInstrumentId);
                    } else {
                        if (this.paymentComponentSettings && this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length > 0) {
                            let isDefaultCard = false;
                            this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                                if (card.expired === false && isDefaultCard === false) {
                                    isDefaultCard = true;
                                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                                    this.selectSavedCard(card);
                                }
                            });
                        } else {
                            this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
                            this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                        }
                    }
                } else {
                    this.paymentComponentSettings.savedCards = [];
                }
            }, (error: Response) => {
                this.paymentComponentSettings.isAddNewCard = false;
            });
    }

    /**
    * Delivery Preference On Change
    * @param value delivery preference
    */
    deliveryPreferenceOnChange() {
        this.deliveryPreferenceType = this.orderFormGroup.value.deliveryPreference;
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.shippingAddressChanged = false;
        this.dropShipAddress = null;
        this.dropLoactionSelected = false;
        if (this.countryCode.toUpperCase() == IsoCodeThree.USA && this.deliveryPreferenceType === ShippingType.DELIVERY && this.enableNexioPaymentForPickUpCenter) {
            this.getDeliveryOptionsPayment();
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
            + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;
        }

        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
            const paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
            if(paymentSelectorValue === this.paymentTypeEnum.Pay_By_Link){
                this.validatePaymentForm();
            }        
        } else if(this.shippingAddressInfoConfig  && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP){
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
        }else {
            this.showPudoPickupPersonAddressForm = false;
            this.displayPudoAddress = false;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
       } else {
            this.showDropShipPersonAddressForm = false;
            this.displayDropAddress = false;
        }
        this.getShipMethods();
        this.validationsOnDeliveryPreference();
        this.clearPudoLocationSearchData();
    }
    /**
     * update validations on delivery preference
     */
    validationsOnDeliveryPreference() {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.shippingAddressInfo = null;
            this.orderFormGroup.controls['shipMethodId'].setValue('');
            this.orderFormGroup.controls['shippingCostSelector'].disable();
            this.getShipMethods(true);
        } else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY) {
            this.selectedPickup = undefined;
            this.orderFormGroup.controls['shippingCostSelector'].enable();
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
            this.updateTotalsAndShipMethod();
        }else if(this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP){
            this.shippingAddressSelectionChange();
            this.updateTotalsAndShipMethod();
            this.pudoShippingMethod=this.orderSession && this.orderSession.pudoShippingMethod?this.orderSession.pudoShippingMethod:this.pudoShippingMethod;
            if( this.orderSession && this.orderSession.buildPudoLocationSearchForm){
            this.pudoLocationSearchForm.controls['zipCode'].setValue(this.orderSession.buildPudoLocationSearchForm.zipCode);
            this.pudoLocationSearchForm.controls['city'].setValue(this.orderSession.buildPudoLocationSearchForm.city);
            this.pudoLocationSearchForm.controls['externalId'].setValue(this.orderSession.buildPudoLocationSearchForm.externalId);
            this.pudoLocationSearchForm.controls['zipCode'].updateValueAndValidity();
            this.pudoLocationSearchForm.controls['city'].updateValueAndValidity();
            this.pudoLocationSearchForm.controls['externalId'].updateValueAndValidity();
            if(this.shippingAddressInfoConfig.pudoLocationsEnabled){
                this.showPudoPickupPersonAddressForm = true;
                this.displayPudoAddress = true;
              }else{
                this.showPudoPickupPersonAddressForm = false;
                this.displayPudoAddress = false;
              }    
              if(this.shippingAddressInfoConfig.dropShipLocationsEnabled){
                this.showDropShipPersonAddressForm = true;
                this.displayDropAddress = true;
                this.pudoShippingAddressInfo = this.orderSession.pudoShippingAddressInfo ? this.orderSession.pudoShippingAddressInfo : null;
              }else{
                this.showDropShipPersonAddressForm = false;
                this.displayDropAddress = false;
              }
            this.pudoAddress=this.orderSession.pudoaddress?this.orderSession.pudoaddress:this.pudoAddress;

            }
           this.selectedPudoCollectionPoint=this.orderSession && this.orderSession.selectedPudoCollectionPoint?this.orderSession.selectedPudoCollectionPoint: this.selectedPudoCollectionPoint;
          // this.getPudoLocations();
        }
    }

    /**
     * map the billing address fields
     */
    mapBillingAddress() {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
            && (this.shippingAddressInfo && this.shippingAddressInfo.countryId)
            || (this.memberInfo && this.memberInfo.address && this.memberInfo.address.countryId) || (this.mailingAddress)) {
            let country: Country;
            const address =  (this.memberInfo && this.memberInfo.address) || this.mailingAddress || this.shippingAddressInfo ;
            this.paymentComponentSettings.billingAddress = address;
            if (address && (address.stateCode === PaymentConstants.PuertoRico
                || address.stateCode === PaymentConstants.MarshallIslands
                || address.stateCode === PaymentConstants.VirginIslands)) {
                if (address.stateCode === PaymentConstants.MarshallIslands) {
                    country = this.countries.filter(x => x.isocodeThree.toLowerCase()
                        === address.stateCode.toLowerCase())[0];
                } else {
                    country = this.countries.filter(x => x.isocodeTwo.toLowerCase()
                        === address.stateCode.toLowerCase())[0];
                }
            } else {
                country = this.countries.filter(x => x.countryId === address.countryId)[0];
            }
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = address.postalCode;
        } else if (this.memberInfo && this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            const country = this.countries.filter(x => x.countryId === this.memberInfo.address.countryId)[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }else if(this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP){
            this.paymentComponentSettings.billingAddress =this.pudoAddress;
           const  country = this.countries.filter(x => x.countryId === this.pudoAddress.countryId)[0];
           this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
           this.paymentComponentSettings.billingAddress.zipCode = this.pudoAddress.postalCode;

        }
    }

    mapShippingAddress() {
        if (this.shippingAddressInfo) {
            this.paymentComponentSettings.shippingAddressDetail = this.shippingAddressInfo;
        }
    }

    /**
    * This method used to map communication preference
    */
    checkContactSponsor(): void {
        const memberCommunicationPreferences: MemberCommunicationPreference = {
            email: this.orderFormGroup.value.isContactSponsor,
            phone: false
        };
        this.memberCommunicationPreferences = memberCommunicationPreferences;
    }

    /**
       * verified Address Mapping
       * @param  {any}  address
       * @returns any
       */
    mapVerifiedAddressToFormFields(address: any) {
        if (address) {
            const countryObj = this._enrollmentCommonService.getCountryDetailsByCountryIdOrCode(this.countries, null, address.country);
            const stateObj = this._enrollmentCommonService.getStateDetailsByStateIdOrCode(this.states, null, address.state);
            const data = {
                'saveForFutureUse': this.orderFormGroup.value.saveForFutureUse,
                'countryObj': countryObj,
                'stateObj': stateObj,
                'addressVerified': (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified
            };
            return this._enrollmentCommonService.mapVerifiedAddressToFormFields(address, data);
        }
        return null;
    }

    /**
    * Add new Shipping Address
    * @param shippingAddressForm
    */
    useNewShippingAddress(addressInfo: any) {
        if (addressInfo) {
            const countryObj = this._enrollmentCommonService.getCountryDetailsByCountryIdOrCode(this.countries, addressInfo.countryId, null);
            const stateObj = this._enrollmentCommonService.getStateDetailsByStateIdOrCode(this.states, addressInfo.stateId, null);
            this.shippingAddressInfo = this._enrollmentCommonService.mapNewShippingAddress(addressInfo, stateObj,
                countryObj, this.orderFormGroup.value.saveForFutureUse);
            if(this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
                this.pudoShippingAddressInfo =  this.shippingAddressInfo;
                this.showPudoPickupPersonAddressForm = false;
            } else {
                    this.shippingAddressInfo =  this.shippingAddressInfo;
            }
            this.isNewCard = false;
            this.updateTotalsAndShipMethod();
        }
    }
    /**
     * save address method
     */
    private saveAddress(addressDetails: any) {
        const saveAddressRequest = this._enrollmentCommonService.prepareRequestToSaveAddress(this.memberInfo,
            addressDetails, this.orderFormGroup.value.saveForFutureUse);
        this._orderService.saveVerifiedAddress(saveAddressRequest).subscribe(response => {
            if (response && response.addressDetail) {
                if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
                    this.pudoAddress = addressDetails;
                    this.pudoAddress.id = response.addressDetail.id;
                    this.savedPudoAddressId = response.addressDetail.id;
                } else {
                    this.verifiedShippingAddressId = response.addressDetail.id;
                    this.address = addressDetails;
                    this.address.id = response.addressDetail.id;
                    // this.address.country = this.address.countryCode;
                    this.orderFormGroup.controls['shippingAddressId'].setValue(response.addressDetail.id, { onlySelf: true });
                    this.savedAddressId = response.addressDetail.id;
                    if (this.shipMethodId && this.shipMethodId.nativeElement) {
                        this.shipMethodId.nativeElement.focus();
                    }
                }
                if (saveAddressRequest.saveForFutureUse) {
                    this.messageService.setAddressSaved(true);
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(false);
                }
            }

        }, error => {
            const notification: any = this._translatePipe.get('order.Unable to Save Member Address');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    }
    // region #Start ShipMethods Section
    /**
       * on Shipping Method Change
       */
    selectShippingMethod(shippingMethod: ShippingMethod, isDeliveryOptionChange: boolean = false) {
        if (shippingMethod) {
            if (this.countryCode == IsoCodeThree.USA && this.deliveryPreferenceType === ShippingType.PICKUP && this.enableNexioPaymentForPickUpCenter) {
                this.getPickupDetailsForUSA(shippingMethod);
            }
            if (shippingMethod && (shippingMethod.pickUpLocation && (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP))) {
                this.getProcuctRestrictions(shippingMethod, shippingMethod.pickUpLocation, isDeliveryOptionChange);
                if (this.orderFormGroup.value.shipMethodId) {
                    this.selectedPickup = this.orderFormGroup.value.shipMethodId;
                }
            } else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, this.storeInfo);
                this.shippingCost = this.isOrderSessionInfo && this.orderSession.shippingCostValue >= 0 ?
                    this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                this.originalShippingTax = shippingMethod.shippingTax || 0;
                this.shippingTax = shippingMethod.shippingTax || 0;
                this.originalShippingCost = shippingMethod.shippingCharge + this.shippingTax;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this.originalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                // this.calculateOrderTax();
                if (!this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['shippingCostSelector'].setValue(this.selectEnum.firstOption.toString());
                    this.shippingCostChange();
                } else {
                    this.getShippingCostInPercentage();
                }
                if (isDeliveryOptionChange) {
                    this.updateTotalsAndShipMethod();
                }
            }
            if (this.deliveryPreferenceType === this.deliveryPreference.PICKUP) {
                this.setPickupAddress = this._enrollmentCommonService.getPickUpAddress(shippingMethod, this.orderFormGroup.value.deliveryPreference, this.countries,
                    this.states, this.selectedIsoCountryCode);
            }
        }
    }
    selectPudoCollectionPoint(collectionPoint: CollectionPoint) {
        this.dropShipAddress = null;
        this.selectedPudoCollectionPoint = collectionPoint;
        if(this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP){
            this.getPudoDropShipPersonAddress(collectionPoint);
            this.dropLoactionSelected = true;
            this.getShipMethods();
         }
        this.dropLoactionSelected = false;
        this.calculateOrderTax();
    }
    getProcuctRestrictions(shippingMethod: ShippingMethod, pickupAddress: any, isDeliveryOptionChange: boolean = false): void {
        const productRestrictionModel: ProductRestrictionModel = this._enrollmentCommonService.prepareProductRestrictionModelRequest(
            pickupAddress, this.products);
        this._commonService.getProductRestrictions(productRestrictionModel).subscribe((response) => {
            if (response && response.success && response.productModels) {
                this.getRestrictedProducts(response.productModels);
                this.taxCalculationStatus = true;
            } else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, this.storeInfo);
                this.shippingCost = this.isOrderSessionInfo ? this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                this.originalShippingTax = shippingMethod.shippingTax || 0;
                this.shippingTax = shippingMethod.shippingTax || 0;
                this.originalShippingCost = shippingMethod.shippingCharge + this.shippingTax;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this.originalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                this.calculateOrderTax();
                if (!this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['shippingCostSelector'].setValue(this.selectEnum.firstOption.toString());
                    this.shippingCostChange();
                } else {
                    this.getShippingCostInPercentage();
                }
                if (isDeliveryOptionChange) {
                    this.updateTotalsAndShipMethod();
                }
            }
        });
    }

    getShippingCost() {
        this.calculateOrderTax();
    }

    /**
     * Get Ship Methods By Products and Store
     */
    getShipMethods(isDeliveryOptionChange: boolean = false) {
        let shippingOptions;
        let items;
        this.taxCalculationStatus = true;
        this.shippingMethods = [];
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.showSelectedShipMethod = false;
        this.shipMethodValidation = null;
        this.restrictedProducts = [];
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
        this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
        this.orderFormGroup.controls['shippingCost'].setValue('');
        if (!this.pudoShippingAddressInfo) {
            this.getPudoPickupPersonAddress();
        }
        if (this.storeInfo && this.products && this.products.length > 0
            && (this.shippingAddressInfo || this.shippingAddressInfoConfig)) {
             if(this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && this.shippingAddressInfoConfig.pudoLocationsEnabled ){
                   shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                }
             }
             if(this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP){
                shippingOptions = this.prepareShippingOptionsRequest();
                 if (!shippingOptions.toAddress) {
                     shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                 }
               }
             if(this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY || this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP){
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig) {
                    shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                }
             }
        //  const shippingOptions: ShippingOptionsRequest = {
        //         productModels: this._enrollmentCommonService.getProductModels(this.products),
        //         orderSourceId: OrderSourceType.Web,
        //         languageCode: this.languageCode,
        //         orderTypeId: ShippingOrderType.Personal,
        //         fromAddress: this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode),
        //         toAddress: this.orderFormGroup.value.deliveryPreference ===
        //             this.deliveryPreference.DELIVERY ? this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo,
        //                 this.selectedCountryCodeTwo, this.orderFormGroup.value.saveForFutureUse) : {},
        //         storeId: this.storeInfo.id,
        //         requestID: 2, // for now we are using two once config is done we will drive from enum
        //         memberTypeId: ShippingMemberType.DISTRIBUTOR,
        //         priceTypeId: this._enrollmentCommonService.getPriceTypeId(),
        //         memberLevelId: ShippingMemberTitle.NOVUS,
        //         orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
        //         orderCaseCredits: this.totalCommissionableVolume,
        //         purchaseFlowId: PurchaseFlowType.WholeSale,
        //         shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
        //             this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY : ShippingType.PICKUP,
        //         storeHomeCountryCode: this.selectedIsoCountryCode,
        //         initialOrder: true,
        //         vatRegistered: false
        //     };
            //order source only for AUT && DEU Country
        
            this._orderService.getShipmentService(shippingOptions).subscribe(response => {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    if (this.shippingAddressInfo || (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled) )|| (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP || this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP)) {
                        this.shipMethods = response;
                        this.shippingMethods = response.shippingMethods;
                        //Process the free shipping based on promotions
                        items = this.orderFormGroup.get('items') ? this.orderFormGroup.get('items') : null;
                        this._commonService.applyPromotionFreeShipping(this.shippingMethods, this.promotionModels, this.items, this.totalCommissionableVolume);
                        this.importFeeEnabled = response.importFeeEnabled;
                        if (this.shippingMethods.length > 0) {
                            this.shippingMethods.forEach(shipMethod => {
                                shipMethod.shippingCharge = shipMethod.shippingCharge - shipMethod.shippingTax;
                                shipMethod.shippingCharge = this._currencyPipe
                                    .getFormatedCurrency(shipMethod.shippingCharge, this.storeInfo);
                                shipMethod.importFeeEnabled = response.importFeeEnabled;
                            });
                            if (this.isOrderSessionInfo) {

                                this.orderFormGroup.patchValue({
                                    shippingCostSelector: this.orderSession.shippingCostSelector,
                                    originalShippingCost: this.orderSession.originalShippingCost,
                                    shipMethodId: this.orderSession.shipMethodId,
                                    shippingCost: this.orderSession.shippingCost,
                                    shippingCostPercentage: this.orderSession.shippingCostPercentage,
                                    isShippingDiscountApplied: this.orderSession.isShippingDiscountApplied
                                });

                                const shipMethodId = this.orderFormGroup.value.shipMethodId;
                                if (shipMethodId && this.shippingMethods) {
                                    const shippingObj =
                                        this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +shipMethodId)[0];
                                    if (shippingObj) {
                                        this.selectShippingMethod(shippingObj, isDeliveryOptionChange);
                                        this.getShippingCost();
                                    }
                                } else {
                                    this.orderFormGroup.patchValue({
                                        shippingCost: 0,
                                        originalShippingCost: 0,
                                        shippingCostPercentage: 0,
                                        isShippingDiscountApplied: false,
                                        originalShippingTax: 0
                                    });
                                    if (this.shippingMethods[0].shippingMethodId) {
                                        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            this.orderFormGroup.controls['shipMethodId']
                                                .setValue(this.shippingMethods[0].shippingMethodId.toString());
                                        } else {
                                            this.orderFormGroup.controls['shipMethodId'].setValue(this.shippingMethods[0].shippingMethodId);
                                        }
                                        this.selectShippingMethod(this.shippingMethods[0], isDeliveryOptionChange);
                                    }
                                }
                            } else {
                                this.orderFormGroup.patchValue({
                                    shippingCost: 0,
                                    originalShippingCost: 0,
                                    shippingCostPercentage: 0,
                                    isShippingDiscountApplied: false,
                                    originalShippingTax: 0
                                });

                                if (this.shippingMethods[0].shippingMethodId) {
                                    let shippingInfoObj: ShippingMethod ;
                                    if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY ) {
                                            shippingInfoObj = response.shippingMethods.find((x) => !x.pudoEnabled);
                                        }
                                        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.pudoLocationsEnabled ) {
                                            shippingInfoObj = response.shippingMethods.find((x) => x.pudoEnabled);
                                        }
                                        if(this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled){
                                            shippingInfoObj = response.shippingMethods.find((x) => !x.pudoEnabled);
                                        }
                                        if (this.selectedPickup && this.isPickUpOptionExist && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +this.selectedPickup)[0];
                                        } else {
                                            if(!shippingInfoObj){
                                                shippingInfoObj = this.shippingMethods[0];
                                            }
                                        }
                                        // if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY ) {
                                            this.pudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled);
                                            if(!this.pudoShippingMethod) {
                                                this.getPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                                            }else{
                                         //       this.getPudoLocations();
                                            }
                                        // }
                                        // if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) {
                                        //     shippingInfoObj = this.shippingMethods[0];
                                        //     this.getPudoShippingMethods(shippingOptions, response.shippingMethods);
                                        // }
                                    }else{
                                    if (this.selectedPickup && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                        shippingInfoObj = this.shippingMethods.filter((shipMethod: any) =>
                                            shipMethod.shippingMethodId === +this.selectedPickup)[0];
                                    } else {
                                        shippingInfoObj = this.shippingMethods[0];
                                    }
                                  }

                                    if (shippingInfoObj) {
                                        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            this.orderFormGroup.controls['shipMethodId']
                                                .setValue(shippingInfoObj.shippingMethodId.toString());
                                        } else {
                                            this.orderFormGroup.controls['shipMethodId'].setValue(shippingInfoObj.shippingMethodId);
                                        }
                                        this.selectShippingMethod(shippingInfoObj, isDeliveryOptionChange);
                                    }
                                }
                            }
                            setTimeout(() => {
                                this.orderSession = null;
                                this.isOrderSessionInfo = false;
                            }, 2000);
                        }
                    }
                } else if (response && response.productModels && response.shippingMethods && response.productModels.length > 0) {
                    this.getRestrictedProducts(response.productModels);
                } else if (response && response.validations.length > 0) {
                    this.shipMethodValidation = response.validations[0];
                } else if (response && !(response.success)) {
                    this.shippingMethods = [];
                    this.shippingCost = 0;
                    this.orderFormGroup.patchValue({
                        shippingCost: 0,
                        originalShippingCost: 0,
                        shippingCostPercentage: 0,
                        isShippingDiscountApplied: false,
                        originalShippingTax: 0
                    });
                }
                if(this.isDropShipOptionExist && !this.pudoShippingMethod){
                    this.getDropShipPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                }
            }, error => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Ship Methods');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        } else {
            this.orderFormGroup.patchValue({
                shippingCost: 0,
                originalShippingCost: 0,
                shippingCostPercentage: 0,
                isShippingDiscountApplied: false,
                originalShippingTax: 0
            });
        }

    }

    /**
    * @param  {any} data
    * @returns SafeHtml
    */
    autocompleListFormatter = (data: any): SafeHtml => {

        const html = `<span>${data.itemNumber} - ${this._titleCase.transform(data.displayName ? data.displayName : data.name)}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    /**
     * Auto Complete Product Search
     */
    observableSource = (keyword: any, fullSearch?: boolean): Observable<any[]> => {
        if (this.hasNewFPCOrderPermissions && this.storeInfo) {
            if (keyword && keyword.length > 1) {
                if (keyword.indexOf('#') == 0) {
                    keyword = keyword.replace(/#/, '');
                }
                
                let _itemNumberURL = environment.productsUrl + '/stores/' + this.storeInfo.id + '/customerservice/products' +
                '?languageCode=' + this.storeDefaultLanguage + '&memberTitleId='  
                + this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value) +
                '&countryCode=' + this.selectedIsoCountryCode + '&pageSize=10&pageNumber=1&wholesaleQualified= false&productWildSearch=' + keyword.trim()
                + '&source=' + ProductSource.ADMINISTRATION +'&optin= false&taxInclusive=' + this.storeInfo.taxInclusive;

                  if (fullSearch) {
                    _itemNumberURL += '&searchType=FULL';
                }
                return this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(res => {
                    let results = res.json();
                    if (results && results.length > 0) {
                        if (this.appConfig && this.appConfig.hideFPCEnrollmentItem && environment.hideFPCEnrollmentItem) {
                            results = results.filter(x => x.itemNumber && (x.itemNumber
                                !== environment.hideFPCEnrollmentItem));
                        }
                        return results;
                    } else {
                        return [];
                    }
                });
            } else {
                return Observable.of([]);
            }
        } else {
            let notification: any;
            if (!this.storeInfo && !this.countryCode && !this.pickupDeliveryOptionAvailable && !this.shippingDeliveryOptionAvailable) {
                notification = this._translatePipe.get('Shipping options not available');
            } else if (!this.storeInfo && !this.countryCode &&
                (this.pickupDeliveryOptionAvailable || this.shippingDeliveryOptionAvailable)) {
                notification = this._translatePipe.get('order.Country Details are Mandatory');
            }
            if (notification) {
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }
    }

    getPudoPickupPersonAddress(): Address {
        let address: Address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                const mailingAddress = this.memberInfo && this.memberInfo.address ? this.memberInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if(!address.phone) {
                            address.phone = this.userInfo.phone;
                            address.phoneNumber = this.userInfo.phone;
                        }
                        if(!address.email) {
                            address.phone = this.userInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        } else {
            address = this.pudoShippingAddressInfo;
        }
        this.pudoAddress = this.pudoShippingAddressInfo;
        return address;
    }
    preparePudoLocationRequest() {
        if (!this.countries) {
            this.countries = this._cacheService.get(CacheKey.COUNTRIES);
        }
        let request: PudoLocationRequest = null;
        if (this.pudoLocationSearchForm) {
            let pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
            if (this.pudoAddress) {
                this.pudoAddress.zip = this.pudoAddress.zip ? this.pudoAddress.zip : this.pudoAddress.postalCode;
            }
            if (pudoLocationSearchFormData && pudoLocationSearchFormData.zipCode ? true: this.pudoAddress && this.pudoAddress.zip) {
                if (!pudoLocationSearchFormData.zipCode) {
                    this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
                }
                pudoLocationSearchFormData = this.pudoLocationSearchForm.value
                if (this.countries && this.storeInfo.homeIsocodeThree&& pudoLocationSearchFormData.zipCode) {
                    const country: Country = this.countries.find((x: Country) => x.isocodeThree.toUpperCase() === this.storeInfo.homeIsocodeThree.toUpperCase());
                    request = {
                        countryIsoCode: country.isocodeTwo || '',
                        postalCode: pudoLocationSearchFormData.zipCode || '',
                        storeID: this.storeInfo && this.storeInfo.id || null,
                        // as per centiro api we need to send  . (period) if there is no city
                        city: pudoLocationSearchFormData.city || '.',
                        streetAddress: pudoLocationSearchFormData.addressLine1 || '',
                        languageCode : "en",
                    }
                }
            }
        }
        return request;
    }
    getPudoLocationMap(geoPoint: GeoPoint) {
        if (geoPoint && geoPoint.latitude && geoPoint.longitude) {
            if(environment.restrictGoogleMapNavigation){
                return ApiUrlConstants.googleMapsUrl + geoPoint.latitude +
                ',' + geoPoint.longitude;
            }
            else {
                return null;
            }
        }
        return null;
    }
    loadPUDOLocations() {
        if (!this.skipAddressVerification) {
            this.messageService.setSubmitPudoPickupPersonAddress(true);
        } else {
            if(this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled){
                this.messageService.setSubmitPudoDropShipPersonAddress(true);
            }
            this.getPudoLocations();
        }
    }

    getPudoLocations() {
            let pudoLocationRequest: PudoLocationRequest = this.preparePudoLocationRequest();
            if (pudoLocationRequest) {
                this.pudoLocationsNotFound = false;
                this.pudoCollectionPoints = null;
                this.selectedPudoCollectionPoint = null;
                this.loadingPudoPickupLocations = true;
                this._orderService.getPudoLocations(pudoLocationRequest).subscribe(
                    (res) => {
                        this.loadingPudoPickupLocations = false;
                        if (res && res.collectionPoints && res.collectionPoints.length) {
                            this.pudoLocationsNotFound = false;
                            res.collectionPoints.sort((x, y) => x.distance - y.distance);
                            this.pudoCollectionPoints = res.collectionPoints;

                            this.calculateOrderTax();
                            this.prepareBusinessHours();
                            if (this.pudoLocationSearchForm && this.pudoLocationSearchForm.value && this.pudoLocationSearchForm.value.externalId) {
                                this.selectedPudoCollectionPoint = this.pudoCollectionPoints.find((x) => x.externalId == this.pudoLocationSearchForm.value.externalId);
                            }
                        } else {
                            this.pudoLocationsNotFound = true;
                        }
                    }, (error) => {
                        this.loadingPudoPickupLocations = false;
                        this.pudoLocationsNotFound = true;
                    }
                );
            }
    }


    prepareBusinessHours(): void {
        if (this.pudoCollectionPoints && this.pudoCollectionPoints.length) {
            this.pudoCollectionPoints.forEach((collectionPoint) => {
                if (collectionPoint && collectionPoint.openingHours) {
                    let businessHours: BusinessHour[] = [];
                    collectionPoint.openingHours.forEach((opening) => {
                        if (opening && opening.hours) {
                            let hours: SplitHour[] = [];
                            opening.hours.forEach((hour) => {
                                hours.push({ start: hour.opens, end: hour.closes })
                            });
                            const businessHour: BusinessHour = {
                                available: true,
                                day: opening.dayText,
                                hours: hours
                            }
                            businessHours.push(businessHour);
                        }
                    });
                    collectionPoint.businessHours = businessHours;
                }
            });
        }
    }

    getPudoShippingMethods(shippingOptions: ShippingOptionsRequest, shippingMethods:ShippingMethod[], mappingRequired:boolean = true) {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if(this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                }
            } else {
                shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
            }
            shippingOptions.shippingTypeId = ShippingType.DELIVERY;
            //order source only for AUT && DEU Country

            this._orderService.getShipmentService(shippingOptions).subscribe((response) => {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    this.pudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled);
                    if(mappingRequired) {
                        if(this.pudoShippingMethod) {
                            this.pudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                        this.getPudoLocations();
                    }
                }
            }, (error) => {
            });
        }
    }

    prepareShippingOptionsRequest(): ShippingOptionsRequest {
        const shippingOptions: ShippingOptionsRequest = {
            productModels: this._enrollmentCommonService.getProductModels(this.products),
                    orderSourceId: OrderSourceType.Web,
                    languageCode: this.languageCode,
                    orderTypeId: ShippingOrderType.Personal,
                    fromAddress: this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode),
                     toAddress: this.orderFormGroup.value.deliveryPreference ===
                    this.deliveryPreference.DELIVERY ? this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo,this.pudoShippingAddressInfo,
                    this.selectedCountryCodeTwo,  this.orderFormGroup.value,this.countries,this.storeInfo.foreverDirectEnabled) : (this.shippingAddressInfoConfig.dropShipLocationsEnabled 
                        && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP)? this.getPudoDropShipPersonAddress() : this.gtePudoPickupPersonAddress(),
                    storeId: this.storeInfo.id,
                    requestID: 2, // for now we are using two once config is done we will drive from enum
                    memberTypeId: ShippingMemberType.DISTRIBUTOR,
                    priceTypeId: this._enrollmentCommonService.getPriceTypeId(),
                    memberLevelId: ShippingMemberTitle.NOVUS,
                     orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
                     orderTaxInclusiveSubTotal: this._commonService.getProductsTotalTax(this.products,this.calculateItemsSubTotal(this.storeInfo),this.storeInfo),
                     orderCaseCredits: this.totalCommissionableVolume,
                      purchaseFlowId: PurchaseFlowType.WholeSale,
                     shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
                     this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY :(this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP? ShippingType.DROPSHIP: ShippingType.PICKUP),
                 storeHomeCountryCode: this.selectedIsoCountryCode,
                    initialOrder: true,
                    vatRegistered: false
        };
        if (this.shippingAddressInfoConfig.sendSourceToShippingOptions) {
            shippingOptions.source = Source.CSP;
        }
        return shippingOptions;

    }
    gtePudoPickupPersonAddress(): Address {
        let address: Address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                const mailingAddress = this.memberInfo && this.memberInfo.address ? this.memberInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if(!address.phone) {
                            address.phone = this.userInfo.phone;
                            address.phoneNumber = this.userInfo.phone;
                        }
                        if(!address.email) {
                            address.phone = this.userInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        } else {
            address = this.pudoShippingAddressInfo;
        }
        this.pudoAddress = this.pudoShippingAddressInfo;
        return address;
    }


    /**
     * Decrement the item Quantity
     * @returns void
     */
    decrementQuantity(index: number): void {
        this.taxCalculationStatus = true;
        const items: any = this.orderFormGroup.get('items');
        const product = items.controls[index].controls['productItem'].value;
        if (items && items.length > 0 && this.storeInfo) {
            
            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            if (items.controls[index].controls['quantity'].value === 1) {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
            this.setFocusbyID('quantity-' + (index));
            if(this.productAssociationInfo){
                const productid=items.value[index].productId;
                const associateProduct = this.productAssociationInfo.find(x => x.productId === productid);
                if(associateProduct){
                    const sameProductIndex = items.controls.findIndex(item => item.controls['productId'].value === associateProduct.depositFeeProductId);
                    if(sameProductIndex >= 0){
                        this.decrementQuantity(sameProductIndex);
                    }
                }
            }
            this.updateTotalsAndShipMethod(false);

                this.clickTimeout[items.controls[index].controls['productId'].value] =
                setTimeout(() => {
                    //New logic to bind promtoion product from promotion engine
                    const freeProductsInfo = this.validatePromotionCriteria(items);
                    const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                    this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
                    if (productIds && productIds.length) {
                        this.addPromotionEngineProducts(productIds, freeProductsInfo);
                    } else {
                        this.updateTotalsAndShipMethod();
                    }
                }, 500);
               
        }
    }

    /**
    * Increment the item Quantity
    * @returns void
    */
    incrementQuantity(index: number, event?: any): void {
        this.taxCalculationStatus = true;
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            const product = items.controls[index].controls['productItem'].value;
            if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock)
                && !(product.stockAvailable && !product.manageStock)) {
                items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);

                items.controls[index].controls['disableIncrement'].setValue(true);
            } else {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            const quantityFieldLength = items.controls[index].controls['quantity'].value ? items.controls[index].controls['quantity'].value.toString().length : 0;
            if (quantityFieldLength > 3) {
                items.controls[index].controls['disableIncrement'].setValue(true);
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
            }
            clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
            items.controls[index].controls['disableDecrement'].setValue(false);
            items.controls[index].controls['quantity'].updateValueAndValidity();
            this.setFocusbyID('quantity-' + (index));
              if(this.productAssociationInfo){
                    const productid=items.value[index].productId;
                    const associateProduct = this.productAssociationInfo.find(x => x.productId === productid);
                    if(associateProduct){
                        const sameProductIndex = items.controls.findIndex(item => item.controls['productId'].value === associateProduct.depositFeeProductId);
                        if(sameProductIndex >= 0){
                            this.incrementQuantity(sameProductIndex);
                        }
                    }
                }
            this.updateTotalsAndShipMethod(false);

                this.clickTimeout[items.controls[index].controls['productId'].value] =
                setTimeout(() => {
                    //New logic to bind promtoion product from promotion engine
                    const freeProductsInfo = this.validatePromotionCriteria(product);
                    const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                    if (productIds && productIds.length) {
                        this.addPromotionEngineProducts(productIds, freeProductsInfo);
                    } else {
                        this.updateTotalsAndShipMethod();
                    }
                }, 500);
              
        }
    }


    quantityChange(event: any, index: number) {
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    }
    /**
    * @param  {number} index
    * @returns void
    */
    updateQuantity(event: any, index: number): void {
        if (!this.isRestrictionPopupOpened && !this.addNewCardClicked) {
            const items: any = this.orderFormGroup.get('items');
            const product = items.controls[index].controls['productItem'].value;
            
            if (items && items.length > 0 && this.storeInfo) {
                let quantity = event.target ? +event.target.value : event;
                if (!items.controls[index].controls['quantity'].dirty && event.target) {
                    return;
                  }
                items.controls[index].controls['quantity'].markAsPristine();
                const previousProductQty = product.quantity;
                if (items.controls[index].controls['quantity'].value > 1 ||
                    (quantity && parseInt(quantity, 10))) {
                    clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
                    if (product && quantity > product.stockQuantity && product.manageStock) {
                        items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                        const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                        this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                        items.controls[index].controls['disableIncrement'].setValue(true);
                    } else {
                        items.controls[index].controls['quantity'].setValue(quantity);
                        items.controls[index].controls['disableIncrement'].setValue(false);
                    }
                    items.controls[index].controls['disableDecrement'].setValue(false);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                }
                if (items.controls[index].controls['quantity'].value === 0) {
                    items.controls[index].controls['quantity'].setValue(1);
                    quantity = 1;
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['disableIncrement'].setValue(false);
                }
                if(this.productAssociationInfo){
                    let productid=items.value[index].productId;
                    const associateProduct = this.productAssociationInfo.find(x => x.productId === productid);
                    if (associateProduct) {
                        const sameProductIndex = items.controls.findIndex(item => item.controls['productId'].value === associateProduct.depositFeeProductId);
                        if (sameProductIndex >= 0) {
                            let depositFeeProductQuantity = +items.value[sameProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - previousProductQty;
                            depositFeeProductQuantity = depositFeeProductQuantity + quantity;
                            if (depositFeeProductQuantity > 0) {
                                this.updateQuantity(depositFeeProductQuantity, sameProductIndex);
                            }
                        }
                    }
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod(false);
                }
                this.isFocused = false;
                 this.clickTimeout[items.controls[index].controls['productId'].value] =
                    setTimeout(() => {
                        //New logic to bind promtoion product from promotion engine
                        const freeProductsInfo = this.validatePromotionCriteria(items);
                        const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                        this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
                        if (productIds && productIds.length) {
                            this.addPromotionEngineProducts(productIds, freeProductsInfo);
                        } else {
                            this.updateTotalsAndShipMethod();
                        }
                }, 600);
               
            }
        }
    }

    /**
     * @description open/close when restricted products shown
     * @param {boolean} isOpen
     * @memberof OrderCreateFPCComponent
     */
    restrictionPopupOpen(isOpen: boolean): void {
        this.isRestrictionPopupOpened = isOpen;
    }

    /**
     * disabling Submit button
     */
    disableSubmitButton(): void {
        this.taxCalculationStatus = true;
    }

    /**
     * @returns void
     */
    deleteItem(index: number, deletePromotionItem?: boolean): void {
        const items = this.orderFormGroup.get('items') as any;
        const product = items.controls[index].controls['productItem'].value;
        const productQuantity = +items.controls[index].controls['quantity'].value;
        if (items && items.length > 0) {
            if (this.productAssociationInfo) {
                const depositFeeEnabledCount = this._commonService.depositFeeEnabledProducts(items);
                let productId = items.value[index].productId;
                const parentProduct = this.productAssociationInfo.find(x => x.productId === productId);
                if (parentProduct) {
                    // remove the parent product
                    items.removeAt(index);
                    const depositFeeProductIndex = items.controls.findIndex(item => item.controls['productId'].value === parentProduct.depositFeeProductId);
                    if (depositFeeEnabledCount > 1) {
                        if (depositFeeProductIndex > -1) {
                            let depositFeeProductQuantity = +items.value[depositFeeProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - productQuantity;
                            if (depositFeeProductQuantity > 0) {
                                items.value[depositFeeProductIndex].quantity = depositFeeProductQuantity
                                items.setValue(items.value);
                            } else {
                                items.removeAt(depositFeeProductIndex);
                            }
                        }
                    } else {
                        if (depositFeeProductIndex > -1) {
                            items.removeAt(depositFeeProductIndex);
                        }
                    }
                } else {
                    items.removeAt(index);
                }
            } else {
                items.removeAt(index);
            }
        }
        setTimeout(() => {
            if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                this.itemLevelSearch.nativeElement.focus();
            }
        }, 500);
        this.updateTotalsAndShipMethod(false);
                //New logic to bind promtoion product from promotion engine
                const freeProductsInfo = this.validatePromotionCriteria(items);
                const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
                if (productIds && productIds.length) {
                    this.addPromotionEngineProducts(productIds, freeProductsInfo);
                } else {
                    this.updateTotalsAndShipMethod();
                }
    }

    addItemNumber(): void {
        this.items = this.orderFormGroup.get('items') as any;
        this.items.push(this.createItemNumberGroup());
    }

    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    public clearAllTheForms(clearCountry: boolean = true, clearShippingAddress: boolean = true, clearMember: boolean = false) {
        this.showSelectedShipMethod = false;
        this.shippingAddressInfo = null;
        this.selectedPayvisionCardInfo = null;
        this.shipMethod = null;
        this.bankDetailsList = [];
        this.shippingCost = 0;
        this.shippingTax = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.itemCount = 0;
        this.verifiedShippingAddressId = 0;
        this.agreementDocuments = [];
        this.personalInformation = null;
        this.mailingAddress = null;
        this.bonusInformation = null;
        this.bonusInfoAgreements = [];
        this.liveFormAddress = null;
        this.address = null;
        this.sponsorInformation = null;
        this.returningFPCUser = null;
        this.isSubmitted = false;
        this.shippingAddressInfoConfig = null;
        this.orderFormGroup.get('items').reset();
        const arr = <FormArray>this.orderFormGroup.controls.items;
        arr.controls = [];
        this.orderFormGroup.controls['isContactSponsor'].setValue(null);
        this.memberCommunicationPreferences = {
            email: true,
            phone: false
        };
        this.orderFormGroup.patchValue({
            shippingCostSelector: this.selectEnum.firstOption.toString(),
            shippingCostPercentage: 0,
            originalShippingCost: 0,
            paymentSelector: this.selectEnum.firstOption.toString(),
            paymentInstrumentId: '',
            isShippingDiscountApplied: false,
            originalShippingTax: 0
        });
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (clearCountry) {
            this.orderFormGroup.controls['countryId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['countryId'].updateValueAndValidity();
            const countryId = this.stores.find(store => store.isocodeThree.toUpperCase() === IsoCodeThree.USA).id || this.stores[0].id;
            this.orderFormGroup.controls['countryId'].setValue(countryId);
        }
        if (clearMember) {
            this.memberInfo = null;
        }

        if (clearShippingAddress) {
            this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
            this.orderFormGroup.controls['shippingAddressId'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingAddressId'].setValue('');
            this.shippingMethods = [];
        }
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['backDateOrder'].setValue(false);
        this.orderFormGroup.controls['itemSearch'].setValue('');
        this.orderFormGroup.markAsUntouched();
        this.updateTotalsAndShipMethod();
        this.orderTaxResponse = null;
        this.signUpEmail = null;
        this.associatedCountry = 0;
        this.selectedPudoCollectionPoint = null;
        this.pudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.pudoShippingAddressInfo = null;
        this.showPudoPickupPersonAddressForm = false;
        this.showDropShipPersonAddressForm = false;
        this.pudoAddress = null;
        this.savedPudoAddressId = null;
        this.pudoAddressSubmitted = false;
        this.buildPayByLinkForm();
        this.buildPudoLocationSearchForm();
        this.loadingPudoPickupLocations = false;
        this.displayPudoAddress = false;
        this.isOverrideMinimumLimit=false;
        this.productAssociationInfo = [];
        this.depsoitFeeProductsInfo =[];
        this.isFPCPurchaseOverrideEnabled = false;
    }

    /**
     * update Totals and ShipMethod
     */
    updateTotalsAndShipMethod(isShippingMethod:boolean = true) {
        this.taxCalculationStatus = true;
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.itemCount = 0;
        if(!this.isOrderSessionInfo) this.pcSponsorEligible = false;
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            for (let index = 0; index < items.length; index++) {
                const product = items.controls[index].controls['productItem'].value;
                const quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    const existProduct = this.products.filter(productObj => productObj.id === product.id)[0];
                    if (!existProduct) {
                        product.quantity = quantity;
                        this.products.push(product);
                        this.fpcProductsInCart.emit(this.products && this.products.length);
                    } else {
                        const productIndex = this.products.findIndex(item => item.id === existProduct.id);
                        this.products[productIndex].quantity = this.products[productIndex].quantity + quantity;
                    }
                    const shippingAddress = this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo,this.pudoShippingAddressInfo,
                        this.selectedCountryCodeTwo,  this.orderFormGroup.value,this.countries);
                    if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
                        const country = this.countries.find(x => x.countryId === shippingAddress.countryId);
                        this.countryTaxInclusive = this._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
                    }
                    const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
                    const taxCalculated = this.appConfig.displayTaxInclusivePrice ? false : true;
                    this.displayPriceConfig = this._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this.storeInfo.taxInclusive,
                            null, taxCalculated, this.countryTaxInclusive, this.storeInfo.homeIsocodeThree, isEnableVATCalculation);

                    this.totalCommissionableVolume = this.totalCommissionableVolume + (product.commissionableVolume * +quantity);
                    if(this.pCSponsorshipParticipationType && this.pCSponsorshipParticipationType == PCSponsorConstants.PCSPONSORSHIP_PARITICIPATION_TYPE  
                        && this.pcSponsorMinCC && this.totalCommissionableVolume >= this.pcSponsorMinCC){
                            this.pcSponsorEligible = true;
                    } 
                    this.itemCount += +product.quantity;
                }
            }
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && (!(this.orderRules.validateProductTypes
                && this.orderRules.validateProductTypes.length) || !this.checkoutConfig.enableMinAndMaxLimitRules)) {
                const subTotal = this.calculateItemsSubTotal(this.storeInfo);
                const hasMinValueIgnoreProduct = this._enrollmentCommonService.checkMinValueProduct(this.products, this.orderRules);
                this.itemSubTotal =  subTotal;
                const literatureItems = this._enrollmentCommonService.getLiteratureItems(this.products, this.orderRules);
                if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                    || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                        && subTotal <= this.orderRules.maxValue))) {
                    if (this.appConfig.orderMinMaxPriceValidation) {
                        this.minMaxPriceValidation = true;
                    }
                    if (subTotal > this.orderRules.maxValue) {
                        clearTimeout(this.cartMessageID);
                        const cartValueExceeded: any = this._translatePipe.get('order.The order amount not including your discounts must not exceed');
                        let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors( this.orderRules.maxValue,this.storeInfo);
                        const cartValueExceededNotification: any = cartValueExceeded.value + ' <b class="helvetica-bold">' +
                            maxValue + '</b>';
                        if (this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {
                            this.cartMessageID = setTimeout(() => {
                                this._commonService.createNotification('', cartValueExceededNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                            }, 100);
                        }
                    } else if ((subTotal < this.orderRules.minValue && !hasMinValueIgnoreProduct ) && !this.isOverrideMinimumLimit) {
                        clearTimeout(this.cartMessageID);
                        const cartMinimumLimit: any = this._translatePipe.get('order.To register as an FPC the order must meet a minimum of');
                        if(this.overrideMinimumLimitIsEnabled){
                            let overrideLimitLink:any=this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                            let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo)
                            const cartMinimumLimitNotification: any = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                            minValue + '</b>.<b>'+overrideLimitLink.value+'</b>';
                            this.cartMessageID = setTimeout(() => {
                                const toast=this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                                toast.click.subscribe((event) => {
                                    if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {

                                        this.overrideMinimumLimit.open();
                                    }
                                });
                            }, 100);
                        }
                       else{
                        let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                            const cartMinimumLimitNotification: any = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                            minValue + '</b>';
                            this.cartMessageID = setTimeout(() => {
                                this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                            }, 100);
                        }
                    } else {
                        this._commonService.removeNotification(Constants.MIN_LIMIT);
                        this._commonService.removeNotification(Constants.MAX_EXCEEDED);
                    }
                } else {
                    this.minMaxPriceValidation = false;
                }
            } else {
                this.itemCount = 0;
            }
            this.validateOrderLimit(true);
            if (isShippingMethod) {
                this.getShipMethods();
            }
        } else {
            this.gstTax = 0;
            this.pstTax = 0;
            this.shippingCost = 0;
            this.shippingTax = 0;
            this.importFeeValue = 0;
            this.fpcProductsInCart.emit(this.products && this.products.length);
        }
    }

    getOverrideMinimumLimit():boolean{
        if(this.userInfo && this.userInfo.allowedOperatingCountries && this.storeInfo && this.storeInfo.operatingCountry && !this.userInfo.hasSystemRole && this.operatingCountry){
            let isoCodeThree:any=this.storeInfo.operatingCountry;
            let allowedCountryIds:any=[];
            let operatingCountryId=this.operatingCountry.filter(operatingCountry=>operatingCountry.value==isoCodeThree);
            allowedCountryIds=this.userInfo.allowedOperatingCountries.split(",");
            if(operatingCountryId && operatingCountryId.length>0){
                return allowedCountryIds.includes(operatingCountryId[0].id.toString()) && this.hasMinimumOverrideLimit;
            }
            else{
                return false;
            }
         }
        return this.userInfo && this.userInfo.hasSystemRole===true?true:false;
    }

    getOperatingCountries():void{
        this._customerService.getOperatingCountries().subscribe((response:any)=>{
            if(response){
                this.operatingCountry=response;
            }
        },err=>{
            console.log(err)
        });

    }

    closeOverrideMinimumLimit():void{
        this.isOverrideMinimumLimit=false;
        this.overrideMinimumLimit.close();
    }
    overrideMinimumLimitValueCheck(event:any){
        this.isOverrideMinimumLimit=event.currentTarget.checked;
    }


    closeNotification():void{
        this._commonService.removeNotification(Constants.MIN_LIMIT);
        this.overrideMinimumLimit.close()
    }

    getFpcDocuments(selectedLanguage ?: string): void {
        const customerTypeId = DocumentLibraryMemberId.Novus;
        const displaySetionId = DisplaySectionId.FPC_Checkout_Page;
        this._documentService.getDocuments(Portal.Csp, customerTypeId, displaySetionId, this.countryCode, selectedLanguage ? selectedLanguage : this.storeDefaultLanguage)
            .subscribe(response => {
                if (response && response[0].body) {
                    response[0].body = orderBy(response[0].body, ['documentUrl'], ['asc']);
                    this.agreementDocuments = response[0].body;
                    if (this.agreementDocuments && this.agreementDocuments.length) {
                        this.agreementDocuments.forEach(item => {
                            item.isSelected = false;
                        });
                    }
                } else {
                    const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            }, (error: any) => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
    }

    /**
     * @description
     * @param {number} index
     * @memberof OrderCreateFPCComponent
     */
    checkFpcDocumentSelection(index: number): void {
        this.agreementDocuments[index].isSelected = !this.agreementDocuments[index].isSelected;
        this.agreementCheckError = this._enrollmentCommonService.validateAgreementSelection(this.agreementDocuments);
    }

    /**
     * @description Clear the out of stock items and update the tax
     * @memberof OrderCreateFPCComponent
     */
    clearOutOfStockItems(): void {
        const items = this.orderFormGroup.get('items') as any;
        if (this.outOfStockItems && this.outOfStockItems.length) {
            const productIds = this.outOfStockItems.map((product: Product) => product.id);
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.isSubmitted = false;
            this.outOfStockModal.close();
        }
    }

    /**
     * @description Remove out of stock items from cart items
     * @param {FormArray} items
     * @param {number[]} productIds
     * @memberof OrderCreateFPCComponent
     */
    removeOutOfStockItems(items: FormArray, productIds: number[]) {
        productIds.forEach((id: number) => {
            const productIndex = items.value.findIndex((product) => product.productId === id);
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    }

    closeOutOfStockForm() {
        this.outOfStockModal.close();
    }

    /**
     * @description submit enrollment
     * @param {string} requestUrl
     * @memberof OrderCreateFPCComponent
     */   
    submitEnrollment(): void {
        this._enrollmentMessageService.setSubmitPersonalInfoForm(true);
        if (this.appConfig.enablePaymentReferenceNumber) {
            if(this.paymentReferenceNumber.value.referenceNumber){
                this.paymentComponentSettings.authorizationCode = this.paymentReferenceNumber.value.referenceNumber;    
            }
        }
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        // if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled
        //     && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP && !this.pudoAddressSubmitted) {
        //     this.isnewcardAdded=true;
        //     this.messageService.setSubmitPudoPickupPersonAddress(true);
        //     return;
        // }
        // if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled 
        //     && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP && !this.pudoAddressSubmitted) {
        //          this.isnewcardAdded=true;
        //         this.messageService.setSubmitPudoDropShipPersonAddress(true);
        //     return;
        // }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP
            && !this.selectedPudoCollectionPoint){
            return;
        }
        if (!this.accountVerified) {
            this.showAccountExistsMessage();
            this.isSubmitted = false;
            return;
        }
       this.isSubmitted = true;

       //Changes for bonus information validations
       if(this.pcSponsorEligible){
        if(this.isBeneluxCountry) {
            this.messageService.accountNumber.subscribe((accountNumber: string) => {
                if (this.bonusInformation) {
                    this.bonusInformation.accountNumber = accountNumber;
                } else {
                    const bonusInfo: any = {
                        accountNumber: accountNumber
                    };
                    this.bonusInformation = bonusInfo;
                }
            });
            if(this.bonusInformation && this.bonusInformation.accountNumber) {
                const list = this.bonusInfoAgreements.filter(x => x.isSelected === false);
                if(list && list.length === 0) {
                    this.displayIBANAckError = false;
                    this.validatePersonalInfo();
                } else {
                    this.displayIBANAckError = true;
                    setTimeout(() => {
                        this._commonService.focusInvalidElement();
                    },0)
                }
            } else{
                this.displayIBANAckError = false;
                this.validatePersonalInfo();
            }
        } else if ((this.storeSettings && this.storeSettings.bonusInfoPaymentOptions) && !(this.bonusInformation || this.bonusPaymentOptionType === BonusPaymentOption.DECIDE_LATER)) {
                setTimeout(() => {
                    this._commonService.focusInvalidElement();
                }, 0);
        } else {
            this.validatePersonalInfo();
        }
     } else {
            this.validatePersonalInfo();
        }
    }

    /**
     * Changes to verify personal information
     */
    validatePersonalInfo(){
        if (this.personalInfoFormValid
            && !this.agreementCheckError && this.personalInformation && this.sponsorInformation
            && this.mailingAddress) {
            this.isSubmitted = true;
            this.validateOutOfStockAndSubmit();
        } else {
            setTimeout(() => {
                this._commonService.focusInvalidElement();
            }, 0)
        }
    }

    validateOutOfStockAndSubmit() {
        if (this.products && this.products.length) {
            const productIds = this.products.map((item: Product) => item.id);
            if (productIds && productIds.length) {
                if ((this.orderFormGroup.value.deliveryPreference==this.deliveryPreference.DELIVERY || this.orderFormGroup.value.deliveryPreference==this.deliveryPreference.DROPSHIP ) || (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled)) {
                    this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id,
                        this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value),
                        this._enrollmentCommonService.getPurchaseFlow(this.orderFormGroup.controls['orderType'].value),
                        this.selectedIsoCountryCode, false, false, this.storeInfo.taxInclusive).subscribe((products: Product[]) => {
                            this.outOfStockItems = this.stockAvailabilityCheck(products);
                            if (this.outOfStockItems.length) {
                                this.outOfStockModal.open();
                                this.isSubmitted = false;
                                this.isnewcardAdded=false;
                            } else {
                                this.placeEnrollRequest();
                                this.isnewcardAdded=false;
                            }
                        });
                } else if (this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.PICKUP) {
                    // pickup products stock availability check
                    const shipMethodId = this.orderFormGroup.value.shipMethodId;
                    if (shipMethodId && this.shippingMethods) {
                        const shippingObj =
                            this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +shipMethodId)[0];
                        if (shippingObj && shippingObj.shippingMethodId) {
                            this.pickupStockAvailabilityCheck(productIds, shippingObj.shippingMethodId);
                        } else {
                            this.isSubmitted = false;
                        }
                    } else {
                        this.isSubmitted = false;
                        const notification = 'Pickup location not available, Please select.'
                        this._commonService.createNotification('', notification, NotificationType.ERROR);
                    }
                }
            }
        }
        else if (this.products && this.products.length===0){
            if(this.overrideMinimumLimitIsEnabled){
                if(!this.isFPCPurchaseOverrideEnabled){
                    this.isSubmitted= false;
                    let FPCPurchaseOverrideLink:any=this._translatePipe.get("order.Order must contain a minimum of 1 item to continue,<b class='helvetica-bold'>To Override Minimum Limit,click <a id='more-options'>here</a></b>");
                    const cartMinimumLimitNotification: any = FPCPurchaseOverrideLink.value;
                    this.cartMessageID = setTimeout(() => {
                        const toast=this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                        toast.click.subscribe((event) => {
                            if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                this.isFPCPurchaseOverrideEnabled = true;
                                this._commonService.removeNotification(Constants.MIN_LIMIT);
                            }
                        });
                    }, 100);
                }
                else if (this.isFPCPurchaseOverrideEnabled){
                    this.placeEnrollRequest(this.isFPCPurchaseOverrideEnabled);
                }
            }
            else{
                let FPCPurchaseOverrideNotification :any = this._translatePipe.get("order.Permission not granted");
                const cartMinimumLimitNotification: any = FPCPurchaseOverrideNotification.value;
                this.isSubmitted = false;
                this.cartMessageID = setTimeout(() => {
                    this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                }, 100);
            }

        }
    }

    /**
     * @description To check stock available
     * @param {Product[]} products
     * @returns {Product[]}
     * @memberof OrderCreateFPCComponent
     */
    stockAvailabilityCheck(products: Product[]): Product[] {
        const cartProducts: Product[] = this.products;
        if (cartProducts && products && products.length) {
            const noStockItems: Product[] = [];
            products.forEach((product: Product) => {
                const cartItem = cartProducts.find((item: Product) => item.id === product.id);
                if (cartItem && !((product.stockAvailable && !product.manageStock) || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                    cartItem.stockQuantity = product.stockQuantity;
                    noStockItems.push(cartItem);
                }
            });
            return noStockItems;
        }
        return [];
    }

    /**
 * @description checks the Pickup stock quantity availability on individual product
 * @param productIds:number[]
 * @param pickupLocationId:number
 * @memberof OrderCreateFBOComponent
 */
    pickupStockAvailabilityCheck(productIds: number[], pickUpLocationId?: number) {
        const noStockItems: Product[] = [];
        const cartProducts: Product[] = this.products;
        if (pickUpLocationId && pickUpLocationId > 0 && productIds && productIds.length > 0) {
            this._customerService.getProductsByLocation(pickUpLocationId, productIds).subscribe(
                (response: any) => {
                    const posProducts = response;
                    if (posProducts && posProducts.length > 0) {
                        posProducts.forEach((pickUpProduct) => {
                            const cartProduct = cartProducts.find((product) => product.id === pickUpProduct.productId);
                            if (cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity) {
                                cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                                noStockItems.push(cartProduct);
                            }
                        });
                    }
                    this.outOfStockItems = noStockItems;
                    if (this.outOfStockItems && this.outOfStockItems.length > 0) {
                        this.outOfStockModal.open();
                        this.isSubmitted = false;
                    } else {
                        this.placeEnrollRequest();
                    }
                },
                (error: any) => {
                    const notification: any = this._translatePipe.get('orderdetails.Sorry, Something Went Wrong: Please try again later.');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            );
        }
    }

    /**
     * @description this method is used
     * to get selected sponsorinfo from sposor component
     * @memberof OrderCreateFPCComponent
     */
    getSelectedSponserInfo(sponsorInformation: SponsorInformation): void {
        this.sponsorInformation = sponsorInformation;
        if(this.sponsorInformation)
        {
            this.isSubmitted=false;
        }
        else
        {
            this.isSubmitted=true;
        }
    }

    pudoAddressInputChange(address: Address): void {
        if (this.formPickupPersonAddressValid) {
            this.pudoAddress = address;
            this.pudoCollectionPoints = null;
            this.hidePudoPickupLocationsButton = true;
            this.pudoLocationsNotFound = false;
            if (this.pudoAddress) {
                this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
            }
        }
    }

    /**
     * @description this method will fire when we change textbox value
     * in address block
     * @memberof OrderCreateFPCComponent
     */
    getAddressOnInputChange(address: Address): void {
        if (!this.sponsorInformation) {
            this.liveFormAddress = address;
            this._enrollmentMessageService.setSponsorPreference(this.liveFormAddress);
        }
        if (this.mailingAddress && !this.shippingAddressInfo) {
            if ((!this.participatingCountry || this.isParticipatingCountrySameAsStore) || this.checkoutConfig.isParticipatingCountryShippingEnabled) {
                this.prepopulateShippingAddress();
            } else {
                this.prePopulateDetails();
            }
        }
        let isAddressEqual = false;

        if (this.mailingAddress) {
            const verifyAddress: any = {
                addressLine1: this.mailingAddress.addressLine1 ? this.mailingAddress.addressLine1 : '',
                addressLine2: this.mailingAddress.addressLine2 ? this.mailingAddress.addressLine2 : '',
                city: this.mailingAddress.city ? this.mailingAddress.city : '',
                state: this.mailingAddress.state ? this.mailingAddress.state : '',
                postalCode: this.mailingAddress.postalCode ? this.mailingAddress.postalCode : '',
            };

            const unVerifiedAddress: any = {
                addressLine1: address.addressLine1 ? address.addressLine1 : '',
                addressLine2: address.addressLine2 ? address.addressLine2 : '',
                city: address.city ? address.city : '',
                state: address.state ? address.state : '',
                postalCode: address.postalCode ? address.postalCode : '',
            };
            isAddressEqual = isEqual(verifyAddress, unVerifiedAddress);
        }

        if (this.mailingAddress && this.mailingAddress.addressVerified && !isAddressEqual && !address.addressVerified) {
            this.mailingAddress.addressVerified = false;
        } else if ((this.participatingCountry || this.isParticipatingCountrySameAsStore) && this.mailingAddress) {
            this.mailingAddress.addressVerified = true;
        }
    }

    addressChangedByUser(changed: boolean): void {
        this.shippingAddressChanged = changed;
        if (changed) {
            this.selectedPudoCollectionPoint = null;
        }
    }

    /**
     * @description this method will prepopulate shipping address
     * @param {string} sponsorId
     * @memberof OrderCreateFPCComponent
     */
    prepopulateShippingAddress(): void {
        if (this.appConfig && this.appConfig.skipAddressVerification && this.mailingAddress) {
            this.mailingAddress.addressVerified = true;
        }
        let schemaCountryCode: any;

        if (this.checkoutConfig.isParticipatingCountryShippingEnabled && !this.isParticipatingCountrySameAsStore && this.participatingCountry) {
            schemaCountryCode = this.participatingCountry.isocodeThree;
        } else {
            schemaCountryCode = this.countryCode;
        }

        const address: Address = this.mailingAddress;
        if (this.liveFormPersonalInfo) {
            address.firstName = this.liveFormPersonalInfo.firstName;
            address.lastName = this.liveFormPersonalInfo.lastName;
            address.middleName = this.liveFormPersonalInfo.middleName;
            address.phoneNumber = this.liveFormPersonalInfo.phoneNumber || this.liveFormPersonalInfo.phone;
            address.phoneType = this.liveFormPersonalInfo.phoneType;
            address.email = this.liveFormPersonalInfo.email ? this.liveFormPersonalInfo.email : null;
        }
        this.address = address;
        this.showAddressForm = false;
        this.displayPudoAddress =false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
            + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;
        }
        /*this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;*/
        setTimeout(() => {
            this.address = this.address;
            this.showAddressForm = true;
            this.pudoAddress =this.address;
            this.pudoShippingAddressInfo =this.address;
            this.displayPudoAddress =true;
            if (this.orderFormGroup.value.deliveryPreference===this.deliveryPreference.DROPSHIP){
            this.getPudoLocations();
            }
        }, 500);
    }

    /**
     * @description this method will help
     * to close progress bar once done with request
     * @private
     * @memberof OrderCreateFPCComponent
     */
    private displayErrorMessage(errResponse: any): void {
        this.isSubmitted = false;
        this.fieldErrors = [];
        if (!this.sponsorInformation) {
            const notification: any = this._translatePipe.get('order.Sponsor not found');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
        if (errResponse && (errResponse.validations && errResponse.validations.length > 0
            || errResponse.length > 0)) {
            this.fieldErrors = errResponse.validations || errResponse;
        }
    }

    validateOrderLimit(quantityUpdate: boolean): boolean {
        let subTotal = this.calculateItemsSubTotal(this.storeInfo);
        // changes for order min/max for taxInclusive stores PS2022-1077
        if (this.storeInfo && this.storeInfo.taxInclusive) {
            subTotal = this.itemTotal;
        }
        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && !quantityUpdate
            && this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {
            const literatureItems = this._enrollmentCommonService.getLiteratureItems(this.products, this.orderRules);
            if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue))) {
                if (subTotal > this.orderRules.maxValue) {
                    const maximumCartLimit: any = this._translatePipe.get('order.The order amount not including your discounts must not exceed');
                    let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue,this.storeInfo);
                    const cartMaximumLimitNotification: any = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                        maxValue + '</b>';
                    this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                    return false;
                } else if (subTotal < this.orderRules.minValue && !this.isOverrideMinimumLimit) {
                    const minimumCartLimit: any = this._translateService.get('order.To register as an FPC the order must meet a minimum of');
                    if(this.overrideMinimumLimitIsEnabled){
                        let overrideLimitLink:any=this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                        let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                        const cartMinimumLimitNotification: any = minimumCartLimit.value + ' <b class="helvetica-bold">' +
                        minValue + '</b>.<b>'+overrideLimitLink.value+'</b>';
                        this.cartMessageID = setTimeout(() => {
                            const toast=this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                            toast.click.subscribe((event) => {
                                if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {

                                    this.overrideMinimumLimit.open();
                                }
                            });
                        }, 100);
                    }
                   else{
                    let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                        const cartMinimumLimitNotification: any = minimumCartLimit.value + ' <b class="helvetica-bold">' +
                        minValue + '</b>';
                        this.cartMessageID = setTimeout(() => {
                            this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                        }, 100);
                        return false;
                    }
                } else {
                    this._commonService.removeNotification(Constants.ORDER_LIMIT);
                }
            }
        }
        if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length && !quantityUpdate) {
            const isLiteratureValidation = this._enrollmentCommonService.isLiteratureValidation(this.products, this.orderRules);
            let invalidProductPopup: any = this._translateService.get(
                'order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}',
                {
                    min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue,this.storeInfo),
                    max: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue,this.storeInfo)
                });
                if(this.appConfig.displayMinValidation){
                    invalidProductPopup = this._translateService.get(
                        'order.Your cart must be a minimum amount of {{min}}',
                        {
                            min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue,this.storeInfo)
                        });
                }
            if (this._enrollmentCommonService.validateSubTotalBasedOnType(this.products, this.orderRules, subTotal,this.isOverrideMinimumLimit)) {
                this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                return false;
            } else {
                this._commonService.removeNotification(Constants.MIN_LIMIT);
            }
        }
        const totalPoints = this._enrollmentCommonService.calculateTotalPoints(this.products);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints > this.orderRules.maxValue)) {
            const exceedPerOrderCC: any = this._translatePipe.get('order.Cart contains a case credit value above the limit',
                {
                    limit: this.orderRules.maxValue
                });
            this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
            return false;
        } else {
            this._commonService.removeNotification(Constants.MAX_EXCEEDED);
        }
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            const totalCC = totalPoints;
            const validations = this._commonService.validateSubTotalBasedOnBothPriceAndCC(
                this.orderRules, this._enrollmentCommonService.isLiteratureValidation(this.products, this.orderRules), subTotal, totalCC
            );
            if ((validations.cartLimitExceed || validations.cartLimitNotReach) && !quantityUpdate) {
                const isLiteratureValidation = this._enrollmentCommonService.isLiteratureValidation(this.products, this.orderRules);
                const invalidProductPopup: any = this._translateService
                    .get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}',
                        {
                            min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue,this.storeInfo),
                            max: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue,this.storeInfo)
                        });
                this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                return false;
            } else if (validations.monthlyCCValid || validations.thresholdCrossed) {
                const exceedMonthlyCCPopup: any = this._translatePipe
                    .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                this._commonService.createNotification('', exceedMonthlyCCPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                return false;
            } else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            }
        }
        if(this.checkoutConfig.enableMonthlyCCLimitRules){
            const totalCC = totalPoints;
            if (this.orderRules &&  totalCC > this.orderRules.maxCCValue) {
                const exceedMonthlyCCPopup: any = this._translatePipe
                    .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                const monthlyCCContent =  exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">' + this.orderRules.maxCCValue + '</b>';
                this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                return false;
            } else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            } 
        }
        return true;
    }

    /**
     * @description this method will process meber
     * enrollment request
     * @param {EnrollInfo} enrollRequest
     * @memberof OrderCreateFPCComponent
     */
    async placeEnrollRequest(isFPCPurchaseOverrideEnabled?:boolean) {
        let itemNumber;
        let revisionNumber;
        let new_RevisionNumber;
        const isValid = isFPCPurchaseOverrideEnabled !=null && isFPCPurchaseOverrideEnabled === true ? isFPCPurchaseOverrideEnabled:this.validateOrderLimit(false);
        if (!isValid) {
            this.isSubmitted = false;
            return;
        }
        const enrollRequest: EnrollSession = this.prepareEnrollSessionRequest();
        if (enrollRequest && enrollRequest.enrollInfo && enrollRequest.enrollInfo.orderInfo && (enrollRequest.enrollInfo.orderInfo.orderShippings[0].shipMethodId == null || enrollRequest.enrollInfo.orderInfo.orderShippings[0].shipMethodId == undefined )) {
            const notification: any = this._translatePipe.get('order.Please Select shipping method.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;

        }
        if(!(enrollRequest && enrollRequest.enrollInfo && enrollRequest.enrollInfo.orderInfo && enrollRequest.enrollInfo.orderInfo.taxMetaData) && this.isTaxMetaDataAvailable){
            const notification: any = this._translatePipe.get('order.Tax is not mapped. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
            return;
        }
        const compareTaxValues = this._enrollmentCommonService.compareTax(enrollRequest.enrollInfo.orderInfo, this.storeInfo, this.appConfig);
        if (compareTaxValues) {
            if (this.personalInformation) {
                let isProductRevisionNumberMatch = true;              
                if(isFPCPurchaseOverrideEnabled ==null || !isFPCPurchaseOverrideEnabled){
                    let recentlyViewedProducts = await this.getRecentlyviewedProducts(enrollRequest.enrollInfo.orderInfo);
                    if (recentlyViewedProducts) {
                        if(recentlyViewedProducts && recentlyViewedProducts.length>0){
                            recentlyViewedProducts.forEach(recentProduct => {
                                enrollRequest.enrollInfo.orderInfo.orderLineItems.forEach(product=>{
                                    if(product.revisionNumber === recentProduct.revisionNumber ){
                                      //  isProductRevisionNumberMatch = true;

                                    }else{
                                        isProductRevisionNumberMatch = false;
                                        itemNumber = product.itemNumber;
                                        revisionNumber = product.revisionNumber;
                                        new_RevisionNumber = recentProduct.revisionNumber;
                                        return;
                                    }
                                });
                            });
                        } 
                    }
                }
                if(isProductRevisionNumberMatch){
                    const transliteratedProps = this._commonService.mapTransliterateProperties(this.storeInfo, this.orderFormGroup.get('language').value);            
                this._enrollService.createEnrollRequest(enrollRequest.enrollInfo, transliteratedProps).subscribe(
                    (fpcCreateResponse: EnrollInfo) => {
                        if (fpcCreateResponse && fpcCreateResponse.validations && fpcCreateResponse.validations.length > 0) {
                            this.isSubmitted = false;
                            this.returningFPCUser = null;
                            this.mailAlreadyExist = true;
                            this._enrollmentMessageService.setIsEmailAlreadyExists(true);
                            this._commonService.createNotification('', fpcCreateResponse.validations[0].message, NotificationType.ERROR);
                        } else {
                            this.enrollmentSuccess(fpcCreateResponse);
                        }
                    }, (errorResponse: any) => {
                        this.displayErrorMessage(errorResponse);
                    });
            }
            else{
                const notification: any = this._translatePipe.get('order.Product revision number mismatch,'+' Item : '+itemNumber+', Revision Number : '+ revisionNumber+', New Revision Number : '+ new_RevisionNumber);
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isSubmitted = false;
            }
        }

        } else {
            const notification: any = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
    }

    /**
     * @description To Handle create/update enrollment success response
     * @private
     * @param {EnrollInfo} fpcResponse
     * @memberof OrderCreateFPCComponent
     */
    private enrollmentSuccess(fpcResponse: EnrollInfo): void {
        if (fpcResponse && fpcResponse.personalInfo && fpcResponse.personalInfo.memberId) {
            const key = this.orderFormGroup.value.orderType === this.orderTypeFPC
                ? MemberActivityLogType.New_FPC_Created : MemberActivityLogType.New_Retail_Created;
            this.saveMemberActivityLog(fpcResponse.personalInfo.memberId, key);
        }
        setTimeout(() => {
            this.displayOrderSuccessDetails(fpcResponse);
        }, 2000);
    }

    saveMemberActivityLog(memberId: number, key: MemberActivityLogType): void {
        const activityLogKeys: ActivityLogKey[] = [];

        if(key === MemberActivityLogType.Override_Minimum_Limit){
            activityLogKeys.push({
                key:MemberActivityLogType.Override_Minimum_Limit,
                value:Constants.OVERRIDE_MINIMUM_LIMIT
            })
        }
        else{
            activityLogKeys.push({
                key: key,
                value: this._enrollmentCommonService.prepareDocumentCheckActivityLogValue(this.agreementDocuments)
            });
        }
        this._commonService.saveMemberActivity(memberId, activityLogKeys).subscribe();
    }

    /**
     * @description this method will display order details
     * @param {EnrollInfo} enrollRequest
     * @memberof OrderCreateFPCComponent
     */
    displayOrderSuccessDetails(fpcCreateResponse: EnrollInfo): void {
        const shippingLogInfo = this._enrollmentCommonService.getShippingLogInfo(this.storeInfo,
                this.orderFormGroup, this.shippingCost, this.shippingTax, this.originalShippingCost, false,
            (this.checkoutConfig ? this.checkoutConfig.calculateTaxExclusivePrice : false), this.appConfig, false);
        if (fpcCreateResponse && fpcCreateResponse.orderInfo && fpcCreateResponse.orderInfo.webOrderId) {
            fpcCreateResponse.webOrderId = fpcCreateResponse.orderInfo.webOrderId;
            fpcCreateResponse.id = fpcCreateResponse.orderInfo.id;
            if (shippingLogInfo) {
                this.createOrderLog(fpcCreateResponse, shippingLogInfo);
            }
            this.createOrderLog(fpcCreateResponse);
            this.sendPasswordResetLink(fpcCreateResponse);
            this.orderSuccess(fpcCreateResponse);
            this.isSubmitted = false;
        } else if (fpcCreateResponse && fpcCreateResponse.personalInfo && fpcCreateResponse.isSuccess) {
            if (fpcCreateResponse.personalInfo.memberContacts && fpcCreateResponse.personalInfo.memberContacts.length > 0) {
                this.signUpEmail = this._enrollmentCommonService.getSignupEmail(fpcCreateResponse);
                this.openAccountConfirmationTab(this.signUpEmail);
            }
            this.sendPasswordResetLink(fpcCreateResponse);
            this.enrollmentSuccessRefreshScreen();
        }
    }

    /**
     * @description
     * @private
     * @returns {EnrollSession}
     * @memberof OrderCreateFPCComponent
     */
    private prepareEnrollSessionRequest(): EnrollSession {
        if (this.sponsorInformation) {
            this.sponsorInformation.memberCommunicationPreferences = this.memberCommunicationPreferences;
        }
        const personalInfo: PersonalInfo = this._enrollService.preparePersonalInfo(this.storeInfo,
            this.orderFormGroup.value.language || this.storeDefaultLanguage,
            this.personalInformation, this.shippingAddressInfo, this.countryCode, this.orderFormGroup.value.countryId,
            this.sponsorInformation, this.agreementDocuments, this.memberInfo, this.memberTypeId,
            null, this.mailingAddress, null, null, this.bonusInformation, true, this.bonusInfoAgreements);
        personalInfo.pass_word = Randomize('A0a', 12);
        personalInfo.loginPassword = personalInfo.pass_word;
        const enrollSession: EnrollSession = {
            enrollInfo: {
                personalInfo: personalInfo,
                orderInfo: this.products && this.products.length > 0 ? this.prepareOrderRequest() : null,
                shoppingCartInfo: null,
                sponsorId: this.sponsorInformation ? this.sponsorInformation.sponsorId : '',
                sponsorInfo: this.sponsorInformation
            },
            sponsorId: this.sponsorInformation ? this.sponsorInformation.sponsorId : ''
        };
        const sessionGuid = this._cacheService.getSessionValue(CacheKey.SessionGuid);
        if(sessionGuid){
            enrollSession.enrollInfo.personalInfo.sessionGuid = sessionGuid;
        }
        return enrollSession;
    }


    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderCreateFPCComponent
     */
    getPersonalInfo(event): void {
        this.personalInformation = event.personalInformation;
        this.personalInfoFormValid = event.personalInfoFormValid;
        this.returningFPCUser = event.userInfo;
        if (this.personalInformation) {
            this.paymentComponentSettings.memberEmail = this.personalInformation.email;
        }
    }

    /**
     * @description get mail already exists or not
     * @param {*} event
     * @memberof OrderCreateFPCComponent
     */
    getMailAlreadyExixts(event): void {
        this.mailAlreadyExist = event;
    }

    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderCreateFPCComponent
     */
    getPersonalInfoFormStatus(event): void {
        this.personalInfoFormValid = event.personalInfoFormValid;
        this.liveFormPersonalInfo = event.personalInformationForm.value;
        if (this.mailingAddress && !this.shippingAddressInfo) {
            if ((!this.participatingCountry || this.isParticipatingCountrySameAsStore) || this.checkoutConfig.isParticipatingCountryShippingEnabled) {
                this.prepopulateShippingAddress();
            } else {
                this.prePopulateDetails();
            }
        }
        this.verifyAccountExistence();
    }

    /**
     * @description  this method is used to
     * get the verified or sugggested address
     * @param {Address} mailingAddress
     * @memberof OrderCreateFPCComponent
     */
    getMailingAddressInfo(address: Address): void {
        this.mailingAddress = address;
        this.getAddressOnInputChange(address);
        this.setBonusInformation();
        this.verifyAccountExistence();

    }

    private verifyAccountExistence() {
        if (this.liveFormPersonalInfo && this.mailingAddress) {
            const verifyAccountModel: VerifyAccountModel = this._enrollmentCommonService.prepareVerifyAccountRequest(
                this.liveFormPersonalInfo, this.mailingAddress);
            this._customerService.validateMemberUniqueFieldsWithAddress(verifyAccountModel)
                .subscribe((response: VerifyAccountModel) => {
                    if (response && !response.accountExists) {
                        this.accountVerified = true;
                    } else if (response && response.accountExists) {
                        this.accountVerified = false;
                        this.showAccountExistsMessage();
                    }
                }, err => { });
        }
    }
    showAccountExistsMessage() {
        const msg = this._translatePipe.get('order.Combination of First name, Last name, Address already exist')['value'];
        this._commonService.createNotification('', msg, NotificationType.ERROR);
    }

    /**
     * @description to rebind the selected sponsor wizard options and values
     * @param {string} requestUrl
     * @memberof OrderCreateFPCComponent
     */
    rebindSponsorOptions(rebindSponsorData: RebindSponsorData): void {
        this.rebindSponsorData = rebindSponsorData;
    }

    /**
     * create order log request parameter
     */
    createOrderLog(res, message?: string) {
        const orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': res.id,
            'webOrderId': res.webOrderId,
            'message': message ? message : 'Order Placed by the agent',
            'source': Constants.CUSTOMER_SERIVCE
        };
        // this._orderService.createOrderLog(orderLogRequest).subscribe((response) => {   },
        //  (error: any) =>
        //   {
        //    this._commonService.createNotification('', 'Failed to Create order log', NotificationType.ERROR);
        // });
    }

    private orderSuccess(response: any) {
        const subTotal=this.calculateItemsSubTotal(this.storeInfo);
        this.isOverrideMinimumLimit && this.hasMinimumOverrideLimit && subTotal <=this.orderRules.minValue ? this.saveMemberActivityLog(response.personalInfo.memberId,MemberActivityLogType.Override_Minimum_Limit):false;
        this.showSelectedShipMethod = false;
        this.paymentComponentSettings.webOrderId = response.webOrderId;
        this.paymentComponentSettings.orderReferenceId = response.id;
        this.openOrderViewTab(this.paymentComponentSettings.webOrderId);
        this.orderFromLookup = false;
        this.clearFPCFormDetails();
        this.clearAllTheForms(true, true, true);
        this.isSubmitted = false;
        this.clearFPCForm();
        this.onSelectNewFPCCreateFlow();
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.removeSessionGuid();
    }

    enrollmentSuccessRefreshScreen() {
        this.showSelectedShipMethod = false;
        this.orderFromLookup = false;
        this.clearFPCFormDetails();
        this.clearAllTheForms(true, true, true);
        this.clearFPCForm();
        this.onSelectNewFPCCreateFlow();
        this.isSubmitted = false;
        this.paymentComponentSettings = new PaymentComponentSettings();
    }

    /**
     * @description This method used to reset fpc flow details
     * @method clearFPCFormDetails()
     * @memberof OrderCreateFPCComponent
     */
    clearFPCFormDetails() {
        this.orderFormGroup.controls['orderType'].setValue(this.orderTypeFPC);
        this.personalInformation = null;
        this.sponsorInformation = null;
        this.returningFPCUser = null;
        this.mailingAddress = null;
        this.bonusInformation = null;
        this.bonusInfoAgreements = [];
        this.liveFormAddress = null;
        this.agreementDocuments = [];
    }

    openOrderViewTab(weborderID: string) {
        const orderInfo = new OrderInfoTab();
        orderInfo.webOrderID = weborderID;
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode;
        orderInfo.newOrder = true;
        this.messageService.setOrderHistoryTab(orderInfo);
    }

    openAccountConfirmationTab(emailID: string) {
        const orderInfo = new OrderInfoTab();
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode;
        orderInfo.newOrder = true;
        orderInfo.emailID = emailID;
        this.messageService.setOrderHistoryTab(orderInfo);
    }

    prepareOrderRequest(): any {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        const shippingAddress = this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo, this.pudoShippingAddressInfo,this.selectedCountryCodeTwo,
            this.orderFormGroup.value,this.countries,this.storeInfo.foreverDirectEnabled);
        if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === shippingAddress.countryId);
            this.countryTaxInclusive = this._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
        }
        const shippingTax = this._enrollService.prepareShippingTax(this.orderTaxResponse) || this.shippingTax;
        const paymentMethodType = this._enrollmentCommonService.getPaymentMethodById(+this.orderFormGroup.controls['paymentSelector'].value);
        const shippingObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === this.orderFormGroup.value.shipMethodId)[0];
        const orderRequest: any = {
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: OrderStatus.Pending,
            memberId: null,
            email: this.memberInfo ? this.memberInfo.email : this.personalInformation ? this.personalInformation.email : null,
            languageCode: this._enrollmentCommonService.getLanguageCultureCode(this.storeLanguages, this.orderFormGroup),
            storeId: this.storeInfo.id,
            paymentMode: paymentMethodType && paymentMethodType == PaymentMethodTypes.Pay_By_Link ? paymentMethodType : null,
            orderTypeId: this._enrollmentCommonService.getOrderTypeId(this.orderFormGroup.controls['orderType'].value),
            memberLevelId: this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value),
            shippingCost: this._enrollmentCommonService.getTaxExclusiveShippingCost(this.shippingCost,
                this.orderFormGroup.value.isShippingDiscountApplied, this.orderFormGroup, false),
            importFeeValue: this.importFeeValue,
            retailDeliveryFee: this.retailDeliveryFee,
            shippingTax: (this.appConfig && this.appConfig.enableVatItemizationForNonVat) ? shippingTax : (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) || (this.appConfig && this.appConfig.displayTaxInclusivePrice)? 0 : shippingTax,
            distrubutorId: null,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: OrderSourceTypes.CUSTOMERSERVICE,
            orderNotes: null,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive, this.appConfig),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: this.getOrderPaymentInfo(),
            shippingAddressModel: shippingAddress,
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            loggedInUserId: this.userInfo ? this.userInfo.userId : null,
            loggedInUserName: this.userInfo ? this.userInfo.userName : null,
            taxMetaData: this.orderTaxResponse ? this.orderTaxResponse.taxMetaData : null,
            erpTaxMetaData: this.orderTaxResponse ? this.orderTaxResponse.erpTaxMetaData : null,
            priceTierName: this._enrollmentCommonService.getPriceTier(this.products),
            wholesaleQualified: this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false,
            memberTypeId: this._enrollmentCommonService.getMemberTypeId(this.orderFormGroup.controls['orderType'].value),
            sponsorId: this.memberInfo ? this.memberInfo.sponsorId : this.sponsorInformation
                ? this.sponsorInformation.sponsorId : this.returningFPCUser ? this.returningFPCUser.sponsorId : null,
            personalDiscountPercentage: this._commonService.getDiscountPerc(this.memberDiscountPercentage),
            memberLevelDiscount: this._commonService.getDiscountPerc(this.memberDiscountPercentage),
            wholesaleQualifiedDiscount: 0,
            optIn: false,
            vatRegistered: false,
            memberDiscountOfferModel: this.getMemberDiscountOfferModel(),
            vatID: null,
            coldProtection: shippingObj ? shippingObj.coldProtection : false,
            firstName: this.personalInformation && this.personalInformation.firstName ? this.personalInformation.firstName : this.memberInfo.firstName,
            lastName: this.personalInformation && this.personalInformation.lastName ? this.personalInformation.lastName : this.memberInfo.lastName,
            languageCulture: this.languageCulture,
            paymentLinkEmail: this.emailForm.value.payByLinkEmail,
            overrideMinimumLimit:this.isOverrideMinimumLimit,
            sourceTypeId: 5,
            freeShippingPromotionOrder:shippingObj ? shippingObj.freeShippingEligible: false,
            retailFreeShippingOrder: 0
        };
        if(shippingObj && shippingObj.freeShippingEligible){
            orderRequest.shippingCost = 0;
            // setting actual shipping cost
            orderRequest.retailFreeShippingCost = shippingObj.originalShippingCost;
        }
        return orderRequest;
    }

    /**
     * @description to create Freeshipping for fpc Second Order
     * @author Akhil
     * @date 2021-03-11
     * @returns
     * @memberof OrderCreateFPCComponent
     */
    getMemberDiscountOfferModel() {
        if (this.memberTypeId === MemberTypeEnum.FPC && this.appConfig && this.checkoutConfig.freeShippingFPCOrder) {
            const currentDate = new Date();
            const effectiveEndDate = new Date();
            effectiveEndDate.setDate(effectiveEndDate.getDate() + environment.freeShippingExpiryDays);
            const memberDiscountOfferModel: any = {
                discountPercentage: 100,
                discountTypeID: DiscountType.ShippingDiscount,
                effectiveStartDate: moment(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()))
                    .format(DateConstants.DOBFormat),
                effectiveEndDate: moment(new Date(effectiveEndDate.getFullYear(), effectiveEndDate.getMonth(), effectiveEndDate.getDate()))
                    .format(DateConstants.DOBFormat)
            };
            return memberDiscountOfferModel;
        }
    }

    /**
      * @returns OrderLineItem
      */
    private getOrderLineItems(countryTaxInclusive: boolean, apConfig?:AppCountryConfig): any[] {
        const orderLineObject = {
            products: this.products,
            countryTaxInclusive: countryTaxInclusive,
            displayPriceConfig: this.displayPriceConfig,
            orderTaxResponse: this.orderTaxResponse,
            checkoutConfig: this.checkoutConfig,
            storeInfo: this.storeInfo
        };

        return this._enrollmentCommonService.getOrderLineItems(orderLineObject, apConfig);
    }

    private getOrderShippings(): any[] {
        const orderShippingObject: any = {
            savedAddressId: this.savedAddressId,
            verifiedShippingAddressId: this.verifiedShippingAddressId,
            orderFormGroup: this.orderFormGroup,
            shipMethod: this.shipMethod,
            originalShippingCost: this.originalShippingCost,
            shippingCost: this.shippingCost,
            shippingTax: (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) ? 0 : this.shippingTax,
            distributionCenterName: this.shipMethods.distributionCenterName,
            memberShippingDiscountOfferEligible: false,
            isVATRegistered: false
        };
        const shippingObj = this.shippingMethods.find((shipMethod: any) => shipMethod.shippingMethodId == this.orderFormGroup.value.shipMethodId);
        if (shippingObj && shippingObj.freeShippingEligible && shippingObj.promotionId) {
            const orderPromotionTrackingList = [{
                promotionID: shippingObj.promotionId
            }];
            orderShippingObject.orderPromotionTrackingList = orderPromotionTrackingList;
        }

        return this._enrollmentCommonService.getOrderShippings(orderShippingObject,this.appConfig,false);
    }
    /**
      * @returns payment method
      */
    private getPaymentMethodById(paymentMethodId: number): any {
        let paymentType: string;
        switch (paymentMethodId) {
            case this.paymentTypeEnum.Credit_Card:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            // case this.paymentTypeEnum.eCheck:
            //     paymentType = PaymentMethodTypes.eCheck;
            //     break;
            case this.paymentTypeEnum.Money_order:
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case this.paymentTypeEnum.Cash:
                paymentType = PaymentMethodTypes.Cash;
                break;
            case this.paymentTypeEnum.Ideal:
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case this.paymentTypeEnum.PayPal:
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case this.paymentTypeEnum.Cash_On_Delivery:
                paymentType = PaymentMethodTypes.Cash_On_Delivery;
                break;
            case this.paymentTypeEnum.Orange_Money:
                paymentType = PaymentMethodTypes.Orange_Money;
                break;
            case this.paymentTypeEnum.Bank_Transfer:
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            case this.paymentTypeEnum.Wire_Transfer:
                paymentType = PaymentMethodTypes.Wire_Transfer;
                break;
            case this.paymentTypeEnum.eCheck:
                paymentType = PaymentMethodTypes.eCheck;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;

        }
        return paymentType;
    }

    getAddresses(): any {
        let countryObj: any = null;
        if (this.countryCode) {
          countryObj = this.countries.filter((x: any) => x.isocodeThree === this.countryCode)[0];
        }
        const addressObject = {
            orderFormGroup: this.orderFormGroup,
            shipMethod: this.shipMethod,
            countries: this.countries,
            states: this.states,
            deliveryPreference: this.deliveryPreference,
            countryCode: this.countryCode,
            shippingAddressInfo: this.shippingAddressInfo,
            selectedCountryCodeTwo: this.selectedCountryCodeTwo,
            billingAddressInfo: this.billingAddressInfo?this.billingAddressInfo:(this.mailingAddress?this.mailingAddress:(this.shippingAddressInfo?this.shippingAddressInfo:null)),
            selectedpudoAddress:this.selectedPudoCollectionPoint ? this.selectedPudoCollectionPoint:null,
            storeInfo:this.storeInfo?this.storeInfo:null,
            countryId: this.selectedIsoCountryCode? this.selectedIsoCountryCode:null,
            pudoShippingAddressInfo:this.pudoShippingAddressInfo ? this.pudoShippingAddressInfo :  null
        };
        return this._enrollmentCommonService.getAddresses(addressObject, this.storeInfo.foreverDirectEnabled);
    }

    calculateOrderTotal(): number {
        let totalCost = 0;
        let itemsTotalTax = 0;
        let calculateVatTax = true;
        for (let i = 0; i < this.products.length; i++) {
            if (!this.countryTaxInclusive) {
                itemsTotalTax += this.products[i].tax;
            }
        }
        if (this.memberInfo && this.memberInfo.vatRegistered
            && this.countryTaxInclusive) {
            if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
                calculateVatTax = false;
            }
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) +
                (this.getShippingCostForOrderSummary() || 0) + (calculateVatTax ? this.taxableAmount || 0 : 0);
        } else {
            if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
                calculateVatTax = this.memberInfo && (!this.memberInfo.vatRegistered && this.memberInfo.memberTypeId === MemberTypeId.DISTRIBUTOR) ? true : false;
            }
            const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) +
                (this.getShippingCostForOrderSummary() || 0) +
                ((this.countryTaxInclusive === false || isCalculateTaxExclusivePrice) ? (calculateVatTax ? this.taxableAmount || 0 : 0) : 0);
        }
        if (this.storeInfo) {
            // tslint:disable-next-line:no-bitwise
            totalCost = Number(totalCost.toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
        }
        this.itemTotal= totalCost - this.itemShippingCost;
        return totalCost;
    }



    /**
   * @param  {any} shippingInfo
   * @returns void
   */
    calculateOrderTax(): void {
        this.taxCalculationStatus = true;
        this.orderTaxResponse = null;
        if (this.storeInfo && this.products && this.products.length > 0 && this.orderFormGroup.value.shipMethodId) {
            const taxRequest: TaxRequest = this.prepareTaxRequest();
            if (taxRequest && taxRequest.fromAddress && taxRequest.toAddress) {
                this._orderService.calculateOrderTax(taxRequest)
                    .subscribe((taxResponse: any) => {
                        if (taxResponse && taxResponse.success) {
                            this.isTaxMetaDataAvailable = taxResponse.taxMetaData?  true : false;
                            if (taxResponse.cart && taxResponse.cart.totalTax >= 0) {
                                taxResponse.cart.totalTax = this._currencyPipe.getFormatedCurrency(taxResponse.cart.totalTax, this.storeInfo);
                                this.orderTaxResponse = taxResponse;
                                this.taxableAmount = taxResponse.cart.totalTax;
                                this.retailDeliveryFee = taxResponse.cart.retailDeliveryFee ? taxResponse.cart.retailDeliveryFee : 0;
                                if (this.orderTaxResponse && this.orderTaxResponse.taxMetaData
                                    && this.orderTaxResponse.taxMetaData.orderTaxCharges
                                    && this.orderTaxResponse.taxMetaData.orderTaxCharges.length > 0) {
                                    const gst = this.orderTaxResponse.taxMetaData
                                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.GST_TAX);
                                    const pst = this.orderTaxResponse.taxMetaData
                                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.PST_TAX);
                                    this.gstTax = gst ? gst.taxAmount : 0;
                                    this.pstTax = pst ? pst.taxAmount : 0;
                                    if (this.countryTaxInclusive) {
                                        const shippingLineItem = this.orderTaxResponse.taxMetaData
                                            .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.NOR && tax.lineNo === 0);
                                        if (shippingLineItem && this.orderFormGroup.controls['shippingCostSelector'].value != this.selectEnum.secondOption.toString() && this.orderFormGroup.controls['shippingCostSelector'].value != this.selectEnum.thirdOption.toString()) {
                                            this.shippingTax = shippingLineItem.taxAmount;
                                        }
                                    }
                                }
                            }
                            setTimeout(() => {
                                this.taxCalculationStatus = false;
                            }, 500);
                        }
                    },
                        (error: any) => {
                            if (error) {
                                const taxResponse = error;
                                if (taxResponse && taxResponse.validations && taxResponse.validations.length > 0) {
                                    if((taxResponse.validations.map(validation => validation.name).indexOf(CommonConstant.Order_Tax))>-1) {
                                        const notification: any = this._translatePipe.get('order.Tax cannot be calculated now. Please try again later.');
                                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                                    }
                                    else {
                                        const notification: any = this._translatePipe.get('order.' + taxResponse.validations[0].message);
                                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                                    }
                                }
                            }
                        });
            }

        }
    }

    private prepareTaxRequest(): TaxRequest {
        const taxRequest: TaxRequest = {
            orderID: 0,
            memberID: 0,
            shopingCart: this.mapCartToTaxCart(),
            fromAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                this._enrollmentCommonService.getPickUpAddress(this.shipMethod, this.orderFormGroup.value.deliveryPreference, this.countries,
                    this.states, this.selectedIsoCountryCode) :
                this._enrollmentCommonService.getShippingMethodWarehouseAddress(this.shipMethod),
            toAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP)
                ? this._enrollmentCommonService.getPickUpAddress(this.shipMethod, this.orderFormGroup.value.deliveryPreference, this.countries,
                    this.states, this.selectedIsoCountryCode) :(this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP)?this.getPudoCollectPointAddress(): this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo,
                        this.pudoShippingAddressInfo,this.selectedCountryCodeTwo, this.orderFormGroup.value,this.countries),
            memberNumber: 0,
            orderNumber: 0,
            storeID: this.storeInfo.id,
            priceTierName: this._enrollmentCommonService.getPriceTier(this.products),
            currencyCode: this.storeInfo.currencyCode,
            countryCode: this.selectedIsoCountryCode.toLowerCase(),
            deliveryTypeId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                ShippingType.PICKUP : ShippingType.DELIVERY,
            orderSource: 'CUSTOMER SERVICE',
            orderTypeId: this._enrollmentCommonService.getOrderTypeId(this.orderFormGroup.controls['orderType'].value),
            conversionRate: 1,
            memberLevelId: this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value),
            wholesaleQualified: false,
            isDiscountedShipping: this.orderFormGroup.value.isShippingDiscountApplied,
            memberType: MemberTypeEnum[this.memberTypeId],
            vatRegistered: false
        };
        return taxRequest;
    }
    /**
      * @returns TaxCart
      */
    private mapCartToTaxCart(): any {
        const taxCart: any = {
            shippingTax: 0,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingCost: this._enrollmentCommonService.getTaxExclusiveShippingCost(this.shippingCost,
                this.orderFormGroup.value.isShippingDiscountApplied, this.orderFormGroup, false),
            importFeeValue: this.importFeeValue || 0,
            importFeeEnabled: this.importFeeEnabled,
            orderLineItems: this.mapItemstoTaxItems()
        };
        return taxCart;
    }

    /**
     * @returns CartItems
     */
    private mapItemstoTaxItems(): any[] {
        const address = (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod
            && this.shipMethod.pickUpLocation) ?
            this._enrollmentCommonService.getPickUpAddress(this.shipMethod, this.orderFormGroup.value.deliveryPreference, this.countries,
                this.states, this.selectedIsoCountryCode) :
            this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo,this.pudoShippingAddressInfo, this.selectedCountryCodeTwo,
                this.orderFormGroup.value,this.countries);
        if (this.products && this.products.length > 0) {
            if (address && address.countryId && this.countries && this.countries.length > 0) {
                const country = this.countries.find(x => x.countryId === address.countryId);
                this.countryTaxInclusive = this._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
            }
        }
        const mapCartToTaxCartObject: any = {
            products: this.products,
            countryTaxInclusive: this.countryTaxInclusive,
            checkoutConfig: this.checkoutConfig,
            address: address
        };
        return this._enrollmentCommonService.mapItemstoTaxItems(mapCartToTaxCartObject,true);
    }

    setFocusbyID(id) {
        setTimeout(() => {
            const element = document.getElementById(id) as HTMLInputElement;
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    }
    moveToItemLevelSearchBlock(event: any) {
        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
            this.itemLevelSearch.nativeElement.focus();
        }
    }

    /**
     * @description item number search in table
     * @param {*} event
     * @memberof OrderCreateFPCComponent
     */
    itemLevelSearchEvent(event: any) {
        if (event.currentTarget.value) {
            this.taxCalculationStatus = true;
            const notification: any = this._translatePipe.get('order.Invalid Item Number');
            if (this.appConfig
                && this.appConfig.hideFPCEnrollmentItem && environment.hideFPCEnrollmentItem
                && event.currentTarget.value.trim() === environment.hideFPCEnrollmentItem) {
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            } else {
                this.observableSource(event.currentTarget.value, true).subscribe((products) => {
                    const responseproducts = products;
                    if (responseproducts.length > 0) {
                        const product = responseproducts[0];
                        const isStockAvailable = this._enrollmentCommonService.stockAvailable(product);
                        let productIndex = -1;
                        if (isStockAvailable) {
                            let items: any = this.orderFormGroup.get('items');
                            if (items && items.length >= 0) {
                                const sameProductIndex = items.controls.findIndex(item =>
                                    item.controls['productNumber'].value === product.itemNumber);
                                productIndex = sameProductIndex;
                                if (sameProductIndex >= 0) {
                                    if (+items.controls[sameProductIndex].controls['quantity'].value < 999) {
                                        items.controls[sameProductIndex].controls['quantity']
                                            .setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                                        this.setFocusbyID('quantity-' + (sameProductIndex));
                                    }
                                } else {
                                    this.addItemNumber();
                                    const index = (items.length - 1);
                                    productIndex = index;
                                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                    if (!items.controls[index].controls['quantity'].value) {
                                        items.controls[index].controls['quantity'].setValue(1);
                                    }
                                    items.controls[index].controls['quantity'].updateValueAndValidity();
                                    items = this._enrollmentCommonService.addNewProductItem(items, index, product,
                                        environment.uiTemplateBaseUrl, environment.cdnURL);
                                    this.setFocusbyID('quantity-' + (items.length - 1));
                                }
                            }
                             const isDepositFeeProductEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                            if (isDepositFeeProductEnabled) {
                                this.getDepositFeeProduct(product);
                            }
                            this.updateTotalsAndShipMethod(false);
                            //New Promotion Engine logic
                                this.clickTimeout[items.controls[productIndex].controls['productId'].value] =
                                setTimeout(() => {
                                    //New logic to bind promtoion product from promotion engine
                                    const freeProductsInfo = this.validatePromotionCriteria(product);
                                    const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                                    //const productIds: number[] = freeProductsInfo.map((product) => product = product.productId);
                                    if (productIds && productIds.length) {
                                        this.addPromotionEngineProducts(productIds, freeProductsInfo);
                                    } else {
                                        this.updateTotalsAndShipMethod();
                                    }
                                }, 500);
                            if (this.orderFormGroup.controls['orderType'].value === OrderType.POS
                                || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                this.deliveryPreferenceOnChange();
                            }
                          
                        } else {
                            this._commonService.createNotification('', 'Out of stock - '
                                + (product.name || ''), NotificationType.ERROR);
                            if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                                this.itemLevelSearch.nativeElement.focus();
                            }
                            this.taxCalculationStatus = false;
                        }
                    } else {
                        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                            this.itemLevelSearch.nativeElement.focus();
                        }
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                    this.itemLevelSearch.nativeElement.value = '';
                });
            }
        }
    }


    getDepositFeeProduct(searchProduct: Product, loadProducts?: boolean) {
        let depositFeeProduct: Product = null;
        const productAssociation = this.productAssociationInfo.find(x => x.productId === searchProduct.id);
        if (productAssociation) {
            depositFeeProduct = this.depsoitFeeProductsInfo.find(x => x.id === productAssociation.depositFeeProductId);
            if (depositFeeProduct) {
                depositFeeProduct.productQuantity = 1;
                if(!loadProducts){
                    this.onItemSelect(depositFeeProduct);
                }
            }
        } else {
            this._customerService.getRelatedProducts(this.storeId, searchProduct.id, 2,  MemberTypeId.DISTRIBUTOR, this.countryCode, this.storeDefaultLanguage, PurchaseFlows.FPC5PERCENT, this.storeInfo.taxInclusive, false, false)
                .subscribe(response => {
                    if (response && response.length) {
                        depositFeeProduct = response[0];
                        const depositFeeProductInfo = this.depsoitFeeProductsInfo.find(x => x.id === depositFeeProduct.id);
                        this.productAssociationInfo.push({
                            productId: searchProduct.id,
                            depositFeeProductId: depositFeeProduct.id
                        });
                        if (!depositFeeProductInfo) {
                            this.depsoitFeeProductsInfo.push(depositFeeProduct);
                        }
                        if(!loadProducts){
                            this.onItemSelect(depositFeeProduct);
                        }
                    }
                });
        }
    }

    /**
     * @description auto complete search
     * @memberof OrderCreateFPCComponent
     */
    onItemSelect(depositFeeProduct?: Product) {
        const searchProduct = depositFeeProduct? depositFeeProduct : this.orderFormGroup.controls['itemSearch'].value;
        if (searchProduct && searchProduct.id) {
            const isStockAvailable = this._enrollmentCommonService.stockAvailable(searchProduct);
            if (isStockAvailable) {
                let items: any = this.orderFormGroup.get('items');
                if (items && items.length >= 0) {
                    this.taxCalculationStatus = true;
                    const sameProductIndex = items.controls.findIndex(item => item.controls['productNumber'].value ===
                    searchProduct.itemNumber);
                    const isDepositFeeProductEnabled = searchProduct.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                    if (isDepositFeeProductEnabled) {
                        this.getDepositFeeProduct(searchProduct);
                    }
                    if (sameProductIndex >= 0) {
                        if (+items.controls[sameProductIndex].controls['quantity'].value < 999) {
                            items.controls[sameProductIndex].controls['quantity'].setValue(
                                +items.controls[sameProductIndex].controls['quantity'].value + 1);
                            this.updateTotalsAndShipMethod();
                            this.orderFormGroup.controls['itemSearch'].setValue('');
                            this.setFocusbyID('quantity-' + (sameProductIndex));
                            items.controls[sameProductIndex].controls['disableDecrement'].setValue(false);
                        }
                    } else {
                        this.addItemNumber();
                        const index = (items.length - 1);
                        items.controls[index].controls['quantity'].setValidators([Validators.required]);
                        if (!items.controls[index].controls['quantity'].value) {
                            items.controls[index].controls['quantity'].setValue(1);
                        }
                        items.controls[index].controls['quantity'].updateValueAndValidity();
                        if (this.orderFormGroup.controls['itemSearch'].value) {
                            const typHeadItem = this.orderFormGroup.controls['itemSearch'].value;
                            this.orderFormGroup.controls['itemSearch'].setValue('');
                            items = this._enrollmentCommonService.addNewProductItem(items, index, typHeadItem,
                                environment.uiTemplateBaseUrl, environment.cdnURL);
                        } else {
                            items = this._enrollmentCommonService.addNewProductItem(items, index, searchProduct,
                                environment.uiTemplateBaseUrl, environment.cdnURL);
                        }
                        clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
                        this.updateTotalsAndShipMethod(false);
                            this.clickTimeout[items.controls[index].controls['productId'].value] =
                            setTimeout(() => {
                                //New logic to bind promtoion product from promotion engine
                                const freeProductsInfo = this.validatePromotionCriteria(searchProduct);
                                const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                                //const productIds: number[] = freeProductsInfo.map((product) => product = product.productId);
                                if (productIds && productIds.length) {
                                    this.addPromotionEngineProducts(productIds, freeProductsInfo);
                                } else {
                                    this.updateTotalsAndShipMethod();
                                }
                            }, 300);
                        this.isFocused = true;
                        this.setFocusbyID('quantity-' + (items.length - 1));
                    }
                }
                if (this.orderFormGroup.controls['orderType'].value === OrderType.POS
                    || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                    this.deliveryPreferenceOnChange();
                }
                
            } else {
                this._commonService.createNotification('', 'Out of stock - '
                    + (this.orderFormGroup.controls['itemSearch'].value.name || ''), NotificationType.ERROR);
                this.orderFormGroup.controls['itemSearch'].setValue('');
                setTimeout(() => {
                    if (this.seachItemElement && this.seachItemElement.nativeElement) {
                        this.seachItemElement.nativeElement.focus();
                    }
                }, 500);
            }
        }
    }

    shippingAddressSelectionChange() {
        this.shippingAddressInfo = this.address && this.address.isSavedAddress ? this.address : null;
        this.address = this.address && this.address.isSavedAddress ? this.address : null;
        this.getShipMethods();

    }

    /**
     * get shipping cost in percentage
     */
    getShippingCostInPercentage() {
        let shippingOriginalCost = this.originalShippingCost;
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['originalShippingCost'].value - this.orderFormGroup.controls['originalShippingTax'].value;
            this.shippingTax = this.orderFormGroup.controls['originalShippingTax'].value;
        } else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
        } else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()) {
            const discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            // if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
            //     shippingOriginalCost = this.originalShippingCost - this.originalShippingTax;
            // }
            shippingOriginalCost = this.originalShippingCost - this.originalShippingTax;
            const shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.originalShippingCost - this.originalShippingTax;
            } else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.getShippingCost();
    }
    /**
     * on chnage on shipping charge selector
     */
    shippingCostChange() {
        const shippingObj = this.shippingMethods.find((shipMethod: any) => shipMethod.shippingMethodId == this.orderFormGroup.value.shipMethodId);
        if (shippingObj && shippingObj.freeShippingEligible && (this.orderFormGroup.controls['shippingCostSelector'].value !== this.selectEnum.firstOption.toString())) {
            this.orderFormGroup.get('shippingCostSelector').setValue(this.selectEnum.firstOption.toString());
            const notification: any = this._translatePipe.get('order.Free shipping is already available for this order, No more discounts allowed');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            if (this.showSelectedShipMethod) {
                this.orderFormGroup.controls['originalShippingCost'].setValue(this.originalShippingCost);
                this.orderFormGroup.controls['originalShippingTax'].setValue(this.originalShippingTax);
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.originalShippingCost - this.originalShippingTax;
            } else {
                this.orderFormGroup.controls['originalShippingCost'].setValue(0);
                this.orderFormGroup.controls['originalShippingTax'].setValue(0);
            }
            this.orderFormGroup.controls['originalShippingCost'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(false);
        } else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
        } else {
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            const discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            let shippingOriginalCost = this.originalShippingCost;
            shippingOriginalCost = this.originalShippingCost - this.originalShippingTax;
            const shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.originalShippingCost - this.originalShippingTax;
            } else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.calculateOrderTax();
    }

    shippingPercentChange(event: any) {
        if (event.keyCode !== 8) {
            const value: any = (this.orderFormGroup.controls['shippingCostPercentage'].value
                ? this.orderFormGroup.controls['shippingCostPercentage'].value : '') + (event.key ? event.key : '');
            const pattern = /^(?:100|[1-9]?[0-9])$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }
    allowOnlyNumbers(event: any) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            const value: any = (event.key ? event.key : '');
            const pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }

    /**
     * Save Shipping Address
     */
    saveShippingAddress(address: Address) {
        this.address = this.mapVerifiedAddressToFormFields(address);
        address.isShowStateCode = this.checkoutConfig.showStateCode;
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            if (!this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
            this.saveAddress(address);
            }
        } else if (this.address && this.address.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === address.countryId);
            this.countryTaxInclusive = this._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
        }
        this.useNewShippingAddress(address);
        const paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
        if(paymentSelectorValue === this.paymentTypeEnum.Pay_By_Link){this.validatePaymentForm();}
        setTimeout(function () {
            const addtoSavedAddressesElement = document.getElementById('addtoSavedAddresses');
            if (addtoSavedAddressesElement) {
                addtoSavedAddressesElement.focus();
            }
        }, 200);
    }

    /**
     * @description save billing address
     * @param {Address} address
     * @memberof OrderCreateFPCComponent
     */
    saveBillingAddress(address: Address) {
        if (address) {
            this.billingAddressInfo = this.mapVerifiedAddressToFormFields(address);
            if (this.saveEcheckFormBtn) {
                this.saveEcheckFormBtn.nativeElement.click();
            }
        }
    }

    // *************************payvision payment section*******************************/

    /**
     * On change of card
     */
    selectSavedCard(cardDetails: any, isNewCard?: boolean) {
        // if(isNewCard && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference===this.deliveryPreference.DROPSHIP && !this.isnewcardAdded){
        //     this.messageService.setSubmitPudoPickupPersonAddress(true);

        // }else{
        this._cacheService.set(CacheKey.IsRefreshed, true);
        this.addNewCardClicked = false;
        this.mapBillingAddress();
        this.mapShippingAddress()
        if (isNewCard) {
            if (this.shippingAddressChanged) {
                this.showVerifyAddressMessage();
                return;
            }
            this._enrollmentMessageService.setSubmitPersonalInfoForm(true);
            this.addOrderInfoToSession();
            // if (this.isWorldpayPayment || this.isWorldPayEnabledCountry) {
                if (this.isWorldpayPayment){
                this.showWorldpayXml = true;
                this.showWorldPayXMLPopup.open();
            } else if (this.isAdyenPayment) {
                this.showAdyenPayment = true;
                this.showAdyenPaymentPopup.open();
            } else if (this.isNIPayment) {
                this.showNIPayment = true;
                this.showNIPopup.open();
            } else if (this.isNexioPayment) {
                this.showNexioPayment = true;
                this.showNexioPopup.open();
            } else {
                this.addNewPayvisionCard = true;
                this.payvisionPayment.open();
            }
        } else {
            this.selectedPayvisionCardInfo = cardDetails;
            this.addNewPayvisionCard = false;
            this.showWorldpayXml = false;
            this.showNIPayment = false;
            this.showAdyenPayment = false;
        }
    
    }

    showVerifyAddressMessage(): void {
        const verifyAddressError: any = this._translatePipe.get('order.Shipping Address must be verified. Please click on VERIFY ADDRESS');
        this._commonService.createNotification('', verifyAddressError.value, NotificationType.ERROR);
    }

    addOrderInfoToSession() {
        sessionStorage.removeItem(CacheKey.OrderInfo);
        const formValues = this.orderFormGroup.value;
        const OrderInfo = {
            storeInfo: this.storeInfo,
            products: this.products,
            countryId: formValues.countryId,
            deliveryPreference: formValues.deliveryPreference,
            memberInfo: formValues.memberInfo,
            orderType: formValues.orderType,
            paymentSelector: formValues.paymentSelector,
            shippingAddressId: this.shippingAddressInfo && this.shippingAddressInfo.id ? this.shippingAddressInfo.id : 0,
            shippingAddressInfo: this.shippingAddressInfo,
            shipMethodId: formValues.shipMethodId,
            shippingCost: formValues.shippingCost,
            shippingCostPercentage: formValues.shippingCostPercentage,
            shippingCostSelector: formValues.shippingCostSelector,
            verifiedShippingAddressId: this.verifiedShippingAddressId,
            shippingCostValue: this.shippingCost,
            orderFromLookup: this.orderFromLookup,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
            isSavedAddress: this.address ? this.address.isSavedAddress : null,
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            memberCartSessionGuid: this.memberCart
                && this.memberCart.sessionGuid ? this.memberCart.sessionGuid :
                this.memberCartSessionGuid ? this.memberCartSessionGuid : null,
            personalInformation: this.personalInformation,
            returningFPCUser: this.returningFPCUser,
            documents: this.agreementDocuments,
            language: this.orderFormGroup.value.language,
            mailingAddress: this.mailingAddress,
            rebindSponsorData: this.rebindSponsorData,
            sponsorInformation: this.sponsorInformation,
            memberCommunicationPreferences: this.memberCommunicationPreferences,
            liveFormAddress: this.liveFormAddress,
            mailAlreadyExist: this.mailAlreadyExist,
            isShippingDiscountApplied: this.orderFormGroup.value.isShippingDiscountApplied,
            minMaxPriceValidation: this.minMaxPriceValidation,
            participatingCountry: this.participatingCountry ? this.participatingCountry : null,
            accountVerified: this.accountVerified,
            selectPudoCollectionPoint:this.selectedPudoCollectionPoint?this.selectedPudoCollectionPoint:null,
            buildPudoLocationSearchForm:this.pudoLocationSearchForm.value,
            pudoShippingMethod:this.pudoShippingMethod?this.pudoShippingMethod:null,
            pudoaddress:this.pudoAddress?this.pudoAddress:null,
            languageCulture: this.languageCulture,
            isOverrideMinimumLimit:this.isOverrideMinimumLimit,
            bonusInformation: this.bonusInformation ? this.bonusInformation : null,
            bonusInfoDocuments: this.bonusInfoAgreements ? this.bonusInfoAgreements :  null,
            bonusPaymentOptionType: this.bonusPaymentOptionType ? this.bonusPaymentOptionType : null,
            bonusPaymentOption: this.bonusPaymentOption ? this.bonusPaymentOption :  null,
            pcSponsorEligible: this.pcSponsorEligible,
            pudoShippingAddressInfo: this.pudoShippingAddressInfo && this.shippingAddressInfoConfig.dropShipLocationsEnabled ? this.pudoShippingAddressInfo : null
        };
        sessionStorage.setItem(CacheKey.OrderInfo, JSON.stringify(OrderInfo));
    }
    /**
     *load procducts from session
     */
    loadproductsFromSession() {
        this.orderSession.products.forEach((product: any) => {
            this.addItemNumber();
            const items: any = this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                const index = (items.length - 1);
                if (product) {
                    const itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    const itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
                    const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    const isDepositFeeProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1');
                    const depositFeeEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['quantity'].setValue(product.quantity);
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                    if (product.promoProduct) {
                        items.controls[index].controls['disableIncrement'].setValue(true);
                        items.controls[index].controls['disableDecrement'].setValue(true);
                        items.controls[index].controls['disableDelete'].setValue(true);
                    } else {
                        items.controls[index].controls['disableIncrement'].setValue(false);
                        items.controls[index].controls['disableDelete'].setValue(false);
                        if (product.quantity == 1) {
                            items.controls[index].controls['disableDecrement'].setValue(true);
                        } else {
                            items.controls[index].controls['disableDecrement'].setValue(false);
                        }
                    }
                    if(depositFeeEnabled) {
                        this.getDepositFeeProduct(product, true);
                    }
                }
            }
        });
        this.updateTotalsAndShipMethod();
    }

    /**
     * on close of payvision form popup
     */
    onPayvisionFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.addNewPayvisionCard = false;
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.payvisionPayment.close();
        this.paymentComponentSettings.payvisionFormLoaded = false;
        // To remove payvision Configurations
        this._commonService.unloadPayvisionWidget();
    }

    /**
    * @returns any
    */
    private getOrderPaymentInfo(): any[] {
        const orderPaymentObject = {
            orderFormGroup: this.orderFormGroup,
            savePaymentMethod: this.savePaymentMethod,
            products: this.products,
            memberInfo: this.memberInfo,
            countryTaxInclusive: this.countryTaxInclusive,
            storeInfo: this.storeInfo,
            checkoutConfig: this.checkoutConfig,
            importFeeValue: this.importFeeValue,
            shippingCost: this.shippingCost,
            shippingTax: (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) ? 0 : this.shippingTax,
            taxableAmount: this.taxableAmount,
            selectedPayvisionCardInfo: this.selectedPayvisionCardInfo,
            echeckRequest: this.getAchInfo(),
            eCheckTokenRes: this.eCheckTokenRes,
            isVATRegistered: false,
            isEnableVATCalculation: false,
            authorizationCode:this.paymentComponentSettings && this.paymentComponentSettings.authorizationCode ? this.paymentComponentSettings.authorizationCode : null

        };
        return this._enrollmentCommonService.getOrderPaymentInfo(orderPaymentObject);
    }

    /**
     * prevent +, -, e entering in shipping cost
     */
    keyEventShippingCost(event: any) {
        if (event.keyCode === 43 || event.keyCode === 45 || event.keyCode === 101) {
            event.preventDefault();
        }
    }

    /**
     * Get ECheck payment
     */
    getSavedEchecks(): void {
        if (this.memberInfo.memberId) {
            this._echeckService.getSavedEchecks(this.memberInfo.memberId, this.selectedIsoCountryCode, this.eCheckTokenRes)
                .subscribe((response: PersonalCheck[]) => {
                    if (response && response.length > 0) {
                        this.paymentComponentSettings.savedEChecks = response;
                        if (this.echeckRequest && this.echeckRequest.reusable) {
                            const selectedCard = this.paymentComponentSettings.savedEChecks.find(x => x.id === this.echeckRequest.id);
                            if (selectedCard) {
                                const indexPostion = this.paymentComponentSettings.savedEChecks
                                    .findIndex(x => x.id === this.echeckRequest.id);
                                this.paymentComponentSettings.savedEChecks.splice(indexPostion, 1);
                                this.paymentComponentSettings.savedEChecks.unshift(selectedCard);
                                this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.echeckRequest.id);
                            } else {
                                const index = this.paymentComponentSettings.savedEChecks.length - 1;
                                this.orderFormGroup.controls['paymentInstrumentId']
                                    .setValue(this.paymentComponentSettings.savedEChecks[index].id);
                            }
                        }

                    } else {
                        this.paymentComponentSettings.savedEChecks = [];
                        this.savedEChecks = '';
                    }
                    this.savedEChecks = JSON.stringify(this.paymentComponentSettings.savedEChecks);
                });
        }
    }

    validatePaymentForm(){
        if((this.emailForm.controls['payByLinkEmail'].value !== '' ) || (this.products.length===0 && (this.hasMinimumOverrideLimit || (this.userInfo && this.userInfo.hasSystemRole===true)))){
            this.isPayByLinkValid = true;
        } else{
            this.isPayByLinkValid = false;
        }
    }
    /**
     * on change of payment method
     */
    onPaymentMethodChnage() {

        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.selectedPayvisionCardInfo = null;
        this.echeckRequest = null;
        const options: any[] = [this.paymentTypeEnum.Money_order, this.paymentTypeEnum.Bank_Transfer,this.paymentTypeEnum.Wire_Transfer,
        this.paymentTypeEnum.Cash_On_Delivery, this.paymentTypeEnum.Orange_Money, this.paymentTypeEnum.BanContact_MisterCash_and_Maestro, this.paymentTypeEnum.MisterCash_and_Maestro, this.paymentTypeEnum.Pay_By_Link];
        const paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
        if (options.some(x => x == paymentSelectorValue)) {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([]);
        } else {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
        }
        if(paymentSelectorValue === this.paymentTypeEnum.Pay_By_Link) {
            const email = this.liveFormPersonalInfo && this.liveFormPersonalInfo.email ? this.liveFormPersonalInfo.email : null;
            if(email != null) {
                this.emailForm.controls['payByLinkEmail'].setValue(email);
            } else {
                this.emailForm.controls['payByLinkEmail'].setValue('');
            }
            this.emailForm.controls['payByLinkEmail'].updateValueAndValidity();
            if((this.emailForm.controls['payByLinkEmail'].value !== '' ) || (this.products.length===0 && (this.hasMinimumOverrideLimit || (this.userInfo && this.userInfo.hasSystemRole===true)))){
                this.isPayByLinkValid = true;
            } else {
                this.isPayByLinkValid = false;
            }
        } else {
            this.isPayByLinkValid = true;
        }

        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if(this.appConfig.enablePaymentReferenceNumber){
            this.paymentReferenceNumber.reset();
            this.paymentReferenceNumberFormValidations();
        }
    }
    /**
     * on change of Echeck
     */
    selectECheck(echeckDetails: PersonalCheck, isNewEcheck: boolean) {
        if (isNewEcheck) {
            this.buildEcheckForm();
            this.echeckSubmitted = false;
            this.eCheckValidationMessages = [];
            this.eCheckPaymentPopup.open();
            this.addNeweCheck = true;
        } else {
            this.selectedECheckInfo = echeckDetails;
            this.billingAddressInfo = echeckDetails.billingAddress;
            this.addNeweCheck = false;
            this.echeckRequest = {
                portalCsp: true,
                id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
                portalType: EcheckPortalTypes.CustomerCare,
                accountNumber: this.selectedECheckInfo.accountNumber,
                routingNumber: this.selectedECheckInfo.routingNumber,
                bankName: this.selectedECheckInfo.bankName,
                accountType: this.selectedECheckInfo.accountType,
                nameOnBankAccount: this.selectedECheckInfo.nameOnBankAccount,
                reusable: this.selectedECheckInfo.reusable,
                defaultECheck: this.selectedECheckInfo.defaultECheck,
                customerId: this.memberInfo.memberId,
                billingAddress: this.getBillingAddressForECheck(),
                billingAddressId: null,
                billingAddressRequired: true,
                customMessage: '',
                storeId: this.storeInfo.id,
                email: this.selectedECheckInfo.email,
                phone: this.selectedECheckInfo.phone
            };
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    }
    /**
     * when Echeck form is closed
     */
    onECheckFormClose() {
        this.eCheckPaymentPopup.close();
        this.addNeweCheck = false;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedEcheckDdl && this.savedEcheckDdl.nativeElement) {
            this.savedEcheckDdl.nativeElement.focus();
        }
    }
    /**
     * buildEcheckForm
     */
    buildEcheckForm() {
        let phone = '';
        let email = '';

        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            } else {
                phone = this.memberInfo.phone;
            }
        }
        this.echeckForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            accountType: ['', [Validators.required]],
            bankName: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            nameOnBankAccount: ['', [Validators.required, CustomValidators.requiredNotEmpty, Utils.alphaNumericCharacterValidation, Validators.maxLength(25)]],
            reuse: [false],
            billingAddressId: [''],
            customMessage: [''],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]]
        });
    }

    validateNewECheck() {
        this.echeckSubmitted = true;
        if (this.echeckForm.valid) {
            const echeckFormValue = this._commonService.trimObjectValues(this.echeckForm.value);
            if (echeckFormValue.phone) {
                const phoneCode = PhoneCodesConstants.phoneCodes.find(x => echeckFormValue.phone.toUpperCase().indexOf(x.name) > -1);
                if (phoneCode) {
                    echeckFormValue.phone = echeckFormValue.phone;
                } else {
                    if (this.phoneNumberFormat) {
                        echeckFormValue.phone = this._maskPipe.transform(echeckFormValue.phone, this.phoneNumberFormat);
                    }else{
                        echeckFormValue.phone = echeckFormValue.phone;
                    }
                }
            }
            const validateECheckReq: ValidateEcheckRequest = {
                accountNumber: echeckFormValue.accountNumber,
                accountType: echeckFormValue.accountType,
                bankName: echeckFormValue.bankName,
                routingNumber: echeckFormValue.routerNumber,
                addressOne: this.billingAddressInfo.addressLine1,
                addressTwo: this.billingAddressInfo.addressLine2,
                city: this.billingAddressInfo.city,
                country: this.paymentComponentSettings.isoTwoletterCountryCode,
                state: this.billingAddressInfo.stateCode,
                zip: this.billingAddressInfo.postalCode,
                email: echeckFormValue.email,
                phone: echeckFormValue.phone,
                paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.eCheck
            };
            this.validateECheck(validateECheckReq);
        }
    }

    validateECheck(validateECheckReq: ValidateEcheckRequest) {
        this.eCheckValidationMessages = [];
        this._echeckService.validateEcheck(validateECheckReq)
            .subscribe((response: ValidateEcheckResponse) => {
                if (response && response.success) {
                    this.savePersonalEcheck(validateECheckReq);
                } else if (response && !response.success && response.validations.length > 0) {
                    this.eCheckValidationMessages = response.validations.map(validation => validation.message);
                } else {
                    this.eCheckValidationMessages.push('Echeck validation failed.');
                }
            }, error => {
                this.eCheckValidationMessages.push('Echeck validation failed.');
            });
    }
    /**
     * save personal echecks
     */
    savePersonalEcheck(eCheckInfo: ValidateEcheckRequest) {
        this.echeckRequest = {
            portalCsp: true,
            id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
            portalType: EcheckPortalTypes.CustomerCare,
            accountNumber: eCheckInfo.accountNumber,
            routingNumber: eCheckInfo.routingNumber,
            bankName: eCheckInfo.bankName,
            accountType: eCheckInfo.accountType,
            nameOnBankAccount: this.addNeweCheck ? eCheckInfo.name : this.selectedECheckInfo.nameOnBankAccount,
            reusable: this.addNeweCheck ? this.echeckForm.value.reuse : this.selectedECheckInfo.reusable,
            defaultECheck: this.addNeweCheck ? false : this.selectedECheckInfo.defaultECheck,
            customerId: this.memberInfo.memberId,
            billingAddress: this.getBillingAddressForECheck(),
            billingAddressId: null,
            billingAddressRequired: true,
            customMessage: '',
            storeId: this.storeInfo.id,
            email: eCheckInfo.email,
            phone: eCheckInfo.phone
        };
        this._echeckService.savePersonalCheck(this.memberInfo.memberId, this.echeckRequest)
            .subscribe((response: any) => {
                if (response) {
                    this.eCheckTokenRes = response;
                    this.echeckSubmitted = false;
                    if (this.addNeweCheck) {
                        this.eCheckPaymentPopup.close();
                        const savedEChecks = JSON.parse(this.savedEChecks);
                        this.paymentComponentSettings.savedEChecks = savedEChecks;
                        if (this.echeckRequest) {
                            this.echeckRequest.id = +(atob(this.eCheckTokenRes));
                        }
                        if (this.echeckRequest && this.echeckRequest.reusable) {
                            this.orderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(this.eCheckTokenRes)));
                            this.getSavedEchecks();
                        } else {
                            this.orderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(this.eCheckTokenRes)));
                        }
                    }
                    if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                        this.paymentFormBtn.nativeElement.focus();
                    }
                } else {
                    this.eCheckValidationMessages.push('Echeck validation failed.');
                }
            }, (error: any) => {
                this.eCheckValidationMessages.push('Echeck validation failed.');
            });
    }

    /**
     * map billing address for e-Check
     */
    getBillingAddressForECheck() {
        const stateObj = this._enrollmentCommonService.getStateDetailsByStateIdOrCode(this.states, null, this.billingAddressInfo.state);
        const billingAddress = this._enrollmentCommonService.mapBillingAddressService(this.billingAddressInfo, stateObj);
        return billingAddress;
    }

    /**
     * @description add mask while chnaging phone number
     *
     * @memberof OrderCreateFPCComponent
     */
    onChangeEcheckPhone($event: any) {
        const value = this.echeckForm.controls['phone'].value;
        let updatedValue = value;
        const alphaNumericValue = value.replace(/[^a-z0-9]/gi, '');
        if (value.match(/[a-zA-Z]/)) {
            if (alphaNumericValue.substr(0, 3).match(/[a-zA-Z]/)) {
                updatedValue = value.replace(/[^a-z0-9]/gi, '');
            } else if (alphaNumericValue.substr(3, 3).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) AAAAAAA');
            } else if (alphaNumericValue.substr(6, 4).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) 000-AAAA');
            }
        } else {
            if (alphaNumericValue.length !== 3) {
                if (this.phoneNumberFormat) {
                    updatedValue = this._maskPipe.transform(value, this.phoneNumberFormat);
                } else {
                    updatedValue = value;
                }
            }
        }
        this.echeckForm.controls['phone'].setValue(updatedValue);
    }

    onWorldpayXMLFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showWorldpayXml = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showWorldPayXMLPopup.close();
    }

    onAdyenPaymentFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showAdyenPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showAdyenPaymentPopup.close();
    }

    onNIFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNIPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNIPopup.close();
    }

    onNexioFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNexioPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNexioPopup.close();
    }


    /**
     * clear form
     */
    clearOrderForm(isClearRetailForm?: boolean) {
        this.clearAllTheForms(true, true, true);
        this.clearFPCForm();
        const countryElement = document.getElementById('country');
        if (countryElement) {
            countryElement.focus();
        }
        this.selectedCountry();
    }

    /**
     * To clear fpc form when clicking on cancel
     */
    clearFPCForm(): void {
        this.liveFormPersonalInfo = null;
        this.paymentComponentSettings.savedCards = [];
        this.address = null;
        this.liveFormAddress = null;
        this.mailingAddress = null;
        this.bonusInformation = null;
        this.bonusInfoAgreements = [];
        this.storeInfo = null;
        this._enrollmentMessageService.setStoreInfo(this.storeInfo);
        this.orderSession = null;
        this.savePaymentMethod = false;
        this.orderFormGroup.controls['isContactSponsor'].setValue(null);
        this.memberCommunicationPreferences.email = false;
        this.checkContactSponsor();
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        this.orderTypeChange(this.orderFormGroup.value.orderType);
    }

    /**
     * get restricted products
     */
    getRestrictedProducts(productModels: RestrictedProduct[]) {
        this.getShippingRestrictionError();
        this.restrictedProducts = [];
        productModels.forEach((product: RestrictedProduct) => {
            const itemNumber = product.itemNumber.substring(product.itemNumber.indexOf('#') + 1);
            const item = this.products.find((productItem: any) => productItem.itemNumber === itemNumber);
            if (item) {
                this.restrictedProducts.push(item.name + ' - #' + itemNumber);
            }
        });
        this.showRestrictedProducts.open();
    }

    /**
         * @description To Show Shipping Restriction Error message
         * @private
         * @returns {string}
         * @memberof OrderCreateFPCComponent
         */
    private getShippingRestrictionError(): string {
        if (this.shippingAddressInfo
            && this.shippingAddressInfo.stateCode && this.shippingAddressInfo.countryId && this.states && this.states.length > 0) {
            const stateName: string = this.states.find(x => x.stateCode === this.shippingAddressInfo.stateCode).stateName;
            const error: any = this._translatePipe.get('order.' + Translations.SHIPPING_RESTRICTION_ERROR, { stateName: stateName });
            this.productErrorMsg = error.value;
        } else {
            const error: any = this._translatePipe.get('order.Following products are not allowed for selected shipping address.');
            this.productErrorMsg = error.value;
        }
        return this.productErrorMsg;
    }

    // getPaymentMethod by Store
    getPaymentMethodsByStore(memberTypeId?: number) {
        let fpc5PercentEnabled = false;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this.credit_Card_show = this.money_Order_show = this.cash_on_delivery_show = this.orange_money_show = this.ach_show = this.wire_Transfer_show
            = this.bank_transfer_show = this.echeck_show = this.banContact_misterCash_and_maestro_show
            = this.misterCash_and_maestro_show = this.pay_by_link_show = false;
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode,
            this.storeDefaultLanguage ? this.storeDefaultLanguage : this.languageCode,
            null, false, fpc5PercentEnabled, true).subscribe(response => {
                if (response) {
                    if (response.find(x => x.paymentMethodName === PaymentMethodTypes.Credit_Card && x.paymentProcessor === PaymentProcessorAlias.ADYEN)) {
                        this._commonService.getPaymentMethodsSourceConfiguration().subscribe(
                            (paymentMethodSourceConfigurations: PaymentMethodSourceConfiguration[]) => {
                                if (paymentMethodSourceConfigurations && paymentMethodSourceConfigurations.length > 0 && response && response.length > 0) {
                                    const paymentmethodsConfig = paymentMethodSourceConfigurations.find((paymentMethodSourceConfiguration: PaymentMethodSourceConfiguration) => paymentMethodSourceConfiguration && paymentMethodSourceConfiguration.country == this.selectedIsoCountryCode);
                                    if (paymentmethodsConfig) {
                                        response = this._commonService.filterPaymentMethods(paymentmethodsConfig, response, this.orderFormGroup.value.orderType);
                                    }
                                }
                                this.updatePaymentMethodsDisplayStatus(response);
                            },
                            (error) => {
                                this.updatePaymentMethodsDisplayStatus(response);
                            });
                    } else {
                        this.updatePaymentMethodsDisplayStatus(response);
                    }
                }
            });
    }

    updatePaymentMethodsDisplayStatus(response) {
                    this.storePaymentInfo = response;
                    this.initializePaymentMethods();
                    this.storePaymentInfo.forEach(
                        paymentMethod => {
                            if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                                this.credit_Card_show = true;
                                if(paymentMethod.paymentProcessor === PaymentProcessorAlias.NEXIO){
                                    this.isNexioPayment = true;
                                }
                                else if(paymentMethod.paymentProcessor === PaymentProcessorAlias.ADYEN){
                                    this.isAdyenPayment = true;
                                }else if(paymentMethod.paymentProcessor === PaymentProcessorAlias.NI){
                                    this.isNIPayment = true;
                                }
                                else if(paymentMethod.paymentProcessor === PaymentProcessorAlias.WPAYXML){
                                    this.isWorldpayPayment = true;
                                }
                            } else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                                this.displayStatementForWavePayment = this.appConfig.displayStatementForWavePayment;
                                if(this.displayStatementForWavePayment){
                                    this.money_Order_show = true;
                                    this.displayStatementForWavePayment = this.appConfig.displayStatementForWavePayment;
                                }else{
                                    this.money_Order_show = true;
                                    this.getBankDetailsByCountry(this.countryCode,PaymentModeConstants.Money_Order);
                                }
                                
                            }
                            // else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                            //     this.echeck_show = true;
                            // }
                            else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                                this.bank_transfer_show = true;
                                this.getBankDetailsByCountry(this.countryCode);
                            } else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                                this.cash_on_delivery_show = true;
                            }
                            else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                                this.orange_money_show = true;
                            }
                            else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                                this.ach_show = true;
                           } else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                                this.pay_by_link_show = true;
                            }
                            else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                                this.wire_Transfer_show = true;
                                this.getBankDetailsByCountry(this.countryCode,PaymentModeConstants.Wire_Transfer);
                            }
                        });
                    const option = this.credit_Card_show ? this.paymentTypeEnum.Credit_Card : this.echeck_show
                        ? this.paymentTypeEnum.eCheck : this.money_Order_show ? this.paymentTypeEnum.Money_order
                            : this.bank_transfer_show ? this.paymentTypeEnum.Bank_Transfer : this.cash_on_delivery_show ? this.paymentTypeEnum.Cash_On_Delivery :
                                this.ach_show ? this.paymentTypeEnum.eCheck : this.banContact_misterCash_and_maestro_show ? this.paymentTypeEnum.BanContact_MisterCash_and_Maestro
                        : this.misterCash_and_maestro_show ? this.paymentTypeEnum.MisterCash_and_Maestro : this.pay_by_link_show ? this.paymentTypeEnum.Pay_By_Link : this.wire_Transfer_show ? this.paymentTypeEnum.Wire_Transfer : this.orange_money_show ? this.paymentTypeEnum.Orange_Money : null;
                    if (option) {
                        this.setPaymentMethod(option);
                    }
                    this.savePaymentMethod = this.orderSession && this.orderSession.savePaymentMethod ?
                        this.orderSession.savePaymentMethod : false;
                }
                initializePaymentMethods(){
                    this.isWorldpayPayment = false;
                    this.isAdyenPayment = false;
                    this.isNIPayment = false;
                    this.isNexioPayment = false;
                }
    setPaymentMethod = (value) => {
        this.orderFormGroup.controls['paymentSelector'].setValue(value.toString());
        this.onPaymentMethodChnage();
    }

    /**
   * @description get Order Min Max Business Rules
   * @memberof OrderCreateFPCComponent
   */
    getOrderRules(): void {
        const orderRulesRequest: OrderRulesRequest = {
            countryCode: this.selectedIsoCountryCode,
            memberTitleId: this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value),
            orderType: MemberOrderType.Enrollment
        };
        this.getBusinessOrderRules(orderRulesRequest);
    }

    getBusinessOrderRules(orderRulesRequest, userInfo?: Member, isFboUpgradeFlow?: boolean): void {
        this._orderService.getOrderBusinessRules(orderRulesRequest)
            .subscribe((response: any) => {
                if (response) {
                    this.orderRules = response;
                }
            }, error => {
            });

    }

    /**
     * @description savePayment methos
     * @memberof OrderCreateFPCComponent
     */
    savePaymentMethodClicked(savePaymentMethod: boolean): void {
        this.savePaymentMethod = !savePaymentMethod;
    }

    savedCardInfo(savedcardDetails: any) {
       this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        if (savedcardDetails) {
            this.paymentComponentSettings.savedCards.unshift(savedcardDetails);
            this.showNexioPopup.close();
            this.showNexioPayment = false;
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length) {
                const savedCard = this.paymentComponentSettings.savedCards[0];
                if (savedCard && savedCard.id === savedcardDetails.id) {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(savedCard.id);
                }  else {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedCards[0].id);
                }
                this.selectedPayvisionCardInfo = savedcardDetails;
            }
        }
    }

    /**
     * @description get Terms and Conditions Document
     * fetchTermsConditionDocument
     * @memberof OrderCreateFPCComponent
     */
    fetchTermsConditionDocument(agreementDocuments: DocumentLibrary[]): void {
        this.agreementDocuments = agreementDocuments;
        const unselectedAgreements = this.agreementDocuments.filter(agreement => !agreement.isSelected);
        if (unselectedAgreements && unselectedAgreements.length > 0) {
            this.agreementCheckError = true;
        } else {
            this.agreementCheckError = false;
        }
    }

    /**
     * @description
     * @private
     * @memberof OrderCreateFPCComponent
     */
    private getParticipatingCountries(id: number): void {
        this.hasParticipatingCountries = false;
        this.orderFormGroup.controls['participatingCountry'].setValue('');
        this.associatedCountries = [];
        this._customerService.getStoreParticipatingCountries(id)
            .subscribe(response => {
                if (response && response.length > 0) {
                    this.participatingCountries = response;
                    if (this.appConfig && this.appConfig.displayParticipatingCountry) {
                        this.associatedCountries = response.filter(country => country.titanPlatformEnabled
                            && country.enrollmentEnabled && country.legacyEnabled);
                        if (this.associatedCountries && this.associatedCountries.length > 0) {
                            this.hasParticipatingCountries = true;
                            if (this.participatingCountry) {
                                this.orderFormGroup.controls['participatingCountry'].setValue(this.participatingCountry.countryId);
                            } else {
                                const countryObj = this.associatedCountries.find((x: Country) => x.countryId === +this.orderFormGroup.value.countryId);
                                if (countryObj) {
                                    this.participatingCountry = countryObj;
                                    this.isParticipatingCountrySameAsStore = true;
                                    this.associatedCountry = this.participatingCountry.countryId;
                                    this.orderFormGroup.controls['participatingCountry'].setValue(this.participatingCountry.countryId);
                                } else {
                                    this.orderFormGroup.controls['participatingCountry'].setValue('');
                                }
                            }
                        }
                    }
                }
            });
    }

    /**
    *
    * @param items
    */
    getItemVolumeSum(items): number {
        return this._enrollmentCommonService.getItemVolumeSum(items);
    }
    trackByItem(index: number): number {
        return index;
    }

    /**
    * @description this method used for allow user to enter address fields
    * @memberof OrderCreateFPCComponent
    */
    enableAddressFields(block: string): void {
        const addressFieldInfo: AddressVisibility = {
            isEnableAddressFields: true,
            block: block
        };
        this.messageService.setEnableAddressFields(addressFieldInfo);
    }

    loadPreferences(response: StoreConfig): void {
        const memberTypeId = this._enrollmentCommonService.getMemberTypeId(this.orderFormGroup.controls['orderType'].value);
        let preferenceConfig: any;
        preferenceConfig = response && response.storePreferenceModels ? response.storePreferenceModels.find(config =>
            config.memberTypeId === memberTypeId) : null;
        if (preferenceConfig) {
            if (preferenceConfig.value === Constants.YES || preferenceConfig.value === Constants.DEFAULT) {
                this.orderFormGroup.controls['isContactSponsor'].setValue(true);
                this.checkContactSponsor();
            } else if (preferenceConfig.value === Constants.NO) {
                this.orderFormGroup.controls['isContactSponsor'].setValue(false);
                this.checkContactSponsor();
            }
        }
    }

    /**
    *
    * @param items
    */
    getItemTotalSum(item): number {
        return this._enrollmentCommonService.calculateSubTotal(this.storeInfo,
            this.countryTaxInclusive, item, this.checkoutConfig, this.appConfig);
    }

    /**
      * Get Total CartItems Cost.
      */
    calculateSubTotal(store: StoreConfig, taxInclusiveShippingCountry: boolean, item: any): number {
        let subTotal = 0;
        if (item) {
            const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            subTotal += this._enrollmentCommonService.calculateItemSubtotal(item, store, taxInclusiveShippingCountry,
                isCalculateTaxExclusivePrice);
        }
        if (store) {
            // tslint:disable-next-line:no-bitwise
            subTotal = Number(subTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return subTotal;
    }

    /**
     * Get Total CartItems Cost.
     */
    calculateItemsSubTotal(store: StoreConfig): number {
        let itemsSubTotal = 0;
        const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
        for (let i = 0; i < this.products.length; i++) {
            itemsSubTotal += this._enrollmentCommonService.calculateItemSubtotal(this.products[i], store,
                this.countryTaxInclusive, isCalculateTaxExclusivePrice, this.appConfig);
        }

        if (store) {
            // tslint:disable-next-line:no-bitwise
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
            this.itemSubTotal = itemsSubTotal;
        }
        return itemsSubTotal;
    }

    /**
    * @description this method will calculate shipping cost that has to be used for calculating order summary
    * @memberof OrderCreateFPCComponent
    */
    getShippingCostForOrderSummary(): number {
        this.itemShippingCost =  this._enrollmentCommonService.getShippingCostForOrderSummary(this.shippingCost, this.shippingTax,
            this.orderFormGroup, false, false, (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice), this.appConfig, false);
            return this.itemShippingCost;
    }

    getSubmitButtonStatus() {
        return (!this.agreementCheckError && !this.mailAlreadyExist && ((!this.taxCalculationStatus && (this.orderFormGroup.valid)) 
        || (!this.products || this.products.length === 0))
        && !this.isSubmitted && this.isPayByLinkValid && (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP?((this.selectedPudoCollectionPoint)?true:false):true) && this.personalInfoFormValid && (this.paymentReferenceNumber && this.paymentReferenceNumber.valid) && ((this.sponsorInformation && this.mailingAddress) ? null : ''));

    }

    sendPasswordResetLink(fpcCreateResponse: EnrollInfo) {
        if (fpcCreateResponse.personalInfo.fboId) {
            this.signUpEmail = fpcCreateResponse.personalInfo.fboId;
            this._enrollService.sendPasswordResetEmail(this.signUpEmail, this.countryCode,
                this.orderFormGroup.controls['language'].value).subscribe(
                    (successResponse: any) => {
                    });
        }
    }

    getMemberTitleId() {
        return this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value);
    }

    /**
     * @description this method used for to prepoluate delais from personal info
     * @memberof OrderCreateFPCComponent
     */
    prePopulateDetails() {
        if (this.liveFormPersonalInfo) {
            const address: any = {
                firstName: this.liveFormPersonalInfo.firstName,
                lastName: this.liveFormPersonalInfo.lastName,
                middleName: this.liveFormPersonalInfo.middleName,
                phoneNumber: this.liveFormPersonalInfo.phoneNumber || this.liveFormPersonalInfo.phone,
                phoneType: this.liveFormPersonalInfo.phoneType,
                email: this.liveFormPersonalInfo.email ? this.liveFormPersonalInfo.email : null,
                countryId: this.orderFormGroup.value.countryId
            };
            this.address = address;
        }
        this.showAddressForm = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
            + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;
        }
        /*this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;*/
        setTimeout(() => {
            this.showAddressForm = true;
        }, 500);
    }

    buildAchForm() {
        let phone = '';
        let email = '';
        let checkNumber = "";
        const phoneNUmberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (phoneNUmberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, phoneNUmberFormat);
            } else {
                phone = this.memberInfo.phone;
            }
        }
        this.paymentAchForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            //  accountType: ['', [Validators.required]],
            dlNumber: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            dlState: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            secType: ['', [Validators.required, CustomValidator.checkIfAccountSelected()],
            ],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]],
            checkNumber: [checkNumber, [Validators.required, CustomValidators.requiredNotEmpty]],
            reuse: [false],
        });
    }
    /**
     * on change of Ach
     */
    // selectAch(achDetails: PersonalAch, isNewAch: boolean) {
    //     if (isNewAch) {
    //         this.buildAchForm();
    //         this.echeckSubmitted = false;
    //         this.eCheckValidationMessages = [];
    //         this.addNewAchCard = true;
    //         this.achPaymentPopup.open();
    //     } else {
    //         this.selectedAchInfo = achDetails;
    //         this.billingAddressInfo = achDetails.billingAddress;
    //         this.addNewAchCard = false;
    //         this.achRequest = {
    //         id:  achDetails.id,
    //         accountNumber: achDetails.accountNumber,
    //         routingNumber: achDetails.routingNumber,
    //         accountType: achDetails.accountType,
    //         secType: achDetails.secType,
    //         checkNumber: achDetails.checkNumber,
    //         //dlNumber: achDetails.dlNumber,
    //         //dlState: achDetails.dlState,
    //         portalType: EcheckPortalTypes.CustomerCare,
    //         reusable: true,
    //         defaultECheck: false,
    //         customerId: 1,
    //         billingAddress: this.getBillingAddressForECheck(),
    //         billingAddressId: null,
    //         storeId: this.paymentComponentSettings.storeId,
    //         paymentMethodType: PaymentConstants.echeck,
    //         email: achDetails.email,
    //         phone: achDetails.phone,
    //         billingAddressRequired: true,
    //         name:this.billingAddressInfo.name
    //         };
    //         if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
    //             this.paymentFormBtn.nativeElement.focus();
    //         }
    //     }
    //  }


    /**
    * @description submit ach payment information
    * @memberof ACHComponent
    */
    submitAchPaymentInformation(achPaymentInfo) {
        if (achPaymentInfo) {
            this.achPaymentInfo = achPaymentInfo;
            this.achToken = this.achPaymentInfo.personalCheckId;
            this.getSavedAchs();
            this.achPaymentPopup.close();
        }
    }
    /**
  * Get ACH payment details
  */
    getSavedAchs(): void {
        const memberId = this.getUserMemberId();
        if (this.memberInfo && this.memberInfo.memberId) {
            this._achService.getSavedEchecks(memberId, this.selectedIsoCountryCode, PaymentMethodTypeConstants.eCheck, this.achToken)
                .subscribe((response: PersonalAch[]) => {
                    if (response && response.length > 0) {
                        this.paymentComponentSettings.savedAchs = response;
                        this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedAchs[0].id);
                        if (this.achRequest && this.achRequest.reusable) {
                            const selectedCard = this.paymentComponentSettings.savedAchs.find(x => x.id === this.achRequest.id);
                            if (selectedCard) {
                                const indexPostion = this.paymentComponentSettings.savedAchs
                                    .findIndex(x => x.id === this.achRequest.id);
                                this.paymentComponentSettings.savedAchs.splice(indexPostion, 1);
                                this.paymentComponentSettings.savedAchs.unshift(selectedCard);
                            } else {
                                const index = this.paymentComponentSettings.savedAchs.length - 1;
                                this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedAchs[index].id);
                            }
                            const index = this.paymentComponentSettings.savedAchs.length - 1;
                            //this.selectAch(this.paymentComponentSettings.savedAchs[index],false);
                        }
                        else {
                            const index = this.paymentComponentSettings.savedAchs.length - 1;
                            // this.selectAch(this.paymentComponentSettings.savedAchs[index],false);
                        }
                        this.savedAch = JSON.stringify(this.paymentComponentSettings.savedAchs);
                    }

                });
        }
    }

    /**
      * map Ach Info for payment
      */
    getAchInfo() {
        this.achPaymentInfo = this.achPaymentInfo ? this.achPaymentInfo : this.selectedAchInfo;
        if (this.achPaymentInfo) {
            const paymentAchInfo = {
                bankName: this.achPaymentInfo.bankName,
                accountNumber: this.achPaymentInfo.accountNumber,
                routingNumber: this.achPaymentInfo.routingNumber,
                accountType: this.achPaymentInfo.accountType,
                mecTransactionID: '',
                nameOnBankAccount: this.achPaymentInfo.nameOnBankAccount,
                customMessage: '',
                reusable: this.achPaymentInfo.reusable,
                eCheckID: this.achPaymentInfo.id,
                email: this.achPaymentInfo.email,
                phone: this.achPaymentInfo.phone,
                secType: this.achPaymentInfo.secType,
                //dlState:this.achPaymentInfo.dlState,
                //dlNumber:this.achPaymentInfo.dlNumber,
                checkNumber: this.achPaymentInfo.checkNumber,
            };
            return paymentAchInfo;
        }
    }
    savePudoShippingAddress(address: Address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        } else if (this.pudoAddress && this.pudoAddress.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === address.countryId);
            this.countryTaxInclusive = this._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
        }
        this.pudoShippingAddressInfo = address;
        this.pudoAddress = address;
        this.pudoAddressSubmitted = true;
        // if(this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP && !this.isnewcardAdded){
        //     this.isnewcardAdded=true;
        //     this.selectSavedCard(null,true);
        // }else{
        //     this.submitEnrollment();
        // }
    }
    getUserMemberId() {
        let memberId = null;
        if (this.memberInfo && this.memberInfo.memberId) {
            memberId = this.memberInfo.memberId;
        } else
            memberId = 0

        return memberId;
    }
    onPaymentAchFormClose() {
        this.addNewAchCard = false;
        this.achPaymentPopup.close();
    }

    addNewPudoShippingAddress(): void {
        this.pudoAddress = null;
        this.showPudoPickupPersonAddressForm = true;
        setTimeout(()=>{
            this.displayPudoAddress = true;
        },100);
    }

    addNewDropshipPersonAddress():void{
        this.pudoShippingAddressInfo = null;
        this.showDropShipPersonAddressForm = true;
        setTimeout(()=>{
            this.displayDropAddress = true;
        },100);
    }


    /**
      * @description To get the list of bank details from payment service based on country
      * @date 2021-01-07
      * @param {*} countryCode
      * @memberof OrderCreateFPCComponent
      */
    getBankDetailsByCountry(countryCode: any, paymentMethod?: string) {
        this._achService.getBankDetailsByCountry(countryCode, paymentMethod).subscribe(response => {
            if (response && response.length > 0) {
                if (paymentMethod && PaymentMethodTypes.Wire_Transfer.toLowerCase() === paymentMethod.toLowerCase()) {
                    this.bankDetailsCountryList = response.filter((bankDetail) => bankDetail.paymentMode.toLowerCase() === PaymentMethodTypes.Wire_Transfer.toLowerCase());
                } else {
                    this.bankDetailsCountryList = response;
                }
            } else {
                this.bankDetailsCountryList = [];
            }
        });
    }

    /**
     * @description this method will show new address form
     * @memberof ServiceOrderComponent
     */
     addNewAddress(): void {
        if(this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled  && !this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayPudoAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewPudoShippingAddress();
        }else if(this.shippingAddressInfoConfig && (!this.shippingAddressInfoConfig.pudoLocationsEnabled && this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP){
            this.pudoAddressSubmitted = false;
            this.displayDropAddress = false;
            this.addNewDropshipPersonAddress();
        }
         else {
            this.address = null;
            this.isNewCard = true;
            this.shippingAddressInfo = null;
            this.shippingMethods = [];
            this.updateTotalsAndShipMethod();
        }
        this.clearPudoLocationSearchData();
    }
    clearPudoLocationSearchForm() {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
         this.hidePudoPickupLocationsButton = false;
        this.buildPudoLocationSearchForm();
    }
    clearPudoLocationSearchData() {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = true;
        this.buildPudoLocationSearchForm();
    }
    getAddressIsValid(isValid) {
        this.formPickupPersonAddressValid = isValid;
        this.pudoLocationsNotFound = false;
    }

    getPudoCollectPointAddress(): any {
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            let pudoaddress: any = null;
            pudoaddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
            if (this.selectedPudoCollectionPoint && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled)) {
                pudoaddress.addressLine1 = this.selectedPudoCollectionPoint.street;
                pudoaddress.addressLine2 = this.selectedPudoCollectionPoint.address2;
                pudoaddress.city = this.selectedPudoCollectionPoint.city;
                pudoaddress.addressType = AddressType.PUDO;
                pudoaddress.zip = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.postalCode = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.name = this.selectedPudoCollectionPoint.name;
                if(this.shippingAddressInfo && this.shippingAddressInfo.countryId){
                    pudoaddress.countryId = this.shippingAddressInfo.countryId;
                }
            }
        return pudoaddress;
    }
}
    

    buildPayByLinkForm() {
        this.emailForm = this._formbuilder.group({
            payByLinkEmail: ['', [Validators.required]]
        });
    }

    emailCheck() {
        if(this.emailForm.controls['payByLinkEmail'].value !== '' && this.emailForm.controls['payByLinkEmail'].valid) {
            this.isPayByLinkValid = true;
        } else {
            this.isPayByLinkValid = false;
        }
    }

    onChangeLanguage() {
        if (this.orderFormGroup.controls['language']) {
            const cultureName = this.orderFormGroup.controls['language'].value;
            const selectedLanguage = this.storeInfo.languages.find(language => language.cultureName === cultureName);
            if (selectedLanguage) {
                this.getFpcDocuments(cultureName);
                this.languageCulture = selectedLanguage.cultureName;
                this.payByLinkLanguageShortCode = selectedLanguage.languageCode;
                this.getStorePromotions(selectedLanguage.cultureId, true);
                this.orderFormGroup.get('itemSearch').setValue("");
                this.isDropShipOptionExist = false;
                this.isPickUpOptionExist = false;
            }
        }
    }
    private getPudoDropShipPersonAddress(collectionPoint?: CollectionPoint): any {
        let address: any = collectionPoint;
        let dropShipAddress;
        if(collectionPoint){
            dropShipAddress = {
                addressLine1: address.street ? collectionPoint.street : this.pudoShippingAddressInfo.addressLine1 ? this.pudoShippingAddressInfo.addressLine1 : null,
                addressLine2: address.address2,
                addressLine3: address.address3,
                city: address.city,
                state: collectionPoint.state,
                stateCode: this.pudoShippingAddressInfo ? this.pudoShippingAddressInfo.stateCode : address.stateCode ? address.stateCode : null,
                countryCode: this.selectedIsoCountryCode,
                country: collectionPoint.country || this.selectedIsoCountryCode,
                postalCode: this.pudoShippingAddressInfo ? this.pudoShippingAddressInfo.postalCode : null,
                zipCode: address.zipCode,
                countryId: this.pudoShippingAddressInfo ? this.pudoShippingAddressInfo.countryId : address.countryId ? address.countryId  :null ,
                stateId: this.pudoShippingAddressInfo.stateId ? this.pudoShippingAddressInfo.stateId : address.stateId ? address.stateId  :null ,
                externalId: address.externalId,
                name: address.name ? this.storeInfo.warehouseAddress.name : null
            }
            this.pudoAddress = dropShipAddress;
            this.messageService.setPudoPersonAddress(true)
            this.dropShipAddress = dropShipAddress;
        }
        else if (this.dropLoactionSelected) {
            return  this.dropShipAddress ;
        }else if(this.orderSession && this.orderSession.pudoaddress){
                return this.orderSession.pudoaddress; 
        }else {
            return
        }
    }
    getRecentlyviewedProducts(orderRequest:any):Promise<any>{
        const wholesaleQualified : boolean = orderRequest.wholesaleQualified;
        const optin : boolean = orderRequest.optin;
        const productIds = orderRequest.orderLineItems.map((item: Product) => item.productId);
        this.purchaseFlowType = this._commonService.getPurchaseFlowType(orderRequest.memberTitleId, orderRequest.wholesaleQualified, this.appConfig.fpc5PercentEnabled,false,orderRequest.memberTitleId);
        if(productIds && productIds.length>0){
            return  this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id,
                orderRequest.memberLevelId, this.purchaseFlowType, this.selectedIsoCountryCode,
                wholesaleQualified?true:false , optin?true:false,this.storeInfo.taxInclusive ).toPromise();
        }else{
            const notification: any = this._translatePipe.get('order.Products not added .');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
       
    }
    setPUDOSuggestedAddress() {
        this.pudoSuggestedAddressSubscription = this.messageService.getPUDOSuggestedAddress().subscribe((value) => {
            if (value) {
                this.buildPudoLocationSearchForm(value.zip, value.city, value.addressLine1);
                this.getPudoLocations();
            }
        });
    }
    ngOnDestroy() {
        if (this.pudoSuggestedAddressSubscription) {
            this.pudoSuggestedAddressSubscription.unsubscribe();
        }
        this._cacheService.remove(CacheKey.COUNTRY_CODE);
        this._cacheService.remove(CacheKey.COUNTRY_ID);
    }

    /**
     * @description To get the Payment method type based on USA country pick up location.
     * @date 2023-28-06
     * @param shippingMethod 
     */
   getPickupDetailsForUSA(shippingMethod){
    if (shippingMethod.shippingMethod == CommonConstant.LOS_ANGELES_PRODUCT_CENTER){
        this.storePaymentInfo.forEach(
            paymentMethod => {
                if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {                       
                    this.credit_Card_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                    this.money_Order_show = false;
                } else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                    this.wire_Transfer_show = false;
                } else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                    this.bank_transfer_show = false;
                } else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                    this.cash_on_delivery_show = false;
                } else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                    this.orange_money_show = false;
                } else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                    this.ach_show = false;
                } else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                    this.pay_by_link_show = false;
                }
            });
    }
    else{
        this.storePaymentInfo.forEach(
            paymentMethod => {
                if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {                       
                    this.credit_Card_show = false;
                } else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                    this.money_Order_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                    this.wire_Transfer_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                    this.bank_transfer_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                    this.cash_on_delivery_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                    this.orange_money_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                    this.ach_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                    this.pay_by_link_show = true;
                }
            });
    }
}
/**
     * @description To get the Payment method type based on USA country for delivery option.
     * @date 2023-28-06
     * @param shippingMethod 
     */
getDeliveryOptionsPayment(){
    this.storePaymentInfo.forEach(
        paymentMethod => {
            if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {                       
                this.credit_Card_show = true;
            } else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                this.money_Order_show = true;
            } else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                this.wire_Transfer_show = true;
            } else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                this.bank_transfer_show = true;
            } else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                this.cash_on_delivery_show = true;
            } else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                this.orange_money_show = true;
            } else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                this.ach_show = true;
            } else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                this.pay_by_link_show = true;
            }
        });
}


getDropShipPudoShippingMethods(shippingOptions: ShippingOptionsRequest, shippingMethods: ShippingMethod[], mappingRequired: boolean = true) {
    if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist)) {
        if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
            if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
            }
        } else {
            shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
        }
        shippingOptions.shippingTypeId = ShippingType.DELIVERY;

        this._orderService.getShipmentService(shippingOptions).subscribe((response) => {
            if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                // Testing Purpose .
                //response.shippingMethods[0].pudoEnabled = true;
                this.dropshipPudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled);
                if (mappingRequired) {
                    if (this.dropshipPudoShippingMethod) {
                        this.dropshipPudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                    }
                }
            }
        }, (error) => {
        });
    }
}

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/order-promotion-fpc.component.ts